export const cities = [
    {
        "id": 1452,
        "name": "New York",
        "stateCode": "NY",
        "iso3166_2": "US-NY",
        "native": "New York",
        "latitude": "40.71277530",
        "longitude": "-74.00597280",
        "type": "state",
        "timezone": "America\/New_York",
        "cities": [
            {
                "id": 111014,
                "name": "Adams",
                "latitude": "43.80923000",
                "longitude": "-76.02409000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111016,
                "name": "Adams Center",
                "latitude": "43.86006000",
                "longitude": "-76.00548000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111037,
                "name": "Addison",
                "latitude": "42.10285000",
                "longitude": "-77.23359000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111071,
                "name": "Airmont",
                "latitude": "41.10093000",
                "longitude": "-74.11625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111078,
                "name": "Akron",
                "latitude": "43.02089000",
                "longitude": "-78.49530000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111082,
                "name": "Alabama",
                "latitude": "43.09645000",
                "longitude": "-78.39086000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111108,
                "name": "Albany",
                "latitude": "42.65258000",
                "longitude": "-73.75623000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111112,
                "name": "Albany County",
                "latitude": "42.60018000",
                "longitude": "-73.97356000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111119,
                "name": "Albertson",
                "latitude": "40.77343000",
                "longitude": "-73.64318000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111128,
                "name": "Albion",
                "latitude": "43.24645000",
                "longitude": "-78.19363000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111136,
                "name": "Alden",
                "latitude": "42.90006000",
                "longitude": "-78.49197000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111157,
                "name": "Alexandria Bay",
                "latitude": "44.33588000",
                "longitude": "-75.91773000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111160,
                "name": "Alfred",
                "latitude": "42.25424000",
                "longitude": "-77.79055000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111180,
                "name": "Allegany",
                "latitude": "42.09006000",
                "longitude": "-78.49419000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111182,
                "name": "Allegany County",
                "latitude": "42.25739000",
                "longitude": "-78.02756000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111235,
                "name": "Altamont",
                "latitude": "42.70063000",
                "longitude": "-74.03374000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111262,
                "name": "Amagansett",
                "latitude": "40.97371000",
                "longitude": "-72.14369000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111283,
                "name": "Amherst",
                "latitude": "42.97839000",
                "longitude": "-78.79976000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111292,
                "name": "Amityville",
                "latitude": "40.67899000",
                "longitude": "-73.41707000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111295,
                "name": "Amsterdam",
                "latitude": "42.93869000",
                "longitude": "-74.18819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111325,
                "name": "Andover",
                "latitude": "42.15646000",
                "longitude": "-77.79555000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111341,
                "name": "Angola",
                "latitude": "42.63839000",
                "longitude": "-79.02782000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111342,
                "name": "Angola on the Lake",
                "latitude": "42.65478000",
                "longitude": "-79.04893000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111383,
                "name": "Apalachin",
                "latitude": "42.06952000",
                "longitude": "-76.15465000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111405,
                "name": "Aquebogue",
                "latitude": "40.94454000",
                "longitude": "-72.62704000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111419,
                "name": "Arcade",
                "latitude": "42.53395000",
                "longitude": "-78.42307000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111444,
                "name": "Ardsley",
                "latitude": "41.01065000",
                "longitude": "-73.84375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111468,
                "name": "Arlington",
                "latitude": "41.69593000",
                "longitude": "-73.89680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111478,
                "name": "Armonk",
                "latitude": "41.12648000",
                "longitude": "-73.71402000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111493,
                "name": "Arrochar",
                "latitude": "40.59844000",
                "longitude": "-74.07264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111504,
                "name": "Arverne",
                "latitude": "40.59122000",
                "longitude": "-73.79597000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111562,
                "name": "Astoria",
                "latitude": "40.77205000",
                "longitude": "-73.93014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111579,
                "name": "Athens",
                "latitude": "42.26036000",
                "longitude": "-73.80957000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111597,
                "name": "Atlantic Beach",
                "latitude": "40.58899000",
                "longitude": "-73.72902000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111610,
                "name": "Attica",
                "latitude": "42.86423000",
                "longitude": "-78.28029000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111628,
                "name": "Auburn",
                "latitude": "42.93173000",
                "longitude": "-76.56605000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111650,
                "name": "Augusta",
                "latitude": "42.97479000",
                "longitude": "-75.50129000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111680,
                "name": "Averill Park",
                "latitude": "42.63397000",
                "longitude": "-73.55373000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111693,
                "name": "Avon",
                "latitude": "42.91201000",
                "longitude": "-77.74556000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111716,
                "name": "Babylon",
                "latitude": "40.69566000",
                "longitude": "-73.32568000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111733,
                "name": "Bainbridge",
                "latitude": "42.29341000",
                "longitude": "-75.47935000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111737,
                "name": "Baiting Hollow",
                "latitude": "40.95621000",
                "longitude": "-72.74427000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111756,
                "name": "Baldwin",
                "latitude": "40.65649000",
                "longitude": "-73.60930000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111762,
                "name": "Baldwin Harbor",
                "latitude": "40.63955000",
                "longitude": "-73.60846000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111764,
                "name": "Baldwinsville",
                "latitude": "43.15868000",
                "longitude": "-76.33271000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111775,
                "name": "Ballston Spa",
                "latitude": "43.00091000",
                "longitude": "-73.84901000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111779,
                "name": "Balmville",
                "latitude": "41.53482000",
                "longitude": "-74.01486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111819,
                "name": "Bardonia",
                "latitude": "41.10954000",
                "longitude": "-73.99625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111837,
                "name": "Barnum Island",
                "latitude": "40.60455000",
                "longitude": "-73.64402000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111888,
                "name": "Batavia",
                "latitude": "42.99812000",
                "longitude": "-78.18752000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111898,
                "name": "Bath",
                "latitude": "42.33702000",
                "longitude": "-77.31776000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111900,
                "name": "Bath Beach",
                "latitude": "40.60455000",
                "longitude": "-74.00431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111918,
                "name": "Baxter Estates",
                "latitude": "40.83482000",
                "longitude": "-73.69541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111930,
                "name": "Bay Park",
                "latitude": "40.63316000",
                "longitude": "-73.67041000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111934,
                "name": "Bay Shore",
                "latitude": "40.72510000",
                "longitude": "-73.24539000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111936,
                "name": "Bay Wood",
                "latitude": "40.75010000",
                "longitude": "-73.29123000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111940,
                "name": "Baychester",
                "latitude": "40.86928000",
                "longitude": "-73.83645000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111952,
                "name": "Bayport",
                "latitude": "40.73843000",
                "longitude": "-73.05067000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111955,
                "name": "Bayside",
                "latitude": "40.76844000",
                "longitude": "-73.77708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111961,
                "name": "Bayville",
                "latitude": "40.91065000",
                "longitude": "-73.56207000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111968,
                "name": "Beacon",
                "latitude": "41.50482000",
                "longitude": "-73.96958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112003,
                "name": "Beaver Dam Lake",
                "latitude": "41.44743000",
                "longitude": "-74.11463000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112007,
                "name": "Beaverdam Lake-Salisbury Mills",
                "latitude": "41.44162000",
                "longitude": "-74.11629000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112025,
                "name": "Bedford",
                "latitude": "41.20426000",
                "longitude": "-73.64374000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112030,
                "name": "Bedford Hills",
                "latitude": "41.23676000",
                "longitude": "-73.69458000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112077,
                "name": "Bellaire",
                "latitude": "40.71399000",
                "longitude": "-73.75402000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112084,
                "name": "Belle Harbor",
                "latitude": "40.57594000",
                "longitude": "-73.84819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112100,
                "name": "Bellerose",
                "latitude": "40.72427000",
                "longitude": "-73.71513000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112101,
                "name": "Bellerose Terrace",
                "latitude": "40.72066000",
                "longitude": "-73.72596000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112123,
                "name": "Bellmore",
                "latitude": "40.66871000",
                "longitude": "-73.52707000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112125,
                "name": "Bellport",
                "latitude": "40.75704000",
                "longitude": "-72.93927000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112140,
                "name": "Belmont",
                "latitude": "42.22312000",
                "longitude": "-78.03445000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112187,
                "name": "Bensonhurst",
                "latitude": "40.60177000",
                "longitude": "-73.99403000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112216,
                "name": "Bergen",
                "latitude": "43.08534000",
                "longitude": "-77.94223000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112217,
                "name": "Bergen Beach",
                "latitude": "40.62038000",
                "longitude": "-73.90680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112293,
                "name": "Bethpage",
                "latitude": "40.74427000",
                "longitude": "-73.48207000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112320,
                "name": "Big Flats",
                "latitude": "42.13730000",
                "longitude": "-76.93691000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112346,
                "name": "Billington Heights",
                "latitude": "42.78423000",
                "longitude": "-78.62642000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112351,
                "name": "Binghamton",
                "latitude": "42.09869000",
                "longitude": "-75.91797000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112382,
                "name": "Black River",
                "latitude": "44.01256000",
                "longitude": "-75.79437000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112424,
                "name": "Blasdell",
                "latitude": "42.79728000",
                "longitude": "-78.82337000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112425,
                "name": "Blauvelt",
                "latitude": "41.06343000",
                "longitude": "-73.95764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112438,
                "name": "Bloomfield",
                "latitude": "40.61260000",
                "longitude": "-74.17820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112473,
                "name": "Blue Point",
                "latitude": "40.74399000",
                "longitude": "-73.03455000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112502,
                "name": "Bohemia",
                "latitude": "40.76926000",
                "longitude": "-73.11511000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112520,
                "name": "Bolivar",
                "latitude": "42.06673000",
                "longitude": "-78.16779000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112570,
                "name": "Boonville",
                "latitude": "43.48368000",
                "longitude": "-75.33656000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112580,
                "name": "Borough Park",
                "latitude": "40.63399000",
                "longitude": "-73.99681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112590,
                "name": "Boston",
                "latitude": "42.62895000",
                "longitude": "-78.73753000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112731,
                "name": "Brentwood",
                "latitude": "40.78121000",
                "longitude": "-73.24623000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112740,
                "name": "Brewerton",
                "latitude": "43.23812000",
                "longitude": "-76.14076000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112743,
                "name": "Brewster",
                "latitude": "41.39732000",
                "longitude": "-73.61707000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112746,
                "name": "Brewster Hill",
                "latitude": "41.42398000",
                "longitude": "-73.60429000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112750,
                "name": "Briarcliff Manor",
                "latitude": "41.14565000",
                "longitude": "-73.82375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112751,
                "name": "Briarwood",
                "latitude": "40.70935000",
                "longitude": "-73.81529000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112757,
                "name": "Bridgehampton",
                "latitude": "40.93788000",
                "longitude": "-72.30092000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112763,
                "name": "Bridgeport",
                "latitude": "43.15535000",
                "longitude": "-75.96936000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112790,
                "name": "Brighton",
                "latitude": "43.14756000",
                "longitude": "-77.55055000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112792,
                "name": "Brighton Beach",
                "latitude": "40.57788000",
                "longitude": "-73.95958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112794,
                "name": "Brightwaters",
                "latitude": "40.72093000",
                "longitude": "-73.26734000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112798,
                "name": "Brinckerhoff",
                "latitude": "41.54398000",
                "longitude": "-73.86819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112820,
                "name": "Broad Channel",
                "latitude": "40.60316000",
                "longitude": "-73.82041000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112823,
                "name": "Broadalbin",
                "latitude": "43.05868000",
                "longitude": "-74.19652000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112833,
                "name": "Brockport",
                "latitude": "43.21367000",
                "longitude": "-77.93918000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112836,
                "name": "Brocton",
                "latitude": "42.38867000",
                "longitude": "-79.44116000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112846,
                "name": "Bronx",
                "latitude": "40.82732000",
                "longitude": "-73.92357000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112847,
                "name": "Bronxville",
                "latitude": "40.93815000",
                "longitude": "-73.83208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112860,
                "name": "Brookhaven",
                "latitude": "40.77927000",
                "longitude": "-72.91538000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112872,
                "name": "Brooklyn",
                "latitude": "40.65010000",
                "longitude": "-73.94958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112875,
                "name": "Brooklyn Heights",
                "latitude": "40.69538000",
                "longitude": "-73.99375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112895,
                "name": "Brookville",
                "latitude": "40.81316000",
                "longitude": "-73.56735000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112899,
                "name": "Broome County",
                "latitude": "42.16022000",
                "longitude": "-75.81962000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112933,
                "name": "Brownsville",
                "latitude": "40.66094000",
                "longitude": "-73.92014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112938,
                "name": "Brownville",
                "latitude": "44.00700000",
                "longitude": "-75.98409000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112972,
                "name": "Buchanan",
                "latitude": "41.26204000",
                "longitude": "-73.93819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113014,
                "name": "Buffalo",
                "latitude": "42.88645000",
                "longitude": "-78.87837000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113103,
                "name": "Bushwick",
                "latitude": "40.69427000",
                "longitude": "-73.91875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113171,
                "name": "Cairo",
                "latitude": "42.29897000",
                "longitude": "-73.99847000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113178,
                "name": "Calcium",
                "latitude": "44.02173000",
                "longitude": "-75.84604000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113191,
                "name": "Caledonia",
                "latitude": "42.97312000",
                "longitude": "-77.85278000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113237,
                "name": "Calverton",
                "latitude": "40.90649000",
                "longitude": "-72.74343000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113248,
                "name": "Cambria Heights",
                "latitude": "40.69455000",
                "longitude": "-73.73847000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113254,
                "name": "Cambridge",
                "latitude": "43.02813000",
                "longitude": "-73.38122000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113267,
                "name": "Camden",
                "latitude": "43.33451000",
                "longitude": "-75.74796000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113284,
                "name": "Camillus",
                "latitude": "43.03923000",
                "longitude": "-76.30410000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113317,
                "name": "Canajoharie",
                "latitude": "42.90563000",
                "longitude": "-74.57181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113318,
                "name": "Canandaigua",
                "latitude": "42.87423000",
                "longitude": "-77.28804000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113319,
                "name": "Canarsie",
                "latitude": "40.64372000",
                "longitude": "-73.90069000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113320,
                "name": "Canastota",
                "latitude": "43.07951000",
                "longitude": "-75.75074000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113329,
                "name": "Canisteo",
                "latitude": "42.27035000",
                "longitude": "-77.60582000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113347,
                "name": "Canton",
                "latitude": "44.59562000",
                "longitude": "-75.16909000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113397,
                "name": "Carle Place",
                "latitude": "40.75260000",
                "longitude": "-73.61041000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113417,
                "name": "Carmel",
                "latitude": "41.43009000",
                "longitude": "-73.68013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113419,
                "name": "Carmel Hamlet",
                "latitude": "41.41485000",
                "longitude": "-73.68524000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113497,
                "name": "Carthage",
                "latitude": "43.97812000",
                "longitude": "-75.60936000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113553,
                "name": "Castleton-on-Hudson",
                "latitude": "42.51841000",
                "longitude": "-73.75123000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113579,
                "name": "Catskill",
                "latitude": "42.21731000",
                "longitude": "-73.86457000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113580,
                "name": "Cattaraugus County",
                "latitude": "42.24863000",
                "longitude": "-78.67885000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113594,
                "name": "Cayuga County",
                "latitude": "43.01033000",
                "longitude": "-76.57436000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113595,
                "name": "Cayuga Heights",
                "latitude": "42.46010000",
                "longitude": "-76.48776000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113596,
                "name": "Cazenovia",
                "latitude": "42.93007000",
                "longitude": "-75.85269000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113626,
                "name": "Cedarhurst",
                "latitude": "40.62288000",
                "longitude": "-73.72430000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113632,
                "name": "Celoron",
                "latitude": "42.10950000",
                "longitude": "-79.28310000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113645,
                "name": "Center Moriches",
                "latitude": "40.80038000",
                "longitude": "-72.78982000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113648,
                "name": "Centereach",
                "latitude": "40.85843000",
                "longitude": "-73.09955000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113650,
                "name": "Centerport",
                "latitude": "40.88538000",
                "longitude": "-73.37623000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113678,
                "name": "Central Islip",
                "latitude": "40.79065000",
                "longitude": "-73.20178000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113681,
                "name": "Central Square",
                "latitude": "43.28674000",
                "longitude": "-76.14604000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113682,
                "name": "Central Valley",
                "latitude": "41.33176000",
                "longitude": "-74.12098000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113708,
                "name": "Chadwicks",
                "latitude": "43.02785000",
                "longitude": "-75.27155000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113726,
                "name": "Champlain",
                "latitude": "44.98643000",
                "longitude": "-73.44653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113746,
                "name": "Chappaqua",
                "latitude": "41.15954000",
                "longitude": "-73.76485000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113768,
                "name": "Charleston",
                "latitude": "40.53677000",
                "longitude": "-74.23737000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113799,
                "name": "Chatham",
                "latitude": "42.36425000",
                "longitude": "-73.59484000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113815,
                "name": "Chautauqua County",
                "latitude": "42.30294000",
                "longitude": "-79.40576000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113824,
                "name": "Cheektowaga",
                "latitude": "42.90339000",
                "longitude": "-78.75475000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113834,
                "name": "Chelsea",
                "latitude": "40.60066000",
                "longitude": "-74.19487000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113836,
                "name": "Chemung County",
                "latitude": "42.14125000",
                "longitude": "-76.76003000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113837,
                "name": "Chenango Bridge",
                "latitude": "42.16674000",
                "longitude": "-75.86242000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113838,
                "name": "Chenango County",
                "latitude": "42.49351000",
                "longitude": "-75.61158000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113888,
                "name": "Chester",
                "latitude": "41.36259000",
                "longitude": "-74.27126000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113912,
                "name": "Chestnut Ridge",
                "latitude": "41.08426000",
                "longitude": "-74.05570000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113981,
                "name": "Chittenango",
                "latitude": "43.04507000",
                "longitude": "-75.86658000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114013,
                "name": "Churchville",
                "latitude": "43.10423000",
                "longitude": "-77.88445000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114043,
                "name": "City Island",
                "latitude": "40.84732000",
                "longitude": "-73.78652000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114108,
                "name": "Clarence",
                "latitude": "42.97673000",
                "longitude": "-78.59197000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114109,
                "name": "Clarence Center",
                "latitude": "43.01061000",
                "longitude": "-78.63753000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114132,
                "name": "Clark Mills",
                "latitude": "43.09229000",
                "longitude": "-75.37962000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114146,
                "name": "Clarkson",
                "latitude": "43.23312000",
                "longitude": "-77.92751000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114202,
                "name": "Clayton",
                "latitude": "44.23949000",
                "longitude": "-76.08578000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114258,
                "name": "Clifton",
                "latitude": "40.62010000",
                "longitude": "-74.07709000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114264,
                "name": "Clifton Springs",
                "latitude": "42.96173000",
                "longitude": "-77.13998000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114283,
                "name": "Clinton",
                "latitude": "43.04840000",
                "longitude": "-75.37850000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114295,
                "name": "Clinton County",
                "latitude": "44.74623000",
                "longitude": "-73.67817000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114298,
                "name": "Clintondale",
                "latitude": "41.69482000",
                "longitude": "-74.05125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114320,
                "name": "Clyde",
                "latitude": "43.08423000",
                "longitude": "-76.86940000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114322,
                "name": "Clymer",
                "latitude": "42.02089000",
                "longitude": "-79.63005000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114347,
                "name": "Cobleskill",
                "latitude": "42.67785000",
                "longitude": "-74.48542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114375,
                "name": "Cohoes",
                "latitude": "42.77424000",
                "longitude": "-73.70012000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114387,
                "name": "Cold Spring",
                "latitude": "41.42009000",
                "longitude": "-73.95458000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114388,
                "name": "Cold Spring Harbor",
                "latitude": "40.87149000",
                "longitude": "-73.45679000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114416,
                "name": "College Point",
                "latitude": "40.78760000",
                "longitude": "-73.84597000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114452,
                "name": "Colonie",
                "latitude": "42.71786000",
                "longitude": "-73.83346000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114480,
                "name": "Columbia County",
                "latitude": "42.25008000",
                "longitude": "-73.63185000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114521,
                "name": "Commack",
                "latitude": "40.84288000",
                "longitude": "-73.29289000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114540,
                "name": "Concord",
                "latitude": "40.60816000",
                "longitude": "-74.08431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114556,
                "name": "Coney Island",
                "latitude": "40.57788000",
                "longitude": "-73.99403000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114557,
                "name": "Congers",
                "latitude": "41.15065000",
                "longitude": "-73.94542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114572,
                "name": "Constantia",
                "latitude": "43.24785000",
                "longitude": "-76.00020000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114605,
                "name": "Cooperstown",
                "latitude": "42.70048000",
                "longitude": "-74.92426000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114616,
                "name": "Copiague",
                "latitude": "40.68149000",
                "longitude": "-73.39984000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114629,
                "name": "Coram",
                "latitude": "40.86871000",
                "longitude": "-73.00149000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114645,
                "name": "Corinth",
                "latitude": "43.24452000",
                "longitude": "-73.83234000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114653,
                "name": "Corning",
                "latitude": "42.14285000",
                "longitude": "-77.05469000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114658,
                "name": "Cornwall",
                "latitude": "41.44482000",
                "longitude": "-74.01570000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114661,
                "name": "Corona",
                "latitude": "40.74705000",
                "longitude": "-73.86014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114676,
                "name": "Cortland",
                "latitude": "42.60118000",
                "longitude": "-76.18048000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114677,
                "name": "Cortland County",
                "latitude": "42.59501000",
                "longitude": "-76.07027000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114678,
                "name": "Cortland West",
                "latitude": "42.59431000",
                "longitude": "-76.22587000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114721,
                "name": "Country Knolls",
                "latitude": "42.91508000",
                "longitude": "-73.80512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114751,
                "name": "Coxsackie",
                "latitude": "42.35092000",
                "longitude": "-73.80290000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114834,
                "name": "Crompond",
                "latitude": "41.29509000",
                "longitude": "-73.86541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114859,
                "name": "Croton-on-Hudson",
                "latitude": "41.20843000",
                "longitude": "-73.89125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114866,
                "name": "Crown Heights",
                "latitude": "41.63732000",
                "longitude": "-73.93792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114872,
                "name": "Crugers",
                "latitude": "41.23343000",
                "longitude": "-73.92264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114887,
                "name": "Cuba",
                "latitude": "42.21757000",
                "longitude": "-78.27529000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114920,
                "name": "Cumberland Head",
                "latitude": "44.71643000",
                "longitude": "-73.40263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114944,
                "name": "Cutchogue",
                "latitude": "41.01066000",
                "longitude": "-72.48509000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114956,
                "name": "Cypress Hills",
                "latitude": "40.67705000",
                "longitude": "-73.89125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115027,
                "name": "Dannemora",
                "latitude": "44.72143000",
                "longitude": "-73.72375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115028,
                "name": "Dansville",
                "latitude": "42.56090000",
                "longitude": "-77.69611000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115177,
                "name": "Deer Park",
                "latitude": "40.76177000",
                "longitude": "-73.32929000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115207,
                "name": "Delaware County",
                "latitude": "42.19809000",
                "longitude": "-74.96647000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115210,
                "name": "Delevan",
                "latitude": "42.48923000",
                "longitude": "-78.48085000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115212,
                "name": "Delhi",
                "latitude": "42.27814000",
                "longitude": "-74.91599000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115218,
                "name": "Delmar",
                "latitude": "42.62202000",
                "longitude": "-73.83262000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115256,
                "name": "Depew",
                "latitude": "42.90395000",
                "longitude": "-78.69225000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115258,
                "name": "Deposit",
                "latitude": "42.06008000",
                "longitude": "-75.42768000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115310,
                "name": "Dexter",
                "latitude": "44.00784000",
                "longitude": "-76.04437000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115358,
                "name": "Dix Hills",
                "latitude": "40.80482000",
                "longitude": "-73.33623000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115370,
                "name": "Dobbs Ferry",
                "latitude": "41.01454000",
                "longitude": "-73.87264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115387,
                "name": "Dolgeville",
                "latitude": "43.10090000",
                "longitude": "-74.77293000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115396,
                "name": "Dongan Hills",
                "latitude": "40.58844000",
                "longitude": "-74.09625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115439,
                "name": "Douglaston",
                "latitude": "40.76871000",
                "longitude": "-73.74708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115456,
                "name": "Dover Plains",
                "latitude": "41.74121000",
                "longitude": "-73.57652000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115485,
                "name": "Dryden",
                "latitude": "42.49091000",
                "longitude": "-76.29716000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115530,
                "name": "Dundee",
                "latitude": "42.52340000",
                "longitude": "-76.97663000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115539,
                "name": "Dunkirk",
                "latitude": "42.47950000",
                "longitude": "-79.33393000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115572,
                "name": "Durham",
                "latitude": "42.39953000",
                "longitude": "-74.17236000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115579,
                "name": "Dutchess County",
                "latitude": "41.76515000",
                "longitude": "-73.74286000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115590,
                "name": "Dyker Heights",
                "latitude": "40.62149000",
                "longitude": "-74.00958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115627,
                "name": "East Atlantic Beach",
                "latitude": "40.78982000",
                "longitude": "-73.74708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115628,
                "name": "East Aurora",
                "latitude": "42.76784000",
                "longitude": "-78.61336000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115655,
                "name": "East Elmhurst",
                "latitude": "40.76121000",
                "longitude": "-73.86514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115658,
                "name": "East Farmingdale",
                "latitude": "40.72927000",
                "longitude": "-73.41679000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115661,
                "name": "East Flatbush",
                "latitude": "40.65371000",
                "longitude": "-73.93042000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115667,
                "name": "East Garden City",
                "latitude": "40.73083000",
                "longitude": "-73.59806000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115669,
                "name": "East Glenville",
                "latitude": "42.89452000",
                "longitude": "-73.92790000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115672,
                "name": "East Greenbush",
                "latitude": "42.59091000",
                "longitude": "-73.70179000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115680,
                "name": "East Hampton",
                "latitude": "40.96343000",
                "longitude": "-72.18480000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115681,
                "name": "East Hampton North",
                "latitude": "40.97276000",
                "longitude": "-72.18911000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115683,
                "name": "East Harlem",
                "latitude": "40.79472000",
                "longitude": "-73.94250000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115692,
                "name": "East Hills",
                "latitude": "40.79371000",
                "longitude": "-73.62707000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115695,
                "name": "East Islip",
                "latitude": "40.73204000",
                "longitude": "-73.18567000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115696,
                "name": "East Ithaca",
                "latitude": "42.43952000",
                "longitude": "-76.47855000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115708,
                "name": "East Massapequa",
                "latitude": "40.67343000",
                "longitude": "-73.43651000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115710,
                "name": "East Meadow",
                "latitude": "40.71399000",
                "longitude": "-73.55902000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115717,
                "name": "East Moriches",
                "latitude": "40.80510000",
                "longitude": "-72.76093000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115719,
                "name": "East New York",
                "latitude": "40.66677000",
                "longitude": "-73.88236000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115722,
                "name": "East Northport",
                "latitude": "40.87676000",
                "longitude": "-73.32456000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115724,
                "name": "East Norwich",
                "latitude": "40.84677000",
                "longitude": "-73.53512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115730,
                "name": "East Patchogue",
                "latitude": "40.76704000",
                "longitude": "-72.99622000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115743,
                "name": "East Quogue",
                "latitude": "40.84066000",
                "longitude": "-72.58148000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115749,
                "name": "East Rochester",
                "latitude": "43.10867000",
                "longitude": "-77.48750000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115750,
                "name": "East Rockaway",
                "latitude": "40.64205000",
                "longitude": "-73.66957000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115757,
                "name": "East Setauket",
                "latitude": "40.94149000",
                "longitude": "-73.10594000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115758,
                "name": "East Shoreham",
                "latitude": "40.94482000",
                "longitude": "-72.87955000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115763,
                "name": "East Syracuse",
                "latitude": "43.06534000",
                "longitude": "-76.07853000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115765,
                "name": "East Tremont",
                "latitude": "40.84538000",
                "longitude": "-73.89097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115769,
                "name": "East Village",
                "latitude": "40.72927000",
                "longitude": "-73.98736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115773,
                "name": "East Williston",
                "latitude": "40.75843000",
                "longitude": "-73.63485000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115776,
                "name": "Eastchester",
                "latitude": "40.95833000",
                "longitude": "-73.80861000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115796,
                "name": "Eastport",
                "latitude": "40.82593000",
                "longitude": "-72.73177000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115805,
                "name": "Eatons Neck",
                "latitude": "40.93065000",
                "longitude": "-73.40151000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115830,
                "name": "Eden",
                "latitude": "42.65228000",
                "longitude": "-78.89698000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115845,
                "name": "Edgemere",
                "latitude": "40.59622000",
                "longitude": "-73.76763000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115872,
                "name": "Edinburg",
                "latitude": "43.22174000",
                "longitude": "-74.10402000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115902,
                "name": "Eggertsville",
                "latitude": "42.96339000",
                "longitude": "-78.80392000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115947,
                "name": "Elbridge",
                "latitude": "43.03451000",
                "longitude": "-76.44799000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115980,
                "name": "Elizabethtown",
                "latitude": "44.21616000",
                "longitude": "-73.59097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116020,
                "name": "Ellenville",
                "latitude": "41.71704000",
                "longitude": "-74.39571000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116047,
                "name": "Elma Center",
                "latitude": "42.82978000",
                "longitude": "-78.63614000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116052,
                "name": "Elmhurst",
                "latitude": "40.73649000",
                "longitude": "-73.87791000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116053,
                "name": "Elmira",
                "latitude": "42.08980000",
                "longitude": "-76.80773000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116054,
                "name": "Elmira Heights",
                "latitude": "42.12980000",
                "longitude": "-76.82079000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116055,
                "name": "Elmont",
                "latitude": "40.70094000",
                "longitude": "-73.71291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116059,
                "name": "Elmsford",
                "latitude": "41.05510000",
                "longitude": "-73.82013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116072,
                "name": "Eltingville",
                "latitude": "40.54538000",
                "longitude": "-74.16570000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116082,
                "name": "Elwood",
                "latitude": "40.84538000",
                "longitude": "-73.33512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116095,
                "name": "Emerson Hill",
                "latitude": "40.60872000",
                "longitude": "-74.09598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116120,
                "name": "Endicott",
                "latitude": "42.09841000",
                "longitude": "-76.04937000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116121,
                "name": "Endwell",
                "latitude": "42.11285000",
                "longitude": "-76.02103000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116168,
                "name": "Erie County",
                "latitude": "42.75824000",
                "longitude": "-78.77966000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116196,
                "name": "Essex County",
                "latitude": "44.11722000",
                "longitude": "-73.77271000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116341,
                "name": "Fairmount",
                "latitude": "43.04729000",
                "longitude": "-76.23854000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116345,
                "name": "Fairport",
                "latitude": "43.09867000",
                "longitude": "-77.44194000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116353,
                "name": "Fairview",
                "latitude": "41.72370000",
                "longitude": "-73.91986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116367,
                "name": "Falconer",
                "latitude": "42.11867000",
                "longitude": "-79.19838000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116384,
                "name": "Fallsburg",
                "latitude": "41.73204000",
                "longitude": "-74.60127000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116395,
                "name": "Far Rockaway",
                "latitude": "40.60538000",
                "longitude": "-73.75513000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116411,
                "name": "Farmingdale",
                "latitude": "40.73260000",
                "longitude": "-73.44540000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116424,
                "name": "Farmingville",
                "latitude": "40.83121000",
                "longitude": "-73.02955000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116460,
                "name": "Fayetteville",
                "latitude": "43.02979000",
                "longitude": "-76.00436000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116524,
                "name": "Firthcliffe",
                "latitude": "41.43926000",
                "longitude": "-74.04514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116532,
                "name": "Fishkill",
                "latitude": "41.53565000",
                "longitude": "-73.89903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116548,
                "name": "Flanders",
                "latitude": "40.90343000",
                "longitude": "-72.61759000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116553,
                "name": "Flatbush",
                "latitude": "40.65205000",
                "longitude": "-73.95903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116555,
                "name": "Flatlands",
                "latitude": "40.62122000",
                "longitude": "-73.93486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116575,
                "name": "Floral Park",
                "latitude": "40.72371000",
                "longitude": "-73.70485000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116592,
                "name": "Florida",
                "latitude": "41.33176000",
                "longitude": "-74.35682000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116600,
                "name": "Flower Hill",
                "latitude": "40.80732000",
                "longitude": "-73.68124000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116629,
                "name": "Fonda",
                "latitude": "42.95452000",
                "longitude": "-74.37652000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116639,
                "name": "Fordham",
                "latitude": "40.85927000",
                "longitude": "-73.89847000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116658,
                "name": "Forest Hills",
                "latitude": "40.71621000",
                "longitude": "-73.85014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116702,
                "name": "Fort Covington Hamlet",
                "latitude": "44.97178000",
                "longitude": "-74.50757000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116708,
                "name": "Fort Drum",
                "latitude": "44.05843000",
                "longitude": "-75.76189000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116709,
                "name": "Fort Edward",
                "latitude": "43.26702000",
                "longitude": "-73.58456000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116715,
                "name": "Fort Hamilton",
                "latitude": "40.61872000",
                "longitude": "-74.03320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116732,
                "name": "Fort Montgomery",
                "latitude": "41.33148000",
                "longitude": "-73.98681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116743,
                "name": "Fort Plain",
                "latitude": "42.93146000",
                "longitude": "-74.62264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116748,
                "name": "Fort Salonga",
                "latitude": "40.91260000",
                "longitude": "-73.30095000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116758,
                "name": "Fort Wadsworth",
                "latitude": "40.60113000",
                "longitude": "-74.05738000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116823,
                "name": "Frankfort",
                "latitude": "43.03896000",
                "longitude": "-75.07044000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116861,
                "name": "Franklin County",
                "latitude": "44.59293000",
                "longitude": "-74.30376000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116872,
                "name": "Franklin Square",
                "latitude": "40.70732000",
                "longitude": "-73.67596000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116876,
                "name": "Franklinville",
                "latitude": "42.33701000",
                "longitude": "-78.45808000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116896,
                "name": "Fredonia",
                "latitude": "42.44006000",
                "longitude": "-79.33171000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116914,
                "name": "Freeport",
                "latitude": "40.65760000",
                "longitude": "-73.58318000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116937,
                "name": "Fresh Meadows",
                "latitude": "40.73482000",
                "longitude": "-73.79347000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116941,
                "name": "Frewsburg",
                "latitude": "42.05450000",
                "longitude": "-79.15810000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116949,
                "name": "Friendship",
                "latitude": "42.20646000",
                "longitude": "-78.13751000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116991,
                "name": "Fulton",
                "latitude": "43.32285000",
                "longitude": "-76.41716000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116997,
                "name": "Fulton County",
                "latitude": "43.11385000",
                "longitude": "-74.42217000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117031,
                "name": "Galeville",
                "latitude": "43.09007000",
                "longitude": "-76.17298000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117050,
                "name": "Gang Mills",
                "latitude": "42.14619000",
                "longitude": "-77.11164000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117058,
                "name": "Garden City",
                "latitude": "40.72677000",
                "longitude": "-73.63430000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117062,
                "name": "Garden City Park",
                "latitude": "40.74093000",
                "longitude": "-73.66263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117063,
                "name": "Garden City South",
                "latitude": "40.71232000",
                "longitude": "-73.66096000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117077,
                "name": "Gardnertown",
                "latitude": "41.53509000",
                "longitude": "-74.07014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117111,
                "name": "Gasport",
                "latitude": "43.19922000",
                "longitude": "-78.57614000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117120,
                "name": "Gates-North Gates",
                "latitude": "43.16547000",
                "longitude": "-77.70066000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117136,
                "name": "Genesee County",
                "latitude": "43.00093000",
                "longitude": "-78.19371000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117138,
                "name": "Geneseo",
                "latitude": "42.79590000",
                "longitude": "-77.81695000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117144,
                "name": "Geneva",
                "latitude": "42.86896000",
                "longitude": "-76.97774000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117242,
                "name": "Glasco",
                "latitude": "42.04370000",
                "longitude": "-73.94736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117264,
                "name": "Glen Cove",
                "latitude": "40.86232000",
                "longitude": "-73.63374000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117267,
                "name": "Glen Head",
                "latitude": "40.83538000",
                "longitude": "-73.62374000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117269,
                "name": "Glen Oaks",
                "latitude": "40.74705000",
                "longitude": "-73.71152000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117283,
                "name": "Glendale",
                "latitude": "40.70149000",
                "longitude": "-73.88680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117304,
                "name": "Glens Falls",
                "latitude": "43.30952000",
                "longitude": "-73.64401000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117305,
                "name": "Glens Falls North",
                "latitude": "43.33506000",
                "longitude": "-73.68251000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117317,
                "name": "Glenwood Landing",
                "latitude": "40.83066000",
                "longitude": "-73.63874000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117328,
                "name": "Gloversville",
                "latitude": "43.05285000",
                "longitude": "-74.34375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117362,
                "name": "Goldens Bridge",
                "latitude": "41.29343000",
                "longitude": "-73.67680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117399,
                "name": "Gordon Heights",
                "latitude": "40.85871000",
                "longitude": "-72.97066000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117409,
                "name": "Goshen",
                "latitude": "41.40204000",
                "longitude": "-74.32432000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117419,
                "name": "Gouverneur",
                "latitude": "44.33673000",
                "longitude": "-75.46299000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117422,
                "name": "Gowanda",
                "latitude": "42.46312000",
                "longitude": "-78.93587000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117462,
                "name": "Grand Island",
                "latitude": "43.03311000",
                "longitude": "-78.96254000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117485,
                "name": "Grandyle Village",
                "latitude": "42.99645000",
                "longitude": "-78.95504000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117503,
                "name": "Graniteville",
                "latitude": "40.62483000",
                "longitude": "-74.14848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117507,
                "name": "Grant City",
                "latitude": "40.58205000",
                "longitude": "-74.10486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117536,
                "name": "Granville",
                "latitude": "43.40785000",
                "longitude": "-73.25955000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117548,
                "name": "Gravesend",
                "latitude": "40.59760000",
                "longitude": "-73.96514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117574,
                "name": "Great Kills",
                "latitude": "40.55427000",
                "longitude": "-74.15153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117575,
                "name": "Great Neck",
                "latitude": "40.80066000",
                "longitude": "-73.72846000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117576,
                "name": "Great Neck Estates",
                "latitude": "40.78705000",
                "longitude": "-73.73680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117577,
                "name": "Great Neck Gardens",
                "latitude": "40.79722000",
                "longitude": "-73.72389000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117578,
                "name": "Great Neck Plaza",
                "latitude": "40.78677000",
                "longitude": "-73.72652000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117579,
                "name": "Great River",
                "latitude": "40.72121000",
                "longitude": "-73.15761000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117584,
                "name": "Greece",
                "latitude": "43.20978000",
                "longitude": "-77.69306000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117599,
                "name": "Green Island",
                "latitude": "42.74424000",
                "longitude": "-73.69151000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117622,
                "name": "Greenburgh",
                "latitude": "41.03287000",
                "longitude": "-73.84291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117630,
                "name": "Greene",
                "latitude": "42.32924000",
                "longitude": "-75.76991000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117642,
                "name": "Greene County",
                "latitude": "42.27652000",
                "longitude": "-74.12271000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117658,
                "name": "Greenlawn",
                "latitude": "40.86899000",
                "longitude": "-73.36512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117661,
                "name": "Greenpoint",
                "latitude": "40.72371000",
                "longitude": "-73.95097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117662,
                "name": "Greenport",
                "latitude": "41.10343000",
                "longitude": "-72.35925000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117663,
                "name": "Greenport West",
                "latitude": "41.10178000",
                "longitude": "-72.37195000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117679,
                "name": "Greenvale",
                "latitude": "40.81066000",
                "longitude": "-73.62846000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117693,
                "name": "Greenville",
                "latitude": "40.99315000",
                "longitude": "-73.81986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117699,
                "name": "Greenwich",
                "latitude": "43.09063000",
                "longitude": "-73.49873000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117711,
                "name": "Greenwood Lake",
                "latitude": "41.22259000",
                "longitude": "-74.29432000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117750,
                "name": "Groton",
                "latitude": "42.58785000",
                "longitude": "-76.36688000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117775,
                "name": "Grymes Hill",
                "latitude": "40.61872000",
                "longitude": "-74.09348000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117834,
                "name": "Hadley",
                "latitude": "43.31729000",
                "longitude": "-73.84818000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117835,
                "name": "Hagaman",
                "latitude": "42.97452000",
                "longitude": "-74.15096000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117852,
                "name": "Halesite",
                "latitude": "40.88843000",
                "longitude": "-73.41540000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117884,
                "name": "Hamburg",
                "latitude": "42.71589000",
                "longitude": "-78.82948000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117893,
                "name": "Hamilton",
                "latitude": "42.82701000",
                "longitude": "-75.54462000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117903,
                "name": "Hamilton County",
                "latitude": "43.66112000",
                "longitude": "-74.49736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117909,
                "name": "Hamlin",
                "latitude": "43.30312000",
                "longitude": "-77.92112000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117935,
                "name": "Hampton Bays",
                "latitude": "40.86899000",
                "longitude": "-72.51759000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117939,
                "name": "Hampton Manor",
                "latitude": "42.62091000",
                "longitude": "-73.72845000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117964,
                "name": "Hannawa Falls",
                "latitude": "44.61228000",
                "longitude": "-74.97103000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117990,
                "name": "Harbor Isle",
                "latitude": "40.60344000",
                "longitude": "-73.66457000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118023,
                "name": "Harlem",
                "latitude": "40.80788000",
                "longitude": "-73.94542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118040,
                "name": "Harriman",
                "latitude": "41.30843000",
                "longitude": "-74.14459000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118046,
                "name": "Harris Hill",
                "latitude": "42.96478000",
                "longitude": "-78.67753000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118059,
                "name": "Harrison",
                "latitude": "40.96899000",
                "longitude": "-73.71263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118090,
                "name": "Hartford",
                "latitude": "43.36368000",
                "longitude": "-73.39372000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118101,
                "name": "Hartsdale",
                "latitude": "41.01899000",
                "longitude": "-73.79819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118135,
                "name": "Hastings-on-Hudson",
                "latitude": "40.99454000",
                "longitude": "-73.87875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118143,
                "name": "Hauppauge",
                "latitude": "40.82565000",
                "longitude": "-73.20261000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118152,
                "name": "Haverstraw",
                "latitude": "41.19759000",
                "longitude": "-73.96458000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118153,
                "name": "Haviland",
                "latitude": "41.76676000",
                "longitude": "-73.90152000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118174,
                "name": "Hawthorne",
                "latitude": "41.10732000",
                "longitude": "-73.79597000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118215,
                "name": "Head of the Harbor",
                "latitude": "40.90343000",
                "longitude": "-73.15789000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118270,
                "name": "Hempstead",
                "latitude": "40.70621000",
                "longitude": "-73.61874000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118318,
                "name": "Heritage Hills",
                "latitude": "41.33954000",
                "longitude": "-73.69735000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118323,
                "name": "Herkimer",
                "latitude": "43.02563000",
                "longitude": "-74.98599000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118324,
                "name": "Herkimer County",
                "latitude": "43.41970000",
                "longitude": "-74.96250000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118337,
                "name": "Herricks",
                "latitude": "40.75538000",
                "longitude": "-73.66680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118349,
                "name": "Hewlett",
                "latitude": "40.64316000",
                "longitude": "-73.69569000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118350,
                "name": "Hewlett Harbor",
                "latitude": "40.63621000",
                "longitude": "-73.68152000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118371,
                "name": "Hicksville",
                "latitude": "40.76843000",
                "longitude": "-73.52513000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118397,
                "name": "Highland",
                "latitude": "41.72093000",
                "longitude": "-73.96014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118405,
                "name": "Highland Falls",
                "latitude": "41.36926000",
                "longitude": "-73.96625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118409,
                "name": "Highland Mills",
                "latitude": "41.34704000",
                "longitude": "-74.12626000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118440,
                "name": "Hillcrest",
                "latitude": "41.12787000",
                "longitude": "-74.04097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118465,
                "name": "Hillside",
                "latitude": "40.70788000",
                "longitude": "-73.78680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118466,
                "name": "Hillside Lake",
                "latitude": "41.61482000",
                "longitude": "-73.79819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118473,
                "name": "Hilton",
                "latitude": "43.28812000",
                "longitude": "-77.79334000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118518,
                "name": "Holbrook",
                "latitude": "40.81232000",
                "longitude": "-73.07844000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118520,
                "name": "Holcomb",
                "latitude": "42.90229000",
                "longitude": "-77.41971000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118540,
                "name": "Holland",
                "latitude": "42.64117000",
                "longitude": "-78.54169000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118543,
                "name": "Holley",
                "latitude": "43.22645000",
                "longitude": "-78.02668000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118549,
                "name": "Hollis",
                "latitude": "40.71344000",
                "longitude": "-73.76708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118580,
                "name": "Holtsville",
                "latitude": "40.81538000",
                "longitude": "-73.04511000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118596,
                "name": "Homer",
                "latitude": "42.63701000",
                "longitude": "-76.17882000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118617,
                "name": "Honeoye Falls",
                "latitude": "42.95229000",
                "longitude": "-77.59028000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118637,
                "name": "Hoosick Falls",
                "latitude": "42.90119000",
                "longitude": "-73.35150000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118667,
                "name": "Hornell",
                "latitude": "42.32785000",
                "longitude": "-77.66110000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118673,
                "name": "Horseheads",
                "latitude": "42.16702000",
                "longitude": "-76.82051000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118674,
                "name": "Horseheads North",
                "latitude": "42.19278000",
                "longitude": "-76.80782000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118690,
                "name": "Houghton",
                "latitude": "42.42340000",
                "longitude": "-78.15723000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118710,
                "name": "Howard Beach",
                "latitude": "40.65788000",
                "longitude": "-73.83625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118744,
                "name": "Hudson",
                "latitude": "42.25286000",
                "longitude": "-73.79096000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118750,
                "name": "Hudson Falls",
                "latitude": "43.30063000",
                "longitude": "-73.58595000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118769,
                "name": "Huguenot",
                "latitude": "40.53733000",
                "longitude": "-74.19459000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118802,
                "name": "Huntington",
                "latitude": "40.86815000",
                "longitude": "-73.42568000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118804,
                "name": "Huntington Bay",
                "latitude": "40.89982000",
                "longitude": "-73.41484000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118808,
                "name": "Huntington Station",
                "latitude": "40.85343000",
                "longitude": "-73.41151000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118813,
                "name": "Hunts Point",
                "latitude": "40.81260000",
                "longitude": "-73.88402000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118820,
                "name": "Hurley",
                "latitude": "41.92454000",
                "longitude": "-74.06125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118850,
                "name": "Hyde Park",
                "latitude": "41.78482000",
                "longitude": "-73.93319000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118878,
                "name": "Ilion",
                "latitude": "43.01507000",
                "longitude": "-75.03543000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118963,
                "name": "Inwood",
                "latitude": "40.86566000",
                "longitude": "-73.92680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118996,
                "name": "Irondequoit",
                "latitude": "43.21340000",
                "longitude": "-77.57972000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119010,
                "name": "Irvington",
                "latitude": "41.03922000",
                "longitude": "-73.86823000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119027,
                "name": "Island Park",
                "latitude": "40.60427000",
                "longitude": "-73.65541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119029,
                "name": "Islandia",
                "latitude": "40.80426000",
                "longitude": "-73.16900000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119034,
                "name": "Islip",
                "latitude": "40.72982000",
                "longitude": "-73.21039000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119035,
                "name": "Islip Terrace",
                "latitude": "40.74315000",
                "longitude": "-73.19262000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119044,
                "name": "Ithaca",
                "latitude": "42.44063000",
                "longitude": "-76.49661000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119097,
                "name": "Jackson Heights",
                "latitude": "40.75566000",
                "longitude": "-73.88541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119111,
                "name": "Jamaica",
                "latitude": "40.69149000",
                "longitude": "-73.80569000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119119,
                "name": "Jamesport",
                "latitude": "40.94954000",
                "longitude": "-72.58148000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119124,
                "name": "Jamestown",
                "latitude": "42.09700000",
                "longitude": "-79.23533000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119127,
                "name": "Jamestown West",
                "latitude": "42.08851000",
                "longitude": "-79.28110000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119191,
                "name": "Jefferson County",
                "latitude": "43.99885000",
                "longitude": "-76.05211000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119201,
                "name": "Jefferson Heights",
                "latitude": "42.23398000",
                "longitude": "-73.88235000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119204,
                "name": "Jefferson Valley-Yorktown",
                "latitude": "41.31797000",
                "longitude": "-73.80066000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119224,
                "name": "Jericho",
                "latitude": "40.79204000",
                "longitude": "-73.53985000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119259,
                "name": "Johnson City",
                "latitude": "42.11563000",
                "longitude": "-75.95881000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119284,
                "name": "Johnstown",
                "latitude": "43.00674000",
                "longitude": "-74.36764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119316,
                "name": "Jordan",
                "latitude": "43.06534000",
                "longitude": "-76.47299000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119391,
                "name": "Kaser",
                "latitude": "41.12121000",
                "longitude": "-74.06709000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119394,
                "name": "Katonah",
                "latitude": "41.25898000",
                "longitude": "-73.68541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119423,
                "name": "Keeseville",
                "latitude": "44.50505000",
                "longitude": "-73.48013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119462,
                "name": "Kenmore",
                "latitude": "42.96589000",
                "longitude": "-78.87004000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119483,
                "name": "Kensington",
                "latitude": "40.79343000",
                "longitude": "-73.72208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119511,
                "name": "Kerhonkson",
                "latitude": "41.77482000",
                "longitude": "-74.29821000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119529,
                "name": "Keuka Park",
                "latitude": "42.61535000",
                "longitude": "-77.09219000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119530,
                "name": "Kew Gardens",
                "latitude": "40.71427000",
                "longitude": "-73.83097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119531,
                "name": "Kew Gardens Hills",
                "latitude": "40.73002000",
                "longitude": "-73.82340000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119550,
                "name": "Kiantone",
                "latitude": "42.02200000",
                "longitude": "-79.19810000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119575,
                "name": "Kinderhook",
                "latitude": "42.39536000",
                "longitude": "-73.69790000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119599,
                "name": "Kings Bridge",
                "latitude": "40.87871000",
                "longitude": "-73.90514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119601,
                "name": "Kings County",
                "latitude": "40.63439000",
                "longitude": "-73.95027000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119605,
                "name": "Kings Park",
                "latitude": "40.88621000",
                "longitude": "-73.25734000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119608,
                "name": "Kings Point",
                "latitude": "40.81982000",
                "longitude": "-73.73513000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119627,
                "name": "Kingston",
                "latitude": "41.92704000",
                "longitude": "-73.99736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119656,
                "name": "Kiryas Joel",
                "latitude": "41.34204000",
                "longitude": "-74.16792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119813,
                "name": "Lackawanna",
                "latitude": "42.82561000",
                "longitude": "-78.82337000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119875,
                "name": "Lake Carmel",
                "latitude": "41.46148000",
                "longitude": "-73.67096000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119907,
                "name": "Lake Erie Beach",
                "latitude": "42.62423000",
                "longitude": "-79.06698000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119914,
                "name": "Lake Grove",
                "latitude": "40.85288000",
                "longitude": "-73.11511000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119926,
                "name": "Lake Katrine",
                "latitude": "41.98565000",
                "longitude": "-73.98819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119935,
                "name": "Lake Luzerne",
                "latitude": "43.31285000",
                "longitude": "-73.83484000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119945,
                "name": "Lake Mohegan",
                "latitude": "41.31787000",
                "longitude": "-73.84625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119963,
                "name": "Lake Placid",
                "latitude": "44.27962000",
                "longitude": "-73.98198000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119964,
                "name": "Lake Pleasant",
                "latitude": "43.47090000",
                "longitude": "-74.41265000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119970,
                "name": "Lake Ronkonkoma",
                "latitude": "40.83510000",
                "longitude": "-73.13122000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119982,
                "name": "Lake Success",
                "latitude": "40.77066000",
                "longitude": "-73.71763000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120016,
                "name": "Lakeland",
                "latitude": "43.09034000",
                "longitude": "-76.24048000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120039,
                "name": "Lakeview",
                "latitude": "40.68538000",
                "longitude": "-73.65263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120049,
                "name": "Lakewood",
                "latitude": "42.10422000",
                "longitude": "-79.33310000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120086,
                "name": "Lancaster",
                "latitude": "42.90061000",
                "longitude": "-78.67031000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120128,
                "name": "Lansing",
                "latitude": "42.48424000",
                "longitude": "-76.47994000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120141,
                "name": "Larchmont",
                "latitude": "40.92788000",
                "longitude": "-73.75180000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120168,
                "name": "Latham",
                "latitude": "42.74702000",
                "longitude": "-73.75901000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120177,
                "name": "Lattingtown",
                "latitude": "40.89538000",
                "longitude": "-73.60096000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120192,
                "name": "Laurel",
                "latitude": "40.96954000",
                "longitude": "-72.56203000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120198,
                "name": "Laurel Hollow",
                "latitude": "40.85677000",
                "longitude": "-73.46957000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120204,
                "name": "Laurelton",
                "latitude": "40.67019000",
                "longitude": "-73.74659000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120228,
                "name": "Lawrence",
                "latitude": "40.61566000",
                "longitude": "-73.72958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120263,
                "name": "Le Roy",
                "latitude": "42.97839000",
                "longitude": "-77.98418000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120407,
                "name": "Levittown",
                "latitude": "40.72593000",
                "longitude": "-73.51429000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120415,
                "name": "Lewis County",
                "latitude": "43.78469000",
                "longitude": "-75.44879000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120426,
                "name": "Lewiston",
                "latitude": "43.17256000",
                "longitude": "-79.03588000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120466,
                "name": "Liberty",
                "latitude": "41.80120000",
                "longitude": "-74.74655000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120478,
                "name": "Lido Beach",
                "latitude": "40.58899000",
                "longitude": "-73.62541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120489,
                "name": "Lima",
                "latitude": "42.90479000",
                "longitude": "-77.61139000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120543,
                "name": "Lincoln Park",
                "latitude": "41.95065000",
                "longitude": "-73.99403000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120548,
                "name": "Lincolndale",
                "latitude": "41.32287000",
                "longitude": "-73.71819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120568,
                "name": "Lindenhurst",
                "latitude": "40.68677000",
                "longitude": "-73.37345000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120570,
                "name": "Lindley",
                "latitude": "42.02841000",
                "longitude": "-77.13969000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120619,
                "name": "Little Falls",
                "latitude": "43.04340000",
                "longitude": "-74.85960000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120622,
                "name": "Little Neck",
                "latitude": "40.76289000",
                "longitude": "-73.73225000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120631,
                "name": "Little Valley",
                "latitude": "42.25256000",
                "longitude": "-78.80559000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120646,
                "name": "Liverpool",
                "latitude": "43.10646000",
                "longitude": "-76.21770000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120658,
                "name": "Livingston County",
                "latitude": "42.72808000",
                "longitude": "-77.77549000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120659,
                "name": "Livingston Manor",
                "latitude": "41.90037000",
                "longitude": "-74.82822000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120663,
                "name": "Livonia",
                "latitude": "42.82145000",
                "longitude": "-77.66861000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120667,
                "name": "Lloyd Harbor",
                "latitude": "40.90343000",
                "longitude": "-73.45984000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120681,
                "name": "Lockport",
                "latitude": "43.17061000",
                "longitude": "-78.69031000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120688,
                "name": "Locust Valley",
                "latitude": "40.87593000",
                "longitude": "-73.59707000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120737,
                "name": "Long Beach",
                "latitude": "40.58844000",
                "longitude": "-73.65791000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120745,
                "name": "Long Island City",
                "latitude": "40.74482000",
                "longitude": "-73.94875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120772,
                "name": "Lorenz Park",
                "latitude": "42.26370000",
                "longitude": "-73.76846000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120850,
                "name": "Lowville",
                "latitude": "43.78674000",
                "longitude": "-75.49185000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120913,
                "name": "Lynbrook",
                "latitude": "40.65483000",
                "longitude": "-73.67180000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120917,
                "name": "Lyncourt",
                "latitude": "43.08146000",
                "longitude": "-76.12576000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120943,
                "name": "Lyons",
                "latitude": "43.06423000",
                "longitude": "-76.99025000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120954,
                "name": "Macedon",
                "latitude": "43.06923000",
                "longitude": "-77.29887000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121017,
                "name": "Madison County",
                "latitude": "42.91277000",
                "longitude": "-75.66967000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121046,
                "name": "Mahopac",
                "latitude": "41.37232000",
                "longitude": "-73.73346000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121066,
                "name": "Malone",
                "latitude": "44.84866000",
                "longitude": "-74.29490000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121074,
                "name": "Malverne",
                "latitude": "40.67899000",
                "longitude": "-73.67402000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121075,
                "name": "Mamaroneck",
                "latitude": "40.94871000",
                "longitude": "-73.73263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121099,
                "name": "Manchester",
                "latitude": "42.96979000",
                "longitude": "-77.23026000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121111,
                "name": "Manhasset",
                "latitude": "40.79788000",
                "longitude": "-73.69957000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121112,
                "name": "Manhasset Hills",
                "latitude": "40.75927000",
                "longitude": "-73.67985000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121115,
                "name": "Manhattan",
                "latitude": "40.78343000",
                "longitude": "-73.96625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121131,
                "name": "Manlius",
                "latitude": "43.00201000",
                "longitude": "-75.97686000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121140,
                "name": "Manorhaven",
                "latitude": "40.84316000",
                "longitude": "-73.71485000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121141,
                "name": "Manorville",
                "latitude": "40.87371000",
                "longitude": "-72.80788000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121191,
                "name": "Marbletown",
                "latitude": "41.88343000",
                "longitude": "-74.11320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121195,
                "name": "Marcellus",
                "latitude": "42.98284000",
                "longitude": "-76.34049000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121227,
                "name": "Mariners Harbor",
                "latitude": "40.63677000",
                "longitude": "-74.15875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121244,
                "name": "Marion",
                "latitude": "43.14340000",
                "longitude": "-77.18915000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121275,
                "name": "Marlboro",
                "latitude": "41.60565000",
                "longitude": "-73.97153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121386,
                "name": "Maspeth",
                "latitude": "40.72316000",
                "longitude": "-73.91264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121391,
                "name": "Massapequa",
                "latitude": "40.68066000",
                "longitude": "-73.47429000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121392,
                "name": "Massapequa Park",
                "latitude": "40.68038000",
                "longitude": "-73.45512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121393,
                "name": "Massena",
                "latitude": "44.92810000",
                "longitude": "-74.89186000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121394,
                "name": "Mastic",
                "latitude": "40.80204000",
                "longitude": "-72.84094000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121395,
                "name": "Mastic Beach",
                "latitude": "40.76677000",
                "longitude": "-72.85205000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121413,
                "name": "Mattituck",
                "latitude": "40.99121000",
                "longitude": "-72.53425000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121415,
                "name": "Mattydale",
                "latitude": "43.09784000",
                "longitude": "-76.14520000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121431,
                "name": "Maybrook",
                "latitude": "41.48398000",
                "longitude": "-74.21765000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121455,
                "name": "Mayville",
                "latitude": "42.25395000",
                "longitude": "-79.50449000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121504,
                "name": "McGraw",
                "latitude": "42.59618000",
                "longitude": "-76.09326000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121526,
                "name": "McKownville",
                "latitude": "42.68397000",
                "longitude": "-73.84762000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121581,
                "name": "Mechanicstown",
                "latitude": "41.44287000",
                "longitude": "-74.38849000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121586,
                "name": "Mechanicville",
                "latitude": "42.90285000",
                "longitude": "-73.68734000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121594,
                "name": "Medford",
                "latitude": "40.81760000",
                "longitude": "-73.00011000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121605,
                "name": "Medina",
                "latitude": "43.22006000",
                "longitude": "-78.38697000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121630,
                "name": "Melrose",
                "latitude": "40.82455000",
                "longitude": "-73.91041000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121633,
                "name": "Melrose Park",
                "latitude": "42.90868000",
                "longitude": "-76.54022000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121635,
                "name": "Melville",
                "latitude": "40.79343000",
                "longitude": "-73.41512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121645,
                "name": "Menands",
                "latitude": "42.69202000",
                "longitude": "-73.72456000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121704,
                "name": "Merrick",
                "latitude": "40.66288000",
                "longitude": "-73.55152000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121715,
                "name": "Merritt Park",
                "latitude": "41.53848000",
                "longitude": "-73.87238000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121743,
                "name": "Mexico",
                "latitude": "43.45951000",
                "longitude": "-76.22882000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121761,
                "name": "Middle Island",
                "latitude": "40.88427000",
                "longitude": "-72.93733000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121764,
                "name": "Middle Village",
                "latitude": "40.71649000",
                "longitude": "-73.88125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121770,
                "name": "Middleburgh",
                "latitude": "42.59869000",
                "longitude": "-74.33292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121775,
                "name": "Middleport",
                "latitude": "43.21256000",
                "longitude": "-78.47641000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121791,
                "name": "Middletown",
                "latitude": "41.44593000",
                "longitude": "-74.42293000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121802,
                "name": "Midland Beach",
                "latitude": "40.57316000",
                "longitude": "-74.09459000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121866,
                "name": "Mill Neck",
                "latitude": "40.88704000",
                "longitude": "-73.55512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121873,
                "name": "Millbrook",
                "latitude": "41.78509000",
                "longitude": "-73.69402000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121883,
                "name": "Miller Place",
                "latitude": "40.95982000",
                "longitude": "-72.99621000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121916,
                "name": "Milton",
                "latitude": "43.03369000",
                "longitude": "-73.85262000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121932,
                "name": "Mineola",
                "latitude": "40.74927000",
                "longitude": "-73.64068000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121944,
                "name": "Minetto",
                "latitude": "43.39812000",
                "longitude": "-76.47744000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121945,
                "name": "Mineville",
                "latitude": "44.09283000",
                "longitude": "-73.51818000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121960,
                "name": "Minoa",
                "latitude": "43.07618000",
                "longitude": "-76.00075000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122021,
                "name": "Mohawk",
                "latitude": "43.01146000",
                "longitude": "-75.00404000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122062,
                "name": "Monroe",
                "latitude": "41.33065000",
                "longitude": "-74.18681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122080,
                "name": "Monroe County",
                "latitude": "43.16512000",
                "longitude": "-77.63626000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122089,
                "name": "Monsey",
                "latitude": "41.11121000",
                "longitude": "-74.06848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122103,
                "name": "Montauk",
                "latitude": "41.03594000",
                "longitude": "-71.95451000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122113,
                "name": "Montebello",
                "latitude": "41.13593000",
                "longitude": "-74.11848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122135,
                "name": "Montgomery",
                "latitude": "41.52759000",
                "longitude": "-74.23682000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122154,
                "name": "Montgomery County",
                "latitude": "42.90228000",
                "longitude": "-74.43968000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122169,
                "name": "Monticello",
                "latitude": "41.65565000",
                "longitude": "-74.68933000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122174,
                "name": "Montour Falls",
                "latitude": "42.34730000",
                "longitude": "-76.84524000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122182,
                "name": "Montrose",
                "latitude": "41.25232000",
                "longitude": "-73.93153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122223,
                "name": "Moravia",
                "latitude": "42.71257000",
                "longitude": "-76.42160000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122256,
                "name": "Moriches",
                "latitude": "40.80732000",
                "longitude": "-72.82121000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122258,
                "name": "Morningside Heights",
                "latitude": "40.81000000",
                "longitude": "-73.96250000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122272,
                "name": "Morris Heights",
                "latitude": "40.84982000",
                "longitude": "-73.91986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122273,
                "name": "Morris Park",
                "latitude": "40.85232000",
                "longitude": "-73.85347000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122275,
                "name": "Morrisania",
                "latitude": "40.82927000",
                "longitude": "-73.90653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122279,
                "name": "Morrisonville",
                "latitude": "44.69310000",
                "longitude": "-73.56208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122285,
                "name": "Morrisville",
                "latitude": "42.89868000",
                "longitude": "-75.64018000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122313,
                "name": "Mott Haven",
                "latitude": "40.80899000",
                "longitude": "-73.92291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122356,
                "name": "Mount Ivy",
                "latitude": "41.18676000",
                "longitude": "-74.03486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122360,
                "name": "Mount Kisco",
                "latitude": "41.20426000",
                "longitude": "-73.72708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122365,
                "name": "Mount Morris",
                "latitude": "42.72562000",
                "longitude": "-77.87417000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122389,
                "name": "Mount Sinai",
                "latitude": "40.94704000",
                "longitude": "-73.02955000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122402,
                "name": "Mount Vernon",
                "latitude": "40.91260000",
                "longitude": "-73.83708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122423,
                "name": "Mountain Lodge Park",
                "latitude": "41.38843000",
                "longitude": "-74.14181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122476,
                "name": "Munsey Park",
                "latitude": "40.79871000",
                "longitude": "-73.67985000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122477,
                "name": "Munsons Corners",
                "latitude": "42.58229000",
                "longitude": "-76.20910000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122516,
                "name": "Muttontown",
                "latitude": "40.82399000",
                "longitude": "-73.54763000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122517,
                "name": "Myers Corner",
                "latitude": "41.60620000",
                "longitude": "-73.87291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122545,
                "name": "Nanuet",
                "latitude": "41.08871000",
                "longitude": "-74.01347000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122548,
                "name": "Napanoch",
                "latitude": "41.74398000",
                "longitude": "-74.37154000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122554,
                "name": "Naples",
                "latitude": "42.61535000",
                "longitude": "-77.40249000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122580,
                "name": "Nassau",
                "latitude": "42.51591000",
                "longitude": "-73.61012000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122583,
                "name": "Nassau County",
                "latitude": "40.73217000",
                "longitude": "-73.58545000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122612,
                "name": "Nedrow",
                "latitude": "42.97507000",
                "longitude": "-76.14131000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122636,
                "name": "Neponsit",
                "latitude": "40.57177000",
                "longitude": "-73.86152000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122639,
                "name": "Nesconset",
                "latitude": "40.85204000",
                "longitude": "-73.15400000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122672,
                "name": "New Brighton",
                "latitude": "40.64233000",
                "longitude": "-74.09292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122682,
                "name": "New Cassel",
                "latitude": "40.75899000",
                "longitude": "-73.56957000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122695,
                "name": "New City",
                "latitude": "41.14760000",
                "longitude": "-73.98931000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122699,
                "name": "New Dorp",
                "latitude": "40.57399000",
                "longitude": "-74.11598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122700,
                "name": "New Dorp Beach",
                "latitude": "40.56538000",
                "longitude": "-74.10292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122712,
                "name": "New Hartford",
                "latitude": "43.07340000",
                "longitude": "-75.28767000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122720,
                "name": "New Hempstead",
                "latitude": "41.14982000",
                "longitude": "-74.03375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122729,
                "name": "New Hyde Park",
                "latitude": "40.73510000",
                "longitude": "-73.68791000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122759,
                "name": "New Paltz",
                "latitude": "41.74759000",
                "longitude": "-74.08681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122773,
                "name": "New Rochelle",
                "latitude": "40.91149000",
                "longitude": "-73.78235000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122781,
                "name": "New Springville",
                "latitude": "40.59344000",
                "longitude": "-74.16320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122782,
                "name": "New Square",
                "latitude": "41.13956000",
                "longitude": "-74.02942000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122794,
                "name": "New Windsor",
                "latitude": "41.47676000",
                "longitude": "-74.02375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122795,
                "name": "New York City",
                "latitude": "40.71427000",
                "longitude": "-74.00597000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122798,
                "name": "New York Mills",
                "latitude": "43.10535000",
                "longitude": "-75.29128000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122804,
                "name": "Newark",
                "latitude": "43.04673000",
                "longitude": "-77.09525000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122817,
                "name": "Newburgh",
                "latitude": "41.50343000",
                "longitude": "-74.01042000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122826,
                "name": "Newfane",
                "latitude": "43.28672000",
                "longitude": "-78.71031000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122881,
                "name": "Niagara County",
                "latitude": "43.17314000",
                "longitude": "-78.69095000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122882,
                "name": "Niagara Falls",
                "latitude": "43.09450000",
                "longitude": "-79.05671000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122906,
                "name": "Niskayuna",
                "latitude": "42.77980000",
                "longitude": "-73.84568000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122907,
                "name": "Nissequogue",
                "latitude": "40.90399000",
                "longitude": "-73.19789000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122910,
                "name": "Niverville",
                "latitude": "42.44092000",
                "longitude": "-73.66095000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122944,
                "name": "Norfolk",
                "latitude": "44.80089000",
                "longitude": "-74.99103000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122961,
                "name": "North Amityville",
                "latitude": "40.69760000",
                "longitude": "-73.42512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122971,
                "name": "North Babylon",
                "latitude": "40.71649000",
                "longitude": "-73.32179000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122972,
                "name": "North Ballston Spa",
                "latitude": "43.01969000",
                "longitude": "-73.85109000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122975,
                "name": "North Bay Shore",
                "latitude": "40.73621000",
                "longitude": "-73.26262000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122981,
                "name": "North Bellmore",
                "latitude": "40.69149000",
                "longitude": "-73.53346000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122982,
                "name": "North Bellport",
                "latitude": "40.77427000",
                "longitude": "-72.94288000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122991,
                "name": "North Boston",
                "latitude": "42.68562000",
                "longitude": "-78.77670000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123001,
                "name": "North Castle",
                "latitude": "41.14000000",
                "longitude": "-73.68389000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123008,
                "name": "North Collins",
                "latitude": "42.59534000",
                "longitude": "-78.94115000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123022,
                "name": "North Elba",
                "latitude": "44.24338000",
                "longitude": "-73.95431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123030,
                "name": "North Gates",
                "latitude": "43.17645000",
                "longitude": "-77.70139000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123032,
                "name": "North Great River",
                "latitude": "40.74732000",
                "longitude": "-73.16984000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123040,
                "name": "North Hills",
                "latitude": "40.78093000",
                "longitude": "-73.67652000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123058,
                "name": "North Lindenhurst",
                "latitude": "40.71427000",
                "longitude": "-73.38151000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123064,
                "name": "North Massapequa",
                "latitude": "40.70093000",
                "longitude": "-73.46207000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123065,
                "name": "North Merrick",
                "latitude": "40.69121000",
                "longitude": "-73.56318000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123071,
                "name": "North New Hyde Park",
                "latitude": "40.74316000",
                "longitude": "-73.69319000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123076,
                "name": "North Patchogue",
                "latitude": "40.78704000",
                "longitude": "-73.00900000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123103,
                "name": "North Sea",
                "latitude": "40.93288000",
                "longitude": "-72.41425000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123113,
                "name": "North Syracuse",
                "latitude": "43.13479000",
                "longitude": "-76.12992000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123115,
                "name": "North Tonawanda",
                "latitude": "43.03867000",
                "longitude": "-78.86420000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123120,
                "name": "North Valley Stream",
                "latitude": "40.68510000",
                "longitude": "-73.70180000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123124,
                "name": "North Wantagh",
                "latitude": "40.69343000",
                "longitude": "-73.50763000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123146,
                "name": "Northeast Ithaca",
                "latitude": "42.47032000",
                "longitude": "-76.46228000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123162,
                "name": "Northport",
                "latitude": "40.90093000",
                "longitude": "-73.34317000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123165,
                "name": "Northumberland",
                "latitude": "43.12730000",
                "longitude": "-73.58817000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123172,
                "name": "Northville",
                "latitude": "40.97010000",
                "longitude": "-72.61898000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123174,
                "name": "Northwest Harbor",
                "latitude": "41.00982000",
                "longitude": "-72.22119000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123178,
                "name": "Northwest Ithaca",
                "latitude": "42.47059000",
                "longitude": "-76.54145000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123196,
                "name": "Norwich",
                "latitude": "42.53118000",
                "longitude": "-75.52351000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123201,
                "name": "Norwood",
                "latitude": "44.75145000",
                "longitude": "-74.99436000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123213,
                "name": "Noyack",
                "latitude": "40.99566000",
                "longitude": "-72.34119000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123217,
                "name": "Nunda",
                "latitude": "42.57951000",
                "longitude": "-77.94250000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123221,
                "name": "Nyack",
                "latitude": "41.09065000",
                "longitude": "-73.91791000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123272,
                "name": "Oakdale",
                "latitude": "40.74399000",
                "longitude": "-73.13872000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123276,
                "name": "Oakfield",
                "latitude": "43.06589000",
                "longitude": "-78.26974000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123310,
                "name": "Oakwood",
                "latitude": "40.56399000",
                "longitude": "-74.11598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123343,
                "name": "Oceanside",
                "latitude": "40.63871000",
                "longitude": "-73.64013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123372,
                "name": "Ogdensburg",
                "latitude": "44.69423000",
                "longitude": "-75.48634000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123414,
                "name": "Olcott",
                "latitude": "43.33783000",
                "longitude": "-78.71476000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123415,
                "name": "Old Bethpage",
                "latitude": "40.76260000",
                "longitude": "-73.45318000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123417,
                "name": "Old Brookville",
                "latitude": "40.83204000",
                "longitude": "-73.60485000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123431,
                "name": "Old Westbury",
                "latitude": "40.78871000",
                "longitude": "-73.59957000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123435,
                "name": "Olean",
                "latitude": "42.07756000",
                "longitude": "-78.42974000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123473,
                "name": "Oneida",
                "latitude": "43.09257000",
                "longitude": "-75.65129000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123475,
                "name": "Oneida County",
                "latitude": "43.24175000",
                "longitude": "-75.43584000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123479,
                "name": "Oneonta",
                "latitude": "42.45286000",
                "longitude": "-75.06377000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123482,
                "name": "Onondaga County",
                "latitude": "43.00580000",
                "longitude": "-76.19464000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123485,
                "name": "Ontario",
                "latitude": "43.22090000",
                "longitude": "-77.28304000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123488,
                "name": "Ontario County",
                "latitude": "42.85285000",
                "longitude": "-77.29982000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123519,
                "name": "Orange County",
                "latitude": "41.40214000",
                "longitude": "-74.30557000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123524,
                "name": "Orange Lake",
                "latitude": "41.53982000",
                "longitude": "-74.09820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123527,
                "name": "Orangeburg",
                "latitude": "41.04649000",
                "longitude": "-73.94958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123538,
                "name": "Orchard Park",
                "latitude": "42.76756000",
                "longitude": "-78.74392000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123557,
                "name": "Oriskany",
                "latitude": "43.15729000",
                "longitude": "-75.33267000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123565,
                "name": "Orleans County",
                "latitude": "43.25070000",
                "longitude": "-78.18901000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123617,
                "name": "Ossining",
                "latitude": "41.16287000",
                "longitude": "-73.86152000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123623,
                "name": "Oswego",
                "latitude": "43.45535000",
                "longitude": "-76.51050000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123624,
                "name": "Oswego County",
                "latitude": "43.46389000",
                "longitude": "-76.20868000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123630,
                "name": "Otisville",
                "latitude": "41.47343000",
                "longitude": "-74.53849000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123635,
                "name": "Otsego County",
                "latitude": "42.63376000",
                "longitude": "-75.03261000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123660,
                "name": "Owego",
                "latitude": "42.10341000",
                "longitude": "-76.26215000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123687,
                "name": "Oxford",
                "latitude": "42.44202000",
                "longitude": "-75.59769000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123693,
                "name": "Oyster Bay",
                "latitude": "40.86565000",
                "longitude": "-73.53207000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123694,
                "name": "Oyster Bay Cove",
                "latitude": "40.87093000",
                "longitude": "-73.51096000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123702,
                "name": "Ozone Park",
                "latitude": "40.67677000",
                "longitude": "-73.84375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123727,
                "name": "Painted Post",
                "latitude": "42.16202000",
                "longitude": "-77.09414000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123733,
                "name": "Palenville",
                "latitude": "42.17453000",
                "longitude": "-74.02014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123776,
                "name": "Palmyra",
                "latitude": "43.06395000",
                "longitude": "-77.23332000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123854,
                "name": "Park Slope",
                "latitude": "40.67010000",
                "longitude": "-73.98597000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123856,
                "name": "Parkchester",
                "latitude": "40.83899000",
                "longitude": "-73.86041000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123910,
                "name": "Patchogue",
                "latitude": "40.76565000",
                "longitude": "-73.01511000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123932,
                "name": "Pawling",
                "latitude": "41.56204000",
                "longitude": "-73.60263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123957,
                "name": "Peach Lake",
                "latitude": "41.36759000",
                "longitude": "-73.57790000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123968,
                "name": "Pearl River",
                "latitude": "41.05899000",
                "longitude": "-74.02181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123984,
                "name": "Peekskill",
                "latitude": "41.29009000",
                "longitude": "-73.92042000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123992,
                "name": "Pelham",
                "latitude": "40.90982000",
                "longitude": "-73.80791000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123993,
                "name": "Pelham Manor",
                "latitude": "40.89538000",
                "longitude": "-73.80708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124026,
                "name": "Penn Yan",
                "latitude": "42.66090000",
                "longitude": "-77.05386000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124072,
                "name": "Perry",
                "latitude": "42.71562000",
                "longitude": "-78.00556000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124093,
                "name": "Perth",
                "latitude": "43.01757000",
                "longitude": "-74.19402000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124098,
                "name": "Peru",
                "latitude": "44.57838000",
                "longitude": "-73.52680000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124120,
                "name": "Phelps",
                "latitude": "42.95756000",
                "longitude": "-77.05747000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124127,
                "name": "Philadelphia",
                "latitude": "44.15450000",
                "longitude": "-75.70882000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124142,
                "name": "Philmont",
                "latitude": "42.24842000",
                "longitude": "-73.65318000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124147,
                "name": "Phoenix",
                "latitude": "43.23118000",
                "longitude": "-76.30076000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124177,
                "name": "Piermont",
                "latitude": "41.04204000",
                "longitude": "-73.91819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124216,
                "name": "Pine Bush",
                "latitude": "41.60815000",
                "longitude": "-74.29904000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124240,
                "name": "Pine Plains",
                "latitude": "41.97981000",
                "longitude": "-73.65596000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124302,
                "name": "Pittsford",
                "latitude": "43.09062000",
                "longitude": "-77.51500000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124317,
                "name": "Plainedge",
                "latitude": "40.71732000",
                "longitude": "-73.48374000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124330,
                "name": "Plainview",
                "latitude": "40.77649000",
                "longitude": "-73.46735000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124339,
                "name": "Plandome",
                "latitude": "40.80677000",
                "longitude": "-73.70346000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124340,
                "name": "Plandome Heights",
                "latitude": "40.80260000",
                "longitude": "-73.70430000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124356,
                "name": "Plattekill",
                "latitude": "41.61759000",
                "longitude": "-74.07598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124360,
                "name": "Plattsburgh",
                "latitude": "44.69949000",
                "longitude": "-73.45291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124361,
                "name": "Plattsburgh West",
                "latitude": "44.68315000",
                "longitude": "-73.50295000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124379,
                "name": "Pleasant Valley",
                "latitude": "41.74454000",
                "longitude": "-73.82124000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124388,
                "name": "Pleasantville",
                "latitude": "41.13287000",
                "longitude": "-73.79263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124423,
                "name": "Poestenkill",
                "latitude": "42.69036000",
                "longitude": "-73.56456000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124428,
                "name": "Point Lookout",
                "latitude": "40.59233000",
                "longitude": "-73.58068000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124458,
                "name": "Pomona",
                "latitude": "41.16704000",
                "longitude": "-74.04320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124500,
                "name": "Port Byron",
                "latitude": "43.03451000",
                "longitude": "-76.62383000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124503,
                "name": "Port Chester",
                "latitude": "41.00176000",
                "longitude": "-73.66568000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124504,
                "name": "Port Dickinson",
                "latitude": "42.13341000",
                "longitude": "-75.89631000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124506,
                "name": "Port Ewen",
                "latitude": "41.90537000",
                "longitude": "-73.97625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124509,
                "name": "Port Henry",
                "latitude": "44.04839000",
                "longitude": "-73.45985000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124513,
                "name": "Port Jefferson",
                "latitude": "40.94649000",
                "longitude": "-73.06927000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124514,
                "name": "Port Jefferson Station",
                "latitude": "40.92538000",
                "longitude": "-73.04733000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124515,
                "name": "Port Jervis",
                "latitude": "41.37509000",
                "longitude": "-74.69266000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124520,
                "name": "Port Morris",
                "latitude": "40.80149000",
                "longitude": "-73.90958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124530,
                "name": "Port Richmond",
                "latitude": "40.63316000",
                "longitude": "-74.13653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124539,
                "name": "Port Washington",
                "latitude": "40.82566000",
                "longitude": "-73.69819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124541,
                "name": "Port Washington North",
                "latitude": "40.84482000",
                "longitude": "-73.70180000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124563,
                "name": "Portland",
                "latitude": "42.37978000",
                "longitude": "-79.46755000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124588,
                "name": "Potsdam",
                "latitude": "44.66978000",
                "longitude": "-74.98131000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124602,
                "name": "Poughkeepsie",
                "latitude": "41.70037000",
                "longitude": "-73.92097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124605,
                "name": "Pound Ridge",
                "latitude": "41.20871000",
                "longitude": "-73.57485000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124735,
                "name": "Pulaski",
                "latitude": "43.56701000",
                "longitude": "-76.12770000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124755,
                "name": "Purchase",
                "latitude": "41.04093000",
                "longitude": "-73.71457000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124768,
                "name": "Putnam County",
                "latitude": "41.42666000",
                "longitude": "-73.74951000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124769,
                "name": "Putnam Lake",
                "latitude": "41.46204000",
                "longitude": "-73.54624000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124790,
                "name": "Queens",
                "latitude": "40.68149000",
                "longitude": "-73.83652000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124791,
                "name": "Queens County",
                "latitude": "40.65749000",
                "longitude": "-73.83875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124793,
                "name": "Queensbury",
                "latitude": "43.37729000",
                "longitude": "-73.61317000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124867,
                "name": "Randolph",
                "latitude": "42.16201000",
                "longitude": "-78.97532000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124889,
                "name": "Ransomville",
                "latitude": "43.23867000",
                "longitude": "-78.90976000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124897,
                "name": "Rapids",
                "latitude": "43.09839000",
                "longitude": "-78.64086000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124905,
                "name": "Ravena",
                "latitude": "42.46841000",
                "longitude": "-73.81624000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124948,
                "name": "Red Hook",
                "latitude": "41.99509000",
                "longitude": "-73.87541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124958,
                "name": "Red Oaks Mill",
                "latitude": "41.65565000",
                "longitude": "-73.87486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125002,
                "name": "Rego Park",
                "latitude": "40.72649000",
                "longitude": "-73.85264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125016,
                "name": "Remsenburg-Speonk",
                "latitude": "40.82642000",
                "longitude": "-72.69673000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125024,
                "name": "Rensselaer",
                "latitude": "42.64258000",
                "longitude": "-73.74290000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125025,
                "name": "Rensselaer County",
                "latitude": "42.71105000",
                "longitude": "-73.50972000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125045,
                "name": "Rhinebeck",
                "latitude": "41.92676000",
                "longitude": "-73.91264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125064,
                "name": "Richfield Springs",
                "latitude": "42.85341000",
                "longitude": "-74.98543000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125070,
                "name": "Richland",
                "latitude": "43.56951000",
                "longitude": "-76.04770000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125101,
                "name": "Richmond County",
                "latitude": "40.58344000",
                "longitude": "-74.14959000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125105,
                "name": "Richmond Hill",
                "latitude": "40.69983000",
                "longitude": "-73.83125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125114,
                "name": "Ridge",
                "latitude": "40.89399000",
                "longitude": "-72.89594000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125132,
                "name": "Ridgewood",
                "latitude": "40.70010000",
                "longitude": "-73.90569000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125195,
                "name": "Riverdale",
                "latitude": "40.90056000",
                "longitude": "-73.90639000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125200,
                "name": "Riverhead",
                "latitude": "40.91704000",
                "longitude": "-72.66204000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125207,
                "name": "Riverside",
                "latitude": "40.88121000",
                "longitude": "-72.67787000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125267,
                "name": "Rochester",
                "latitude": "43.15478000",
                "longitude": "-77.61556000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125281,
                "name": "Rock Hill",
                "latitude": "41.62593000",
                "longitude": "-74.59766000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125291,
                "name": "Rockaway Point",
                "latitude": "40.56066000",
                "longitude": "-73.91514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125310,
                "name": "Rockland County",
                "latitude": "41.15243000",
                "longitude": "-74.02409000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125325,
                "name": "Rockville Centre",
                "latitude": "40.65871000",
                "longitude": "-73.64124000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125338,
                "name": "Rocky Point",
                "latitude": "40.95260000",
                "longitude": "-72.92538000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125346,
                "name": "Roessleville",
                "latitude": "42.69508000",
                "longitude": "-73.80707000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125378,
                "name": "Rome",
                "latitude": "43.21285000",
                "longitude": "-75.45573000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125388,
                "name": "Ronkonkoma",
                "latitude": "40.81538000",
                "longitude": "-73.11233000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125391,
                "name": "Roosevelt",
                "latitude": "40.67871000",
                "longitude": "-73.58902000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125409,
                "name": "Rosebank",
                "latitude": "40.61399000",
                "longitude": "-74.06625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125418,
                "name": "Rosedale",
                "latitude": "40.66205000",
                "longitude": "-73.73541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125435,
                "name": "Rosendale Village",
                "latitude": "41.85038000",
                "longitude": "-74.07379000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125447,
                "name": "Roslyn",
                "latitude": "40.79982000",
                "longitude": "-73.65096000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125448,
                "name": "Roslyn Estates",
                "latitude": "40.79427000",
                "longitude": "-73.66041000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125449,
                "name": "Roslyn Harbor",
                "latitude": "40.81649000",
                "longitude": "-73.63707000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125450,
                "name": "Roslyn Heights",
                "latitude": "40.78871000",
                "longitude": "-73.64735000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125461,
                "name": "Rossville",
                "latitude": "40.55566000",
                "longitude": "-74.21348000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125468,
                "name": "Rotterdam",
                "latitude": "42.78702000",
                "longitude": "-73.97096000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125475,
                "name": "Rouses Point",
                "latitude": "44.99393000",
                "longitude": "-73.36486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125562,
                "name": "Rye",
                "latitude": "40.98065000",
                "longitude": "-73.68374000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125563,
                "name": "Rye Brook",
                "latitude": "41.01926000",
                "longitude": "-73.68346000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125575,
                "name": "Sackets Harbor",
                "latitude": "43.94617000",
                "longitude": "-76.11909000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125584,
                "name": "Sag Harbor",
                "latitude": "40.99788000",
                "longitude": "-72.29258000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125609,
                "name": "Saint Bonaventure",
                "latitude": "42.08034000",
                "longitude": "-78.47502000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125656,
                "name": "Saint James",
                "latitude": "40.87899000",
                "longitude": "-73.15678000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125669,
                "name": "Saint Johnsville",
                "latitude": "42.99813000",
                "longitude": "-74.68292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125723,
                "name": "Salamanca",
                "latitude": "42.15784000",
                "longitude": "-78.71503000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125759,
                "name": "Salisbury",
                "latitude": "40.74566000",
                "longitude": "-73.56013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125854,
                "name": "Sanborn",
                "latitude": "43.13672000",
                "longitude": "-78.88476000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125872,
                "name": "Sands Point",
                "latitude": "40.85177000",
                "longitude": "-73.71874000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125936,
                "name": "Saranac Lake",
                "latitude": "44.32950000",
                "longitude": "-74.13127000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125943,
                "name": "Saratoga County",
                "latitude": "43.10738000",
                "longitude": "-73.86390000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125944,
                "name": "Saratoga Springs",
                "latitude": "43.08313000",
                "longitude": "-73.78457000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125959,
                "name": "Saugerties",
                "latitude": "42.07759000",
                "longitude": "-73.95291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125960,
                "name": "Saugerties South",
                "latitude": "42.06139000",
                "longitude": "-73.95067000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125993,
                "name": "Sayville",
                "latitude": "40.73593000",
                "longitude": "-73.08206000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125998,
                "name": "Scarsdale",
                "latitude": "41.00510000",
                "longitude": "-73.78458000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126003,
                "name": "Schenectady",
                "latitude": "42.81424000",
                "longitude": "-73.93957000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126004,
                "name": "Schenectady County",
                "latitude": "42.81812000",
                "longitude": "-74.05857000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126015,
                "name": "Schoharie",
                "latitude": "42.66591000",
                "longitude": "-74.30958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126016,
                "name": "Schoharie County",
                "latitude": "42.58822000",
                "longitude": "-74.44212000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126024,
                "name": "Schuyler County",
                "latitude": "42.39380000",
                "longitude": "-76.87518000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126025,
                "name": "Schuylerville",
                "latitude": "43.10008000",
                "longitude": "-73.58178000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126033,
                "name": "Scotchtown",
                "latitude": "41.48148000",
                "longitude": "-74.36015000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126034,
                "name": "Scotia",
                "latitude": "42.82647000",
                "longitude": "-73.96429000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126065,
                "name": "Scottsville",
                "latitude": "43.02590000",
                "longitude": "-77.74528000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126072,
                "name": "Sea Cliff",
                "latitude": "40.84899000",
                "longitude": "-73.64485000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126086,
                "name": "Seaford",
                "latitude": "40.66593000",
                "longitude": "-73.48818000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126094,
                "name": "Searingtown",
                "latitude": "40.77482000",
                "longitude": "-73.65568000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126098,
                "name": "Seaside",
                "latitude": "40.58316000",
                "longitude": "-73.82819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126133,
                "name": "Selden",
                "latitude": "40.86649000",
                "longitude": "-73.03566000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126159,
                "name": "Seneca County",
                "latitude": "42.78108000",
                "longitude": "-76.82378000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126160,
                "name": "Seneca Falls",
                "latitude": "42.91062000",
                "longitude": "-76.79662000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126161,
                "name": "Seneca Knolls",
                "latitude": "43.12007000",
                "longitude": "-76.28632000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126169,
                "name": "Setauket-East Setauket",
                "latitude": "40.93064000",
                "longitude": "-73.10179000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126258,
                "name": "Sheepshead Bay",
                "latitude": "40.59122000",
                "longitude": "-73.94458000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126295,
                "name": "Shelter Island",
                "latitude": "41.06815000",
                "longitude": "-72.33869000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126296,
                "name": "Shelter Island Heights",
                "latitude": "41.08399000",
                "longitude": "-72.35592000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126308,
                "name": "Shenorock",
                "latitude": "41.33176000",
                "longitude": "-73.73819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126315,
                "name": "Sherburne",
                "latitude": "42.67813000",
                "longitude": "-75.49851000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126338,
                "name": "Sherrill",
                "latitude": "43.07368000",
                "longitude": "-75.59824000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126354,
                "name": "Shinnecock Hills",
                "latitude": "40.89093000",
                "longitude": "-72.46370000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126361,
                "name": "Shirley",
                "latitude": "40.80149000",
                "longitude": "-72.86760000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126366,
                "name": "Shokan",
                "latitude": "41.97343000",
                "longitude": "-74.21209000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126378,
                "name": "Shortsville",
                "latitude": "42.95590000",
                "longitude": "-77.22081000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126387,
                "name": "Shrub Oak",
                "latitude": "41.32759000",
                "longitude": "-73.81958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126397,
                "name": "Sidney",
                "latitude": "42.31480000",
                "longitude": "-75.39157000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126423,
                "name": "Silver Creek",
                "latitude": "42.54423000",
                "longitude": "-79.16671000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126477,
                "name": "Skaneateles",
                "latitude": "42.94701000",
                "longitude": "-76.42910000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126498,
                "name": "Sleepy Hollow",
                "latitude": "41.08565000",
                "longitude": "-73.85847000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126504,
                "name": "Sloan",
                "latitude": "42.89339000",
                "longitude": "-78.79392000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126505,
                "name": "Sloatsburg",
                "latitude": "41.15454000",
                "longitude": "-74.19292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126526,
                "name": "Smithtown",
                "latitude": "40.85593000",
                "longitude": "-73.20067000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126564,
                "name": "Sodus",
                "latitude": "43.23784000",
                "longitude": "-77.06136000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126573,
                "name": "Solvay",
                "latitude": "43.05812000",
                "longitude": "-76.20743000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126609,
                "name": "Sound Beach",
                "latitude": "40.95621000",
                "longitude": "-72.96788000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126620,
                "name": "South Beach",
                "latitude": "40.58329000",
                "longitude": "-74.07609000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126627,
                "name": "South Blooming Grove",
                "latitude": "41.37337000",
                "longitude": "-74.17843000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126643,
                "name": "South Corning",
                "latitude": "42.12174000",
                "longitude": "-77.03719000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126653,
                "name": "South Fallsburg",
                "latitude": "41.72065000",
                "longitude": "-74.63433000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126654,
                "name": "South Farmingdale",
                "latitude": "40.72066000",
                "longitude": "-73.44012000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126655,
                "name": "South Floral Park",
                "latitude": "40.71427000",
                "longitude": "-73.70013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126661,
                "name": "South Glens Falls",
                "latitude": "43.29924000",
                "longitude": "-73.63512000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126668,
                "name": "South Hempstead",
                "latitude": "40.68094000",
                "longitude": "-73.61541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126672,
                "name": "South Hill",
                "latitude": "42.42924000",
                "longitude": "-76.49494000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126677,
                "name": "South Huntington",
                "latitude": "40.82371000",
                "longitude": "-73.39873000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126689,
                "name": "South Lockport",
                "latitude": "43.15006000",
                "longitude": "-78.69670000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126695,
                "name": "South Nyack",
                "latitude": "41.08315000",
                "longitude": "-73.92014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126741,
                "name": "South Valley Stream",
                "latitude": "40.65594000",
                "longitude": "-73.71763000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126758,
                "name": "Southampton",
                "latitude": "40.88427000",
                "longitude": "-72.38953000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126781,
                "name": "Southold",
                "latitude": "41.06482000",
                "longitude": "-72.42620000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126785,
                "name": "Southport",
                "latitude": "42.05480000",
                "longitude": "-76.81912000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126794,
                "name": "Spackenkill",
                "latitude": "41.65593000",
                "longitude": "-73.91347000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126802,
                "name": "Sparkill",
                "latitude": "41.03121000",
                "longitude": "-73.92708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126830,
                "name": "Spencerport",
                "latitude": "43.18645000",
                "longitude": "-77.80390000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126877,
                "name": "Spring Valley",
                "latitude": "41.11315000",
                "longitude": "-74.04375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126903,
                "name": "Springfield",
                "latitude": "42.83618000",
                "longitude": "-74.85348000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126908,
                "name": "Springfield Gardens",
                "latitude": "40.66312000",
                "longitude": "-73.76221000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126910,
                "name": "Springs",
                "latitude": "41.01621000",
                "longitude": "-72.15924000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126917,
                "name": "Springville",
                "latitude": "42.50840000",
                "longitude": "-78.66725000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126923,
                "name": "Spuyten Duyvil",
                "latitude": "40.88121000",
                "longitude": "-73.91736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126927,
                "name": "St. Lawrence County",
                "latitude": "44.50062000",
                "longitude": "-75.11631000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126945,
                "name": "Stamford",
                "latitude": "42.40730000",
                "longitude": "-74.61432000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126976,
                "name": "Stapleton",
                "latitude": "40.62649000",
                "longitude": "-74.07764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126995,
                "name": "Staten Island",
                "latitude": "40.56233000",
                "longitude": "-74.13986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127019,
                "name": "Steinway",
                "latitude": "40.77455000",
                "longitude": "-73.90375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127039,
                "name": "Steuben County",
                "latitude": "42.26781000",
                "longitude": "-77.38380000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127052,
                "name": "Stewart Manor",
                "latitude": "40.71927000",
                "longitude": "-73.68846000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127062,
                "name": "Stillwater",
                "latitude": "42.93841000",
                "longitude": "-73.65317000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127085,
                "name": "Stone Ridge",
                "latitude": "41.85315000",
                "longitude": "-74.13903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127096,
                "name": "Stony Brook",
                "latitude": "40.92565000",
                "longitude": "-73.14094000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127100,
                "name": "Stony Point",
                "latitude": "41.22954000",
                "longitude": "-73.98708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127108,
                "name": "Stottville",
                "latitude": "42.28620000",
                "longitude": "-73.73873000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127164,
                "name": "Suffern",
                "latitude": "41.11482000",
                "longitude": "-74.14959000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127168,
                "name": "Suffolk County",
                "latitude": "40.94046000",
                "longitude": "-72.68524000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127190,
                "name": "Sullivan County",
                "latitude": "41.71642000",
                "longitude": "-74.76814000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127258,
                "name": "Sunnyside",
                "latitude": "40.73982000",
                "longitude": "-73.93542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127276,
                "name": "Sunset Park",
                "latitude": "40.64548000",
                "longitude": "-74.01241000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127356,
                "name": "Sylvan Beach",
                "latitude": "42.46479000",
                "longitude": "-77.10830000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127362,
                "name": "Syosset",
                "latitude": "40.82621000",
                "longitude": "-73.50207000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127365,
                "name": "Syracuse",
                "latitude": "43.04812000",
                "longitude": "-76.14742000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127426,
                "name": "Tappan",
                "latitude": "41.02204000",
                "longitude": "-73.94736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127436,
                "name": "Tarrytown",
                "latitude": "41.07621000",
                "longitude": "-73.85875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127517,
                "name": "Terrace Heights",
                "latitude": "40.72149000",
                "longitude": "-73.76930000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127536,
                "name": "Terryville",
                "latitude": "40.90899000",
                "longitude": "-73.06511000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127554,
                "name": "The Bronx",
                "latitude": "40.84985000",
                "longitude": "-73.86641000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127575,
                "name": "Thiells",
                "latitude": "41.21065000",
                "longitude": "-74.01764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127586,
                "name": "Thomaston",
                "latitude": "40.78621000",
                "longitude": "-73.71374000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127606,
                "name": "Thornwood",
                "latitude": "41.12343000",
                "longitude": "-73.77902000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127625,
                "name": "Throgs Neck",
                "latitude": "40.82260000",
                "longitude": "-73.81958000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127635,
                "name": "Ticonderoga",
                "latitude": "43.84867000",
                "longitude": "-73.42345000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127652,
                "name": "Tillson",
                "latitude": "41.82898000",
                "longitude": "-74.06848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127669,
                "name": "Tioga County",
                "latitude": "42.17030000",
                "longitude": "-76.30632000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127688,
                "name": "Tivoli",
                "latitude": "42.05842000",
                "longitude": "-73.90930000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127713,
                "name": "Tompkins County",
                "latitude": "42.45202000",
                "longitude": "-76.47366000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127715,
                "name": "Tompkinsville",
                "latitude": "40.63812000",
                "longitude": "-74.07795000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127718,
                "name": "Tonawanda",
                "latitude": "43.02033000",
                "longitude": "-78.88031000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127758,
                "name": "Town Line",
                "latitude": "42.89061000",
                "longitude": "-78.57780000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127795,
                "name": "Tremont",
                "latitude": "40.84954000",
                "longitude": "-73.90569000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127819,
                "name": "Tribes Hill",
                "latitude": "42.95535000",
                "longitude": "-74.28513000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127851,
                "name": "Troy",
                "latitude": "42.72841000",
                "longitude": "-73.69179000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127857,
                "name": "Trumansburg",
                "latitude": "42.54229000",
                "longitude": "-76.66606000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127869,
                "name": "Tuckahoe",
                "latitude": "40.95038000",
                "longitude": "-73.82736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127898,
                "name": "Tupper Lake",
                "latitude": "44.22395000",
                "longitude": "-74.46406000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127959,
                "name": "Ulster County",
                "latitude": "41.88815000",
                "longitude": "-74.25857000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127965,
                "name": "Unadilla",
                "latitude": "42.32536000",
                "longitude": "-75.31240000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128012,
                "name": "Union Springs",
                "latitude": "42.83979000",
                "longitude": "-76.69328000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128013,
                "name": "Uniondale",
                "latitude": "40.70038000",
                "longitude": "-73.59291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128014,
                "name": "Unionport",
                "latitude": "40.82732000",
                "longitude": "-73.85013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128028,
                "name": "University Gardens",
                "latitude": "40.77732000",
                "longitude": "-73.72263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128030,
                "name": "University Heights",
                "latitude": "40.86010000",
                "longitude": "-73.90930000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128042,
                "name": "Upper Brookville",
                "latitude": "40.83871000",
                "longitude": "-73.56513000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128048,
                "name": "Upper Nyack",
                "latitude": "41.10704000",
                "longitude": "-73.92014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128067,
                "name": "Utica",
                "latitude": "43.10090000",
                "longitude": "-75.23266000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128077,
                "name": "Vails Gate",
                "latitude": "41.45426000",
                "longitude": "-74.05764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128081,
                "name": "Valatie",
                "latitude": "42.41342000",
                "longitude": "-73.67317000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128092,
                "name": "Valhalla",
                "latitude": "41.07482000",
                "longitude": "-73.77513000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128102,
                "name": "Valley Cottage",
                "latitude": "41.11815000",
                "longitude": "-73.95542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128117,
                "name": "Valley Stream",
                "latitude": "40.66427000",
                "longitude": "-73.70846000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128136,
                "name": "Van Nest",
                "latitude": "40.84843000",
                "longitude": "-73.86375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128190,
                "name": "Vernon",
                "latitude": "43.07951000",
                "longitude": "-75.53934000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128207,
                "name": "Verplanck",
                "latitude": "41.25287000",
                "longitude": "-73.95986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128217,
                "name": "Victor",
                "latitude": "42.98256000",
                "longitude": "-77.40888000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128247,
                "name": "Village Green",
                "latitude": "43.13340000",
                "longitude": "-76.31299000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128254,
                "name": "Village of the Branch",
                "latitude": "40.85621000",
                "longitude": "-73.18733000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128283,
                "name": "Viola",
                "latitude": "41.13648000",
                "longitude": "-74.08236000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128301,
                "name": "Volney",
                "latitude": "43.34285000",
                "longitude": "-76.35771000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128307,
                "name": "Voorheesville",
                "latitude": "42.65397000",
                "longitude": "-73.92874000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128324,
                "name": "Wading River",
                "latitude": "40.95038000",
                "longitude": "-72.84260000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128363,
                "name": "Wakefield",
                "latitude": "40.89788000",
                "longitude": "-73.85236000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128368,
                "name": "Walden",
                "latitude": "41.56120000",
                "longitude": "-74.18848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128410,
                "name": "Wallkill",
                "latitude": "41.60565000",
                "longitude": "-74.18404000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128436,
                "name": "Walton",
                "latitude": "42.16953000",
                "longitude": "-75.12934000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128439,
                "name": "Walton Park",
                "latitude": "41.30982000",
                "longitude": "-74.22904000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128445,
                "name": "Wampsville",
                "latitude": "43.07535000",
                "longitude": "-75.70685000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128446,
                "name": "Wanakah",
                "latitude": "42.74617000",
                "longitude": "-78.90309000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128452,
                "name": "Wantagh",
                "latitude": "40.68371000",
                "longitude": "-73.51013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128456,
                "name": "Wappingers Falls",
                "latitude": "41.59648000",
                "longitude": "-73.91097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128497,
                "name": "Warren County",
                "latitude": "43.56098000",
                "longitude": "-73.84601000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128503,
                "name": "Warrensburg",
                "latitude": "43.49674000",
                "longitude": "-73.77623000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128521,
                "name": "Warsaw",
                "latitude": "42.74006000",
                "longitude": "-78.13279000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128524,
                "name": "Warwick",
                "latitude": "41.25648000",
                "longitude": "-74.35988000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128572,
                "name": "Washington County",
                "latitude": "43.31370000",
                "longitude": "-73.43076000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128581,
                "name": "Washington Heights",
                "latitude": "40.85010000",
                "longitude": "-73.93541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128582,
                "name": "Washington Mills",
                "latitude": "43.05007000",
                "longitude": "-75.27294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128588,
                "name": "Washingtonville",
                "latitude": "41.42787000",
                "longitude": "-74.16598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128597,
                "name": "Watchtower",
                "latitude": "41.63776000",
                "longitude": "-74.26027000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128599,
                "name": "Water Mill",
                "latitude": "40.91959000",
                "longitude": "-72.34274000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128606,
                "name": "Waterford",
                "latitude": "42.79258000",
                "longitude": "-73.68123000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128615,
                "name": "Waterloo",
                "latitude": "42.90479000",
                "longitude": "-76.86274000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128623,
                "name": "Watertown",
                "latitude": "43.97478000",
                "longitude": "-75.91076000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128628,
                "name": "Waterville",
                "latitude": "42.93118000",
                "longitude": "-75.37989000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128630,
                "name": "Watervliet",
                "latitude": "42.73008000",
                "longitude": "-73.70123000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128634,
                "name": "Watkins Glen",
                "latitude": "42.38063000",
                "longitude": "-76.87329000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128672,
                "name": "Waverly",
                "latitude": "42.01035000",
                "longitude": "-76.52717000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128673,
                "name": "Wawarsing",
                "latitude": "41.75898000",
                "longitude": "-74.35738000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128677,
                "name": "Wayland",
                "latitude": "42.56784000",
                "longitude": "-77.58971000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128701,
                "name": "Wayne County",
                "latitude": "43.06588000",
                "longitude": "-76.97845000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128733,
                "name": "Webster",
                "latitude": "43.21229000",
                "longitude": "-77.42999000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128753,
                "name": "Weedsport",
                "latitude": "43.04868000",
                "longitude": "-76.56272000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128793,
                "name": "Wellsville",
                "latitude": "42.12201000",
                "longitude": "-77.94806000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128811,
                "name": "Wesley Hills",
                "latitude": "41.15926000",
                "longitude": "-74.06986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128816,
                "name": "West Albany",
                "latitude": "42.68313000",
                "longitude": "-73.77845000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128819,
                "name": "West Babylon",
                "latitude": "40.71816000",
                "longitude": "-73.35429000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128823,
                "name": "West Bay Shore",
                "latitude": "40.70871000",
                "longitude": "-73.28123000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128843,
                "name": "West Carthage",
                "latitude": "43.97423000",
                "longitude": "-75.61519000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128861,
                "name": "West Elmira",
                "latitude": "42.07813000",
                "longitude": "-76.84524000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128863,
                "name": "West End",
                "latitude": "42.46869000",
                "longitude": "-75.09378000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128879,
                "name": "West Glens Falls",
                "latitude": "43.30007000",
                "longitude": "-73.68401000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128891,
                "name": "West Haverstraw",
                "latitude": "41.20954000",
                "longitude": "-73.98542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128894,
                "name": "West Hempstead",
                "latitude": "40.70482000",
                "longitude": "-73.65013000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128895,
                "name": "West Hills",
                "latitude": "40.81621000",
                "longitude": "-73.43234000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128901,
                "name": "West Hurley",
                "latitude": "41.99731000",
                "longitude": "-74.10486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128903,
                "name": "West Islip",
                "latitude": "40.70621000",
                "longitude": "-73.30623000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128942,
                "name": "West Nyack",
                "latitude": "41.09649000",
                "longitude": "-73.97292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128962,
                "name": "West Point",
                "latitude": "41.39148000",
                "longitude": "-73.95597000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128975,
                "name": "West Sand Lake",
                "latitude": "42.64341000",
                "longitude": "-73.60873000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128976,
                "name": "West Sayville",
                "latitude": "40.72788000",
                "longitude": "-73.09761000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128979,
                "name": "West Seneca",
                "latitude": "42.85006000",
                "longitude": "-78.79975000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129015,
                "name": "Westbury",
                "latitude": "40.75566000",
                "longitude": "-73.58763000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129020,
                "name": "Westchester County",
                "latitude": "41.15148000",
                "longitude": "-73.75339000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129022,
                "name": "Westerleigh",
                "latitude": "40.62121000",
                "longitude": "-74.13181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129030,
                "name": "Westfield",
                "latitude": "42.32228000",
                "longitude": "-79.57810000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129035,
                "name": "Westhampton",
                "latitude": "40.82454000",
                "longitude": "-72.66621000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129036,
                "name": "Westhampton Beach",
                "latitude": "40.80316000",
                "longitude": "-72.61454000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129042,
                "name": "Westmere",
                "latitude": "42.69119000",
                "longitude": "-73.86873000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129066,
                "name": "Weston Mills",
                "latitude": "42.07590000",
                "longitude": "-78.37252000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129074,
                "name": "Westvale",
                "latitude": "43.04757000",
                "longitude": "-76.22048000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129111,
                "name": "Wheatley Heights",
                "latitude": "40.76371000",
                "longitude": "-73.36984000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129155,
                "name": "White Plains",
                "latitude": "41.03399000",
                "longitude": "-73.76291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129169,
                "name": "Whitehall",
                "latitude": "43.55562000",
                "longitude": "-73.40372000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129183,
                "name": "Whitesboro",
                "latitude": "43.12201000",
                "longitude": "-75.29156000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129187,
                "name": "Whitestone",
                "latitude": "40.79455000",
                "longitude": "-73.81847000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129270,
                "name": "Williamsburg",
                "latitude": "40.71427000",
                "longitude": "-73.95347000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129274,
                "name": "Williamson",
                "latitude": "43.22395000",
                "longitude": "-77.18609000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129292,
                "name": "Williamsville",
                "latitude": "42.96395000",
                "longitude": "-78.73781000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129301,
                "name": "Williston Park",
                "latitude": "40.75649000",
                "longitude": "-73.64485000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129314,
                "name": "Willowbrook",
                "latitude": "40.60316000",
                "longitude": "-74.13848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129331,
                "name": "Wilson",
                "latitude": "43.30978000",
                "longitude": "-78.82615000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129469,
                "name": "Wolcott",
                "latitude": "43.22062000",
                "longitude": "-76.81496000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129510,
                "name": "Woodbury",
                "latitude": "41.36454000",
                "longitude": "-74.10598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129522,
                "name": "Woodhaven",
                "latitude": "40.68927000",
                "longitude": "-73.85791000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129537,
                "name": "Woodlawn",
                "latitude": "40.89816000",
                "longitude": "-73.86736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129541,
                "name": "Woodmere",
                "latitude": "40.63205000",
                "longitude": "-73.71263000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129546,
                "name": "Woodrow",
                "latitude": "40.54344000",
                "longitude": "-74.19764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129554,
                "name": "Woodside",
                "latitude": "40.74538000",
                "longitude": "-73.90541000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129565,
                "name": "Woodstock",
                "latitude": "42.04092000",
                "longitude": "-74.11820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129585,
                "name": "Worcester",
                "latitude": "42.59146000",
                "longitude": "-74.75043000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129619,
                "name": "Wurtsboro",
                "latitude": "41.57676000",
                "longitude": "-74.48710000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129620,
                "name": "Wyandanch",
                "latitude": "40.75399000",
                "longitude": "-73.36040000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129624,
                "name": "Wykagyl",
                "latitude": "40.94149000",
                "longitude": "-73.79902000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129628,
                "name": "Wynantskill",
                "latitude": "42.69675000",
                "longitude": "-73.64428000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129640,
                "name": "Wyoming County",
                "latitude": "42.70238000",
                "longitude": "-78.22444000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129663,
                "name": "Yaphank",
                "latitude": "40.83677000",
                "longitude": "-72.91705000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129671,
                "name": "Yates County",
                "latitude": "42.63344000",
                "longitude": "-77.10546000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129688,
                "name": "Yonkers",
                "latitude": "40.93121000",
                "longitude": "-73.89875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129704,
                "name": "Yorkshire",
                "latitude": "42.53006000",
                "longitude": "-78.47280000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129708,
                "name": "Yorktown Heights",
                "latitude": "41.27093000",
                "longitude": "-73.77763000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129710,
                "name": "Yorkville",
                "latitude": "43.11285000",
                "longitude": "-75.27100000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129717,
                "name": "Youngstown",
                "latitude": "43.24728000",
                "longitude": "-79.05005000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129748,
                "name": "Zena",
                "latitude": "42.01676000",
                "longitude": "-74.07625000",
                "timezone": "America\/New_York"
            }
        ]
    },
    {
        "id": 1416,
        "name": "California",
        "stateCode": "CA",
        "iso3166_2": "US-CA",
        "native": "California",
        "latitude": "36.70146310",
        "longitude": "-118.75599700",
        "type": "state",
        "timezone": "America\/Los_Angeles",
        "cities": [
            {
                "id": 110992,
                "name": "Acalanes Ridge",
                "latitude": "37.90472000",
                "longitude": "-122.07857000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111001,
                "name": "Acton",
                "latitude": "34.46999000",
                "longitude": "-118.19674000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111043,
                "name": "Adelanto",
                "latitude": "34.58277000",
                "longitude": "-117.40922000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111056,
                "name": "Agoura",
                "latitude": "34.14306000",
                "longitude": "-118.73787000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111057,
                "name": "Agoura Hills",
                "latitude": "34.13639000",
                "longitude": "-118.77453000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111058,
                "name": "Agua Dulce",
                "latitude": "34.49638000",
                "longitude": "-118.32563000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111061,
                "name": "Aguanga",
                "latitude": "33.44281000",
                "longitude": "-116.86502000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111064,
                "name": "Ahwahnee",
                "latitude": "37.36550000",
                "longitude": "-119.72627000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111088,
                "name": "Alameda",
                "latitude": "37.76521000",
                "longitude": "-122.24164000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111089,
                "name": "Alameda County",
                "latitude": "37.65055000",
                "longitude": "-121.91789000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111093,
                "name": "Alamo",
                "latitude": "37.85020000",
                "longitude": "-122.03218000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111110,
                "name": "Albany",
                "latitude": "37.88687000",
                "longitude": "-122.29775000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111169,
                "name": "Alhambra",
                "latitude": "34.09529000",
                "longitude": "-118.12701000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111175,
                "name": "Aliso Viejo",
                "latitude": "33.56504000",
                "longitude": "-117.72712000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111196,
                "name": "Allendale",
                "latitude": "38.44463000",
                "longitude": "-121.94302000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111215,
                "name": "Alondra Park",
                "latitude": "33.88946000",
                "longitude": "-118.33091000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111217,
                "name": "Alpaugh",
                "latitude": "35.88773000",
                "longitude": "-119.48734000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111223,
                "name": "Alpine",
                "latitude": "32.83505000",
                "longitude": "-116.76641000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111226,
                "name": "Alpine County",
                "latitude": "38.59725000",
                "longitude": "-119.82065000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111230,
                "name": "Alta Sierra",
                "latitude": "35.73126000",
                "longitude": "-118.55390000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111231,
                "name": "Altadena",
                "latitude": "34.18973000",
                "longitude": "-118.13118000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111251,
                "name": "Alturas",
                "latitude": "41.48714000",
                "longitude": "-120.54349000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111254,
                "name": "Alum Rock",
                "latitude": "37.36605000",
                "longitude": "-121.82718000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111261,
                "name": "Amador County",
                "latitude": "38.44639000",
                "longitude": "-120.65112000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111271,
                "name": "American Canyon",
                "latitude": "38.17492000",
                "longitude": "-122.26080000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111280,
                "name": "Amesti",
                "latitude": "36.96356000",
                "longitude": "-121.77912000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111299,
                "name": "Anaheim",
                "latitude": "33.83529000",
                "longitude": "-117.91450000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111314,
                "name": "Anderson",
                "latitude": "40.44821000",
                "longitude": "-122.29778000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111337,
                "name": "Angels Camp",
                "latitude": "38.06826000",
                "longitude": "-120.53965000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111343,
                "name": "Angwin",
                "latitude": "38.57574000",
                "longitude": "-122.44998000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111364,
                "name": "Antelope",
                "latitude": "38.70824000",
                "longitude": "-121.32995000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111373,
                "name": "Antioch",
                "latitude": "38.00492000",
                "longitude": "-121.80579000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111378,
                "name": "Anza",
                "latitude": "33.55503000",
                "longitude": "-116.67363000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111394,
                "name": "Apple Valley",
                "latitude": "34.50083000",
                "longitude": "-117.18588000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111403,
                "name": "Aptos",
                "latitude": "36.97717000",
                "longitude": "-121.89940000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111404,
                "name": "Aptos Hills-Larkin Valley",
                "latitude": "36.96064000",
                "longitude": "-121.83404000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111416,
                "name": "Arbuckle",
                "latitude": "39.01740000",
                "longitude": "-122.05775000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111425,
                "name": "Arcadia",
                "latitude": "34.13973000",
                "longitude": "-118.03534000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111426,
                "name": "Arcata",
                "latitude": "40.86652000",
                "longitude": "-124.08284000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111440,
                "name": "Arden-Arcade",
                "latitude": "38.60250000",
                "longitude": "-121.37854000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111477,
                "name": "Armona",
                "latitude": "36.31578000",
                "longitude": "-119.70846000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111488,
                "name": "Arnold",
                "latitude": "38.25547000",
                "longitude": "-120.35103000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111491,
                "name": "Aromas",
                "latitude": "36.88856000",
                "longitude": "-121.64300000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111494,
                "name": "Arroyo Grande",
                "latitude": "35.11859000",
                "longitude": "-120.59073000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111496,
                "name": "Artesia",
                "latitude": "33.86585000",
                "longitude": "-118.08312000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111505,
                "name": "Arvin",
                "latitude": "35.20913000",
                "longitude": "-118.82843000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111538,
                "name": "Ashland",
                "latitude": "37.69465000",
                "longitude": "-122.11385000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111564,
                "name": "Atascadero",
                "latitude": "35.48942000",
                "longitude": "-120.67073000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111582,
                "name": "Atherton",
                "latitude": "37.46133000",
                "longitude": "-122.19774000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111613,
                "name": "Atwater",
                "latitude": "37.34772000",
                "longitude": "-120.60908000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111617,
                "name": "Auberry",
                "latitude": "37.08078000",
                "longitude": "-119.48541000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111631,
                "name": "Auburn",
                "latitude": "38.89657000",
                "longitude": "-121.07689000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111635,
                "name": "Auburn Lake Trails",
                "latitude": "38.91434000",
                "longitude": "-120.95244000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111644,
                "name": "August",
                "latitude": "37.97881000",
                "longitude": "-121.26217000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111675,
                "name": "Avalon",
                "latitude": "33.34281000",
                "longitude": "-118.32785000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111676,
                "name": "Avenal",
                "latitude": "36.00412000",
                "longitude": "-120.12903000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111683,
                "name": "Avila Beach",
                "latitude": "35.17998000",
                "longitude": "-120.73184000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111689,
                "name": "Avocado Heights",
                "latitude": "34.03612000",
                "longitude": "-117.99118000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111713,
                "name": "Azusa",
                "latitude": "34.13362000",
                "longitude": "-117.90756000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111744,
                "name": "Bakersfield",
                "latitude": "35.37329000",
                "longitude": "-119.01871000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111763,
                "name": "Baldwin Park",
                "latitude": "34.08529000",
                "longitude": "-117.96090000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111803,
                "name": "Banning",
                "latitude": "33.92557000",
                "longitude": "-116.87641000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111857,
                "name": "Barstow",
                "latitude": "34.89859000",
                "longitude": "-117.02282000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111858,
                "name": "Barstow Heights",
                "latitude": "34.86971000",
                "longitude": "-117.05615000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111932,
                "name": "Bay Point",
                "latitude": "38.02909000",
                "longitude": "-121.96163000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111957,
                "name": "Bayside",
                "latitude": "40.84235000",
                "longitude": "-124.06367000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111959,
                "name": "Bayview",
                "latitude": "40.77263000",
                "longitude": "-124.18395000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111971,
                "name": "Beale Air Force Base",
                "latitude": "39.10917000",
                "longitude": "-121.35444000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111979,
                "name": "Bear Valley Springs",
                "latitude": "35.15913000",
                "longitude": "-118.62842000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 111990,
                "name": "Beaumont",
                "latitude": "33.92946000",
                "longitude": "-116.97725000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112066,
                "name": "Bell",
                "latitude": "33.97751000",
                "longitude": "-118.18702000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112070,
                "name": "Bell Gardens",
                "latitude": "33.96529000",
                "longitude": "-118.15146000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112072,
                "name": "Bella Vista",
                "latitude": "40.64071000",
                "longitude": "-122.23250000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112118,
                "name": "Bellflower",
                "latitude": "33.88168000",
                "longitude": "-118.11701000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112142,
                "name": "Belmont",
                "latitude": "37.52021000",
                "longitude": "-122.27580000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112153,
                "name": "Belvedere",
                "latitude": "37.87270000",
                "longitude": "-122.46442000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112163,
                "name": "Ben Lomond",
                "latitude": "37.08911000",
                "longitude": "-122.08635000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112168,
                "name": "Benicia",
                "latitude": "38.04937000",
                "longitude": "-122.15858000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112223,
                "name": "Berkeley",
                "latitude": "37.87159000",
                "longitude": "-122.27275000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112240,
                "name": "Bermuda Dunes",
                "latitude": "33.74280000",
                "longitude": "-116.28918000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112253,
                "name": "Berry Creek",
                "latitude": "39.64516000",
                "longitude": "-121.40330000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112260,
                "name": "Bertsch-Oceanview",
                "latitude": "41.75250000",
                "longitude": "-124.15875000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112286,
                "name": "Bethel Island",
                "latitude": "38.01492000",
                "longitude": "-121.64051000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112306,
                "name": "Beverly Hills",
                "latitude": "34.07362000",
                "longitude": "-118.40036000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112315,
                "name": "Big Bear City",
                "latitude": "34.26112000",
                "longitude": "-116.84503000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112316,
                "name": "Big Bear Lake",
                "latitude": "34.24390000",
                "longitude": "-116.91142000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112328,
                "name": "Big Pine",
                "latitude": "37.16493000",
                "longitude": "-118.28955000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112331,
                "name": "Big River",
                "latitude": "34.14002000",
                "longitude": "-114.36134000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112340,
                "name": "Biggs",
                "latitude": "39.41239000",
                "longitude": "-121.71275000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112352,
                "name": "Biola",
                "latitude": "36.80217000",
                "longitude": "-120.01627000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112364,
                "name": "Bishop",
                "latitude": "37.36354000",
                "longitude": "-118.39511000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112381,
                "name": "Black Point-Green Point",
                "latitude": "38.11547000",
                "longitude": "-122.51318000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112387,
                "name": "Blackhawk",
                "latitude": "37.82076000",
                "longitude": "-121.90774000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112453,
                "name": "Bloomington",
                "latitude": "34.07029000",
                "longitude": "-117.39588000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112470,
                "name": "Blue Lake",
                "latitude": "40.88291000",
                "longitude": "-123.98395000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112485,
                "name": "Blythe",
                "latitude": "33.61030000",
                "longitude": "-114.59635000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112495,
                "name": "Bodega Bay",
                "latitude": "38.33325000",
                "longitude": "-123.04806000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112496,
                "name": "Bodfish",
                "latitude": "35.58801000",
                "longitude": "-118.49203000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112514,
                "name": "Bolinas",
                "latitude": "37.90937000",
                "longitude": "-122.68637000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112529,
                "name": "Bonadelle Ranchos-Madera Ranchos",
                "latitude": "36.98467000",
                "longitude": "-119.87463000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112537,
                "name": "Bonita",
                "latitude": "32.65783000",
                "longitude": "-117.03003000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112548,
                "name": "Bonny Doon",
                "latitude": "37.04162000",
                "longitude": "-122.15052000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112550,
                "name": "Bonsall",
                "latitude": "33.28892000",
                "longitude": "-117.22559000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112571,
                "name": "Boonville",
                "latitude": "39.00907000",
                "longitude": "-123.36612000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112578,
                "name": "Boron",
                "latitude": "34.99942000",
                "longitude": "-117.64978000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112579,
                "name": "Boronda",
                "latitude": "36.69885000",
                "longitude": "-121.67495000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112581,
                "name": "Borrego Springs",
                "latitude": "33.25587000",
                "longitude": "-116.37501000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112591,
                "name": "Bostonia",
                "latitude": "32.80755000",
                "longitude": "-116.93642000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112604,
                "name": "Boulder Creek",
                "latitude": "37.12606000",
                "longitude": "-122.12219000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112646,
                "name": "Boyes Hot Springs",
                "latitude": "38.31380000",
                "longitude": "-122.48193000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112649,
                "name": "Boyle Heights",
                "latitude": "34.03390000",
                "longitude": "-118.20535000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112658,
                "name": "Bradbury",
                "latitude": "34.14695000",
                "longitude": "-117.97090000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112700,
                "name": "Brawley",
                "latitude": "32.97866000",
                "longitude": "-115.53027000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112707,
                "name": "Brea",
                "latitude": "33.91668000",
                "longitude": "-117.90006000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112733,
                "name": "Brentwood",
                "latitude": "37.93187000",
                "longitude": "-121.69579000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112736,
                "name": "Bret Harte",
                "latitude": "37.60207000",
                "longitude": "-121.00519000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112765,
                "name": "Bridgeport",
                "latitude": "38.25575000",
                "longitude": "-119.23127000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112800,
                "name": "Brisbane",
                "latitude": "37.68077000",
                "longitude": "-122.39997000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112825,
                "name": "Broadmoor",
                "latitude": "37.68660000",
                "longitude": "-122.48275000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112851,
                "name": "Brookdale",
                "latitude": "37.10634000",
                "longitude": "-122.10608000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112893,
                "name": "Brooktrails",
                "latitude": "39.44377000",
                "longitude": "-123.38529000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112983,
                "name": "Buckhorn",
                "latitude": "38.45216000",
                "longitude": "-120.52854000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112997,
                "name": "Buellton",
                "latitude": "34.61360000",
                "longitude": "-120.19265000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 112999,
                "name": "Buena Park",
                "latitude": "33.86751000",
                "longitude": "-117.99812000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113003,
                "name": "Buena Vista",
                "latitude": "37.32133000",
                "longitude": "-121.91662000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113047,
                "name": "Burbank",
                "latitude": "34.18084000",
                "longitude": "-118.30897000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113065,
                "name": "Burlingame",
                "latitude": "37.58410000",
                "longitude": "-122.36608000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113082,
                "name": "Burney",
                "latitude": "40.88238000",
                "longitude": "-121.66082000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113125,
                "name": "Butte County",
                "latitude": "39.66693000",
                "longitude": "-121.60067000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113129,
                "name": "Buttonwillow",
                "latitude": "35.40052000",
                "longitude": "-119.46956000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113146,
                "name": "Byron",
                "latitude": "37.86715000",
                "longitude": "-121.63801000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113148,
                "name": "Bystrom",
                "latitude": "37.62076000",
                "longitude": "-120.98577000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113150,
                "name": "Cabazon",
                "latitude": "33.91752000",
                "longitude": "-116.78724000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113173,
                "name": "Calabasas",
                "latitude": "34.15778000",
                "longitude": "-118.63842000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113176,
                "name": "Calaveras County",
                "latitude": "38.20461000",
                "longitude": "-120.55413000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113196,
                "name": "Calexico",
                "latitude": "32.67895000",
                "longitude": "-115.49888000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113218,
                "name": "California City",
                "latitude": "35.12580000",
                "longitude": "-117.98590000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113219,
                "name": "Calimesa",
                "latitude": "34.00390000",
                "longitude": "-117.06198000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113220,
                "name": "Calipatria",
                "latitude": "33.12560000",
                "longitude": "-115.51415000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113221,
                "name": "Calistoga",
                "latitude": "38.57880000",
                "longitude": "-122.57971000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113226,
                "name": "Callender",
                "latitude": "35.05303000",
                "longitude": "-120.59628000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113242,
                "name": "Camarillo",
                "latitude": "34.21639000",
                "longitude": "-119.03760000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113246,
                "name": "Cambria",
                "latitude": "35.56414000",
                "longitude": "-121.08075000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113249,
                "name": "Cambrian Park",
                "latitude": "37.25689000",
                "longitude": "-121.93079000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113281,
                "name": "Cameron Park",
                "latitude": "38.66879000",
                "longitude": "-120.98716000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113285,
                "name": "Camino",
                "latitude": "38.73824000",
                "longitude": "-120.67493000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113289,
                "name": "Camp Meeker",
                "latitude": "38.42519000",
                "longitude": "-122.95944000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113290,
                "name": "Camp Pendleton North",
                "latitude": "33.31465000",
                "longitude": "-117.31603000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113291,
                "name": "Camp Pendleton South",
                "latitude": "33.22844000",
                "longitude": "-117.37929000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113298,
                "name": "Campbell",
                "latitude": "37.28717000",
                "longitude": "-121.94996000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113308,
                "name": "Campo",
                "latitude": "32.60645000",
                "longitude": "-116.46891000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113335,
                "name": "Canoga Park",
                "latitude": "34.20112000",
                "longitude": "-118.59814000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113359,
                "name": "Canyon Lake",
                "latitude": "33.68502000",
                "longitude": "-117.27309000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113376,
                "name": "Capitola",
                "latitude": "36.97523000",
                "longitude": "-121.95329000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113408,
                "name": "Carlsbad",
                "latitude": "33.15809000",
                "longitude": "-117.35059000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113420,
                "name": "Carmel Valley Village",
                "latitude": "36.50605000",
                "longitude": "-121.76594000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113421,
                "name": "Carmel-by-the-Sea",
                "latitude": "36.55524000",
                "longitude": "-121.92329000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113423,
                "name": "Carmichael",
                "latitude": "38.61713000",
                "longitude": "-121.32828000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113440,
                "name": "Carpinteria",
                "latitude": "34.39888000",
                "longitude": "-119.51846000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113474,
                "name": "Carson",
                "latitude": "33.83141000",
                "longitude": "-118.28202000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113498,
                "name": "Caruthers",
                "latitude": "36.54273000",
                "longitude": "-119.83320000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113509,
                "name": "Casa Conejo",
                "latitude": "34.18362000",
                "longitude": "-118.94343000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113511,
                "name": "Casa de Oro-Mount Helix",
                "latitude": "32.76397000",
                "longitude": "-116.96877000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113540,
                "name": "Castaic",
                "latitude": "34.48888000",
                "longitude": "-118.62287000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113557,
                "name": "Castro Valley",
                "latitude": "37.69410000",
                "longitude": "-122.08635000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113559,
                "name": "Castroville",
                "latitude": "36.76579000",
                "longitude": "-121.75800000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113570,
                "name": "Cathedral City",
                "latitude": "33.77974000",
                "longitude": "-116.46529000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113592,
                "name": "Cayucos",
                "latitude": "35.44275000",
                "longitude": "-120.89213000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113622,
                "name": "Cedar Ridge",
                "latitude": "38.06576000",
                "longitude": "-120.27686000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113683,
                "name": "Central Valley (historical)",
                "latitude": "40.68043000",
                "longitude": "-122.37112000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113698,
                "name": "Century City",
                "latitude": "34.05557000",
                "longitude": "-118.41786000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113700,
                "name": "Ceres",
                "latitude": "37.59493000",
                "longitude": "-120.95771000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113701,
                "name": "Cerritos",
                "latitude": "33.85835000",
                "longitude": "-118.06479000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113714,
                "name": "Challenge-Brownsville",
                "latitude": "39.46447000",
                "longitude": "-121.26338000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113734,
                "name": "Channel Islands Beach",
                "latitude": "34.15806000",
                "longitude": "-119.22316000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113790,
                "name": "Charter Oak",
                "latitude": "34.10306000",
                "longitude": "-117.84589000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113807,
                "name": "Chatsworth",
                "latitude": "34.25723000",
                "longitude": "-118.60120000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113865,
                "name": "Cherry Valley",
                "latitude": "33.97252000",
                "longitude": "-116.97725000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113867,
                "name": "Cherryland",
                "latitude": "37.67938000",
                "longitude": "-122.10330000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113892,
                "name": "Chester",
                "latitude": "40.30627000",
                "longitude": "-121.23191000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113943,
                "name": "Chico",
                "latitude": "39.72849000",
                "longitude": "-121.83748000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113963,
                "name": "China Lake Acres",
                "latitude": "35.64051000",
                "longitude": "-117.76395000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113964,
                "name": "Chinatown",
                "latitude": "37.79660000",
                "longitude": "-122.40858000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113968,
                "name": "Chino",
                "latitude": "34.01223000",
                "longitude": "-117.68894000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113969,
                "name": "Chino Hills",
                "latitude": "33.99380000",
                "longitude": "-117.75888000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 113993,
                "name": "Chowchilla",
                "latitude": "37.12300000",
                "longitude": "-120.26018000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114003,
                "name": "Chualar",
                "latitude": "36.57052000",
                "longitude": "-121.51855000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114005,
                "name": "Chula Vista",
                "latitude": "32.64005000",
                "longitude": "-117.08420000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114034,
                "name": "Citrus",
                "latitude": "34.11501000",
                "longitude": "-117.89173000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114037,
                "name": "Citrus Heights",
                "latitude": "38.70712000",
                "longitude": "-121.28106000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114046,
                "name": "City and County of San Francisco",
                "latitude": "37.77823000",
                "longitude": "-122.44250000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 153627,
                "name": "City of Industry",
                "latitude": "34.01583333",
                "longitude": "-117.95083333",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114106,
                "name": "Claremont",
                "latitude": "34.09668000",
                "longitude": "-117.71978000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114169,
                "name": "Clay",
                "latitude": "38.33602000",
                "longitude": "-121.15939000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114203,
                "name": "Clayton",
                "latitude": "37.94103000",
                "longitude": "-121.93579000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114213,
                "name": "Clear Lake Riviera",
                "latitude": "38.95406000",
                "longitude": "-122.72082000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114219,
                "name": "Clearlake",
                "latitude": "38.95823000",
                "longitude": "-122.62637000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114220,
                "name": "Clearlake Oaks",
                "latitude": "39.02628000",
                "longitude": "-122.67193000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114311,
                "name": "Cloverdale",
                "latitude": "38.80546000",
                "longitude": "-123.01722000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114315,
                "name": "Clovis",
                "latitude": "36.82523000",
                "longitude": "-119.70292000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114324,
                "name": "Coachella",
                "latitude": "33.68030000",
                "longitude": "-116.17389000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114338,
                "name": "Coalinga",
                "latitude": "36.13968000",
                "longitude": "-120.36015000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114340,
                "name": "Coarsegold",
                "latitude": "37.26217000",
                "longitude": "-119.70098000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114343,
                "name": "Cobb",
                "latitude": "38.82213000",
                "longitude": "-122.72305000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114408,
                "name": "Colfax",
                "latitude": "39.10073000",
                "longitude": "-120.95328000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114425,
                "name": "Collierville",
                "latitude": "38.21464000",
                "longitude": "-121.26884000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114440,
                "name": "Colma",
                "latitude": "37.67688000",
                "longitude": "-122.45969000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114463,
                "name": "Colton",
                "latitude": "34.07390000",
                "longitude": "-117.31365000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114474,
                "name": "Columbia",
                "latitude": "38.03631000",
                "longitude": "-120.40131000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114504,
                "name": "Colusa",
                "latitude": "39.21433000",
                "longitude": "-122.00942000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114505,
                "name": "Colusa County",
                "latitude": "39.17757000",
                "longitude": "-122.23703000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114525,
                "name": "Commerce",
                "latitude": "34.00057000",
                "longitude": "-118.15979000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114529,
                "name": "Compton",
                "latitude": "33.89585000",
                "longitude": "-118.22007000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114543,
                "name": "Concord",
                "latitude": "37.97798000",
                "longitude": "-122.03107000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114575,
                "name": "Contra Costa Centre",
                "latitude": "37.92752000",
                "longitude": "-122.05786000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114576,
                "name": "Contra Costa County",
                "latitude": "37.92342000",
                "longitude": "-121.95121000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114596,
                "name": "Cool",
                "latitude": "38.88722000",
                "longitude": "-121.01472000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114622,
                "name": "Copperopolis",
                "latitude": "37.98104000",
                "longitude": "-120.64187000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114633,
                "name": "Corcoran",
                "latitude": "36.09801000",
                "longitude": "-119.56040000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114654,
                "name": "Corning",
                "latitude": "39.92766000",
                "longitude": "-122.17916000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114662,
                "name": "Corona",
                "latitude": "33.87529000",
                "longitude": "-117.56644000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114664,
                "name": "Coronado",
                "latitude": "32.68589000",
                "longitude": "-117.18309000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114667,
                "name": "Corralitos",
                "latitude": "36.98856000",
                "longitude": "-121.80634000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114672,
                "name": "Corte Madera",
                "latitude": "37.92548000",
                "longitude": "-122.52748000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114686,
                "name": "Costa Mesa",
                "latitude": "33.64113000",
                "longitude": "-117.91867000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114688,
                "name": "Cotati",
                "latitude": "38.32686000",
                "longitude": "-122.70721000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114689,
                "name": "Coto De Caza",
                "latitude": "33.60419000",
                "longitude": "-117.58699000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114702,
                "name": "Cottonwood",
                "latitude": "40.38571000",
                "longitude": "-122.28084000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114715,
                "name": "Country Club",
                "latitude": "37.96881000",
                "longitude": "-121.34078000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114731,
                "name": "Covelo",
                "latitude": "39.79327000",
                "longitude": "-123.24922000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114734,
                "name": "Covina",
                "latitude": "34.09001000",
                "longitude": "-117.89034000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114796,
                "name": "Crescent City",
                "latitude": "41.75595000",
                "longitude": "-124.20175000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114802,
                "name": "Crest",
                "latitude": "32.80727000",
                "longitude": "-116.86808000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114805,
                "name": "Crestline",
                "latitude": "34.24195000",
                "longitude": "-117.28560000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114830,
                "name": "Crockett",
                "latitude": "38.05242000",
                "longitude": "-122.21302000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114890,
                "name": "Cudahy",
                "latitude": "33.96057000",
                "longitude": "-118.18535000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114904,
                "name": "Culver City",
                "latitude": "34.02112000",
                "longitude": "-118.39647000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114924,
                "name": "Cupertino",
                "latitude": "37.32300000",
                "longitude": "-122.03218000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114947,
                "name": "Cutler",
                "latitude": "36.52328000",
                "longitude": "-119.28678000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114951,
                "name": "Cutten",
                "latitude": "40.76985000",
                "longitude": "-124.14284000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 114954,
                "name": "Cypress",
                "latitude": "33.81696000",
                "longitude": "-118.03729000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115006,
                "name": "Daly City",
                "latitude": "37.70577000",
                "longitude": "-122.46192000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115012,
                "name": "Dana Point",
                "latitude": "33.46697000",
                "longitude": "-117.69811000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115038,
                "name": "Danville",
                "latitude": "37.82159000",
                "longitude": "-121.99996000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115073,
                "name": "Davis",
                "latitude": "38.54491000",
                "longitude": "-121.74052000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115090,
                "name": "Day Valley",
                "latitude": "37.03578000",
                "longitude": "-121.86246000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115178,
                "name": "Deer Park",
                "latitude": "38.68185000",
                "longitude": "-120.82327000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115186,
                "name": "Del Aire",
                "latitude": "33.91613000",
                "longitude": "-118.36952000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115188,
                "name": "Del Mar",
                "latitude": "32.95949000",
                "longitude": "-117.26531000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115189,
                "name": "Del Monte Forest",
                "latitude": "36.58635000",
                "longitude": "-121.94746000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115191,
                "name": "Del Norte County",
                "latitude": "41.74496000",
                "longitude": "-123.95781000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115192,
                "name": "Del Rey",
                "latitude": "36.65912000",
                "longitude": "-119.59374000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115193,
                "name": "Del Rey Oaks",
                "latitude": "36.59329000",
                "longitude": "-121.83495000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115194,
                "name": "Del Rio",
                "latitude": "37.74354000",
                "longitude": "-121.01188000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115199,
                "name": "Delano",
                "latitude": "35.76884000",
                "longitude": "-119.24705000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115213,
                "name": "Delhi",
                "latitude": "37.43216000",
                "longitude": "-120.77854000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115234,
                "name": "Denair",
                "latitude": "37.52632000",
                "longitude": "-120.79687000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115276,
                "name": "Descanso",
                "latitude": "32.85283000",
                "longitude": "-116.61585000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115280,
                "name": "Desert Edge",
                "latitude": "33.92417000",
                "longitude": "-116.44139000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115282,
                "name": "Desert Hot Springs",
                "latitude": "33.96173000",
                "longitude": "-116.50353000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115283,
                "name": "Desert Shores",
                "latitude": "33.40420000",
                "longitude": "-116.03972000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115284,
                "name": "Desert View Highlands",
                "latitude": "34.59082000",
                "longitude": "-118.15257000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115312,
                "name": "Diablo",
                "latitude": "37.83493000",
                "longitude": "-121.95801000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115314,
                "name": "Diamond Bar",
                "latitude": "34.02862000",
                "longitude": "-117.81034000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115316,
                "name": "Diamond Springs",
                "latitude": "38.69463000",
                "longitude": "-120.81494000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115351,
                "name": "Dinuba",
                "latitude": "36.54328000",
                "longitude": "-119.38707000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115353,
                "name": "Discovery Bay",
                "latitude": "37.90854000",
                "longitude": "-121.60023000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115367,
                "name": "Dixon",
                "latitude": "38.44546000",
                "longitude": "-121.82330000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115369,
                "name": "Dixon Lane-Meadow Creek",
                "latitude": "37.38639000",
                "longitude": "-118.41527000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115385,
                "name": "Dogtown",
                "latitude": "38.21381000",
                "longitude": "-121.08855000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115390,
                "name": "Dollar Point",
                "latitude": "39.18796000",
                "longitude": "-120.09991000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115414,
                "name": "Dos Palos",
                "latitude": "36.98606000",
                "longitude": "-120.62657000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115460,
                "name": "Downey",
                "latitude": "33.94001000",
                "longitude": "-118.13257000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115461,
                "name": "Downieville",
                "latitude": "39.55934000",
                "longitude": "-120.82689000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115490,
                "name": "Duarte",
                "latitude": "34.13945000",
                "longitude": "-117.97729000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115496,
                "name": "Dublin",
                "latitude": "37.70215000",
                "longitude": "-121.93579000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115551,
                "name": "Dunnigan",
                "latitude": "38.88518000",
                "longitude": "-121.96969000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115553,
                "name": "Dunsmuir",
                "latitude": "41.20821000",
                "longitude": "-122.27195000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115573,
                "name": "Durham",
                "latitude": "39.64627000",
                "longitude": "-121.79998000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115618,
                "name": "Earlimart",
                "latitude": "35.88412000",
                "longitude": "-119.27233000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115663,
                "name": "East Foothills",
                "latitude": "37.38105000",
                "longitude": "-121.81745000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115689,
                "name": "East Hemet",
                "latitude": "33.74002000",
                "longitude": "-116.93891000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115699,
                "name": "East La Mirada",
                "latitude": "33.92446000",
                "longitude": "-117.98895000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115706,
                "name": "East Los Angeles",
                "latitude": "34.02390000",
                "longitude": "-118.17202000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115725,
                "name": "East Oakdale",
                "latitude": "37.78798000",
                "longitude": "-120.80382000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115728,
                "name": "East Palo Alto",
                "latitude": "37.46883000",
                "longitude": "-122.14108000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115729,
                "name": "East Pasadena",
                "latitude": "34.13814000",
                "longitude": "-118.07384000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115739,
                "name": "East Porterville",
                "latitude": "36.05745000",
                "longitude": "-118.97566000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115742,
                "name": "East Quincy",
                "latitude": "39.93406000",
                "longitude": "-120.89801000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115744,
                "name": "East Rancho Dominguez",
                "latitude": "33.89807000",
                "longitude": "-118.19535000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115746,
                "name": "East Richmond Heights",
                "latitude": "37.94492000",
                "longitude": "-122.31358000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115755,
                "name": "East San Gabriel",
                "latitude": "34.09168000",
                "longitude": "-118.09118000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115759,
                "name": "East Sonora",
                "latitude": "37.97770000",
                "longitude": "-120.36130000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115791,
                "name": "Easton",
                "latitude": "36.65023000",
                "longitude": "-119.79070000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115797,
                "name": "Eastvale",
                "latitude": "33.96358000",
                "longitude": "-117.56418000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115814,
                "name": "Echo Park",
                "latitude": "34.07808000",
                "longitude": "-118.26066000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115888,
                "name": "Edwards Air Force Base",
                "latitude": "34.91637000",
                "longitude": "-117.93535000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115911,
                "name": "El Cajon",
                "latitude": "32.79477000",
                "longitude": "-116.96253000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115914,
                "name": "El Centro",
                "latitude": "32.79200000",
                "longitude": "-115.56305000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115915,
                "name": "El Cerrito",
                "latitude": "37.91576000",
                "longitude": "-122.31164000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115916,
                "name": "El Cerrito Corona",
                "latitude": "33.84057000",
                "longitude": "-117.52283000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115921,
                "name": "El Dorado County",
                "latitude": "38.77874000",
                "longitude": "-120.52465000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115922,
                "name": "El Dorado Hills",
                "latitude": "38.68574000",
                "longitude": "-121.08217000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115924,
                "name": "El Granada",
                "latitude": "37.50272000",
                "longitude": "-122.46942000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115928,
                "name": "El Monte",
                "latitude": "34.06862000",
                "longitude": "-118.02757000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115936,
                "name": "El Rio",
                "latitude": "34.23578000",
                "longitude": "-119.16383000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115937,
                "name": "El Segundo",
                "latitude": "33.91918000",
                "longitude": "-118.41647000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115938,
                "name": "El Sobrante",
                "latitude": "37.97715000",
                "longitude": "-122.29525000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115940,
                "name": "El Verano",
                "latitude": "38.29769000",
                "longitude": "-122.49165000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115957,
                "name": "Eldridge",
                "latitude": "38.34880000",
                "longitude": "-122.51081000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 115987,
                "name": "Elk Grove",
                "latitude": "38.40880000",
                "longitude": "-121.37162000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116003,
                "name": "Elkhorn",
                "latitude": "36.82440000",
                "longitude": "-121.74050000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116075,
                "name": "Elverta",
                "latitude": "38.71379000",
                "longitude": "-121.46273000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116090,
                "name": "Emerald Lake Hills",
                "latitude": "37.46466000",
                "longitude": "-122.26802000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116097,
                "name": "Emeryville",
                "latitude": "37.83132000",
                "longitude": "-122.28525000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116110,
                "name": "Empire",
                "latitude": "37.63826000",
                "longitude": "-120.90215000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116118,
                "name": "Encinitas",
                "latitude": "33.03699000",
                "longitude": "-117.29198000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116119,
                "name": "Encino",
                "latitude": "34.15917000",
                "longitude": "-118.50119000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116178,
                "name": "Escalon",
                "latitude": "37.79781000",
                "longitude": "-120.99792000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116184,
                "name": "Escondido",
                "latitude": "33.11921000",
                "longitude": "-117.08642000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116187,
                "name": "Esparto",
                "latitude": "38.69213000",
                "longitude": "-122.01719000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116221,
                "name": "Eucalyptus Hills",
                "latitude": "32.87977000",
                "longitude": "-116.94669000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116235,
                "name": "Eureka",
                "latitude": "40.80207000",
                "longitude": "-124.16367000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116274,
                "name": "Exeter",
                "latitude": "36.29606000",
                "longitude": "-119.14205000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116286,
                "name": "Fair Oaks",
                "latitude": "38.64463000",
                "longitude": "-121.27217000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116292,
                "name": "Fairbanks Ranch",
                "latitude": "32.99393000",
                "longitude": "-117.18726000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116306,
                "name": "Fairfax",
                "latitude": "37.98715000",
                "longitude": "-122.58887000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116316,
                "name": "Fairfield",
                "latitude": "38.24936000",
                "longitude": "-122.03997000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116333,
                "name": "Fairmead",
                "latitude": "37.07633000",
                "longitude": "-120.19295000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116355,
                "name": "Fairview",
                "latitude": "37.67854000",
                "longitude": "-122.04580000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116376,
                "name": "Fallbrook",
                "latitude": "33.37642000",
                "longitude": "-117.25115000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116407,
                "name": "Farmersville",
                "latitude": "36.29773000",
                "longitude": "-119.20678000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116471,
                "name": "Felton",
                "latitude": "37.05134000",
                "longitude": "-122.07330000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116489,
                "name": "Ferndale",
                "latitude": "40.57624000",
                "longitude": "-124.26394000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116503,
                "name": "Fetters Hot Springs-Agua Caliente",
                "latitude": "38.32140000",
                "longitude": "-122.48682000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116508,
                "name": "Fillmore",
                "latitude": "34.39916000",
                "longitude": "-118.91815000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116520,
                "name": "Firebaugh",
                "latitude": "36.85884000",
                "longitude": "-120.45601000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116589,
                "name": "Florence-Graham",
                "latitude": "33.96772000",
                "longitude": "-118.24438000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116595,
                "name": "Florin",
                "latitude": "38.49602000",
                "longitude": "-121.40884000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116626,
                "name": "Folsom",
                "latitude": "38.67796000",
                "longitude": "-121.17606000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116631,
                "name": "Fontana",
                "latitude": "34.09223000",
                "longitude": "-117.43505000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116632,
                "name": "Foothill Farms",
                "latitude": "38.67877000",
                "longitude": "-121.35114000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116633,
                "name": "Foothill Ranch",
                "latitude": "33.68641000",
                "longitude": "-117.66088000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116635,
                "name": "Ford City",
                "latitude": "35.15441000",
                "longitude": "-119.45623000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116662,
                "name": "Forest Meadows",
                "latitude": "38.16851000",
                "longitude": "-120.40659000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116667,
                "name": "Forest Ranch",
                "latitude": "39.88211000",
                "longitude": "-121.67275000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116671,
                "name": "Foresthill",
                "latitude": "39.02018000",
                "longitude": "-120.81799000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116673,
                "name": "Forestville",
                "latitude": "38.47352000",
                "longitude": "-122.89027000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116695,
                "name": "Fort Bragg",
                "latitude": "39.44572000",
                "longitude": "-123.80529000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116719,
                "name": "Fort Irwin",
                "latitude": "35.26275000",
                "longitude": "-116.68475000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116767,
                "name": "Fortuna",
                "latitude": "40.59819000",
                "longitude": "-124.15728000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116776,
                "name": "Foster City",
                "latitude": "37.55855000",
                "longitude": "-122.27108000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116784,
                "name": "Fountain Valley",
                "latitude": "33.70918000",
                "longitude": "-117.95367000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116797,
                "name": "Fowler",
                "latitude": "36.63051000",
                "longitude": "-119.67847000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116883,
                "name": "Frazier Park",
                "latitude": "34.82276000",
                "longitude": "-118.94482000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116903,
                "name": "Freedom",
                "latitude": "36.93523000",
                "longitude": "-121.77301000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116924,
                "name": "Fremont",
                "latitude": "37.54827000",
                "longitude": "-121.98857000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116929,
                "name": "French Camp",
                "latitude": "37.88409000",
                "longitude": "-121.27106000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116939,
                "name": "Fresno",
                "latitude": "36.74773000",
                "longitude": "-119.77237000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116940,
                "name": "Fresno County",
                "latitude": "36.75818000",
                "longitude": "-119.64932000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116975,
                "name": "Fruitridge Pocket",
                "latitude": "38.53265000",
                "longitude": "-121.45581000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 116983,
                "name": "Fullerton",
                "latitude": "33.87029000",
                "longitude": "-117.92534000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117040,
                "name": "Galt",
                "latitude": "38.25464000",
                "longitude": "-121.29995000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117053,
                "name": "Garden Acres",
                "latitude": "37.96381000",
                "longitude": "-121.22939000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117065,
                "name": "Garden Grove",
                "latitude": "33.77391000",
                "longitude": "-117.94145000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117069,
                "name": "Gardena",
                "latitude": "33.88835000",
                "longitude": "-118.30896000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117094,
                "name": "Garnet",
                "latitude": "33.90196000",
                "longitude": "-116.54557000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117165,
                "name": "Georgetown",
                "latitude": "38.90684000",
                "longitude": "-120.83855000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117169,
                "name": "Gerber",
                "latitude": "40.05627000",
                "longitude": "-122.15027000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117225,
                "name": "Gilroy",
                "latitude": "37.00578000",
                "longitude": "-121.56828000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117261,
                "name": "Glen Avon",
                "latitude": "34.01168000",
                "longitude": "-117.48477000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117286,
                "name": "Glendale",
                "latitude": "34.14251000",
                "longitude": "-118.25508000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117291,
                "name": "Glendora",
                "latitude": "34.13612000",
                "longitude": "-117.86534000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117296,
                "name": "Glenn County",
                "latitude": "39.59840000",
                "longitude": "-122.39221000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117345,
                "name": "Gold River",
                "latitude": "38.62629000",
                "longitude": "-121.24662000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117351,
                "name": "Golden Hills",
                "latitude": "35.14247000",
                "longitude": "-118.49036000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117367,
                "name": "Goleta",
                "latitude": "34.43583000",
                "longitude": "-119.82764000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117372,
                "name": "Gonzales",
                "latitude": "36.50663000",
                "longitude": "-121.44438000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117378,
                "name": "Good Hope",
                "latitude": "33.76474000",
                "longitude": "-117.26698000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117410,
                "name": "Goshen",
                "latitude": "36.35106000",
                "longitude": "-119.42012000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117476,
                "name": "Grand Terrace",
                "latitude": "34.03390000",
                "longitude": "-117.31365000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117493,
                "name": "Granite Bay",
                "latitude": "38.76323000",
                "longitude": "-121.16384000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117499,
                "name": "Granite Hills",
                "latitude": "32.80311000",
                "longitude": "-116.90475000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117543,
                "name": "Grass Valley",
                "latitude": "39.21906000",
                "longitude": "-121.06106000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117545,
                "name": "Graton",
                "latitude": "38.43630000",
                "longitude": "-122.86972000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117590,
                "name": "Green Acres",
                "latitude": "33.73808000",
                "longitude": "-117.07642000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117611,
                "name": "Green Valley",
                "latitude": "38.25297000",
                "longitude": "-122.16219000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117654,
                "name": "Greenfield",
                "latitude": "36.32080000",
                "longitude": "-121.24381000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117696,
                "name": "Greenville",
                "latitude": "40.13961000",
                "longitude": "-120.95107000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117730,
                "name": "Gridley",
                "latitude": "39.36378000",
                "longitude": "-121.69358000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117760,
                "name": "Grover Beach",
                "latitude": "35.12164000",
                "longitude": "-120.62128000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117777,
                "name": "Guadalupe",
                "latitude": "34.97164000",
                "longitude": "-120.57184000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117780,
                "name": "Guerneville",
                "latitude": "38.50186000",
                "longitude": "-122.99611000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117810,
                "name": "Gustine",
                "latitude": "37.25772000",
                "longitude": "-120.99882000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117825,
                "name": "Hacienda Heights",
                "latitude": "33.99307000",
                "longitude": "-117.96868000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117856,
                "name": "Half Moon Bay",
                "latitude": "37.46355000",
                "longitude": "-122.42859000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117895,
                "name": "Hamilton City",
                "latitude": "39.74266000",
                "longitude": "-122.01359000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117960,
                "name": "Hanford",
                "latitude": "36.32745000",
                "longitude": "-119.64568000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117982,
                "name": "Happy Camp",
                "latitude": "41.79275000",
                "longitude": "-123.38080000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 117986,
                "name": "Harbison Canyon",
                "latitude": "32.82033000",
                "longitude": "-116.83002000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118099,
                "name": "Hartley",
                "latitude": "38.41713000",
                "longitude": "-121.94691000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118160,
                "name": "Hawaiian Gardens",
                "latitude": "33.83140000",
                "longitude": "-118.07284000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118175,
                "name": "Hawthorne",
                "latitude": "33.91640000",
                "longitude": "-118.35257000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118186,
                "name": "Hayfork",
                "latitude": "40.55431000",
                "longitude": "-123.18308000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118197,
                "name": "Hayward",
                "latitude": "37.66882000",
                "longitude": "-122.08080000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118217,
                "name": "Healdsburg",
                "latitude": "38.61047000",
                "longitude": "-122.86916000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118228,
                "name": "Heber",
                "latitude": "32.73089000",
                "longitude": "-115.52972000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118264,
                "name": "Hemet",
                "latitude": "33.74761000",
                "longitude": "-116.97307000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118311,
                "name": "Herald",
                "latitude": "38.29575000",
                "longitude": "-121.24439000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118314,
                "name": "Hercules",
                "latitude": "38.01714000",
                "longitude": "-122.28858000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118331,
                "name": "Hermosa Beach",
                "latitude": "33.86224000",
                "longitude": "-118.39952000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118344,
                "name": "Hesperia",
                "latitude": "34.42639000",
                "longitude": "-117.30088000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118376,
                "name": "Hidden Hills",
                "latitude": "34.16028000",
                "longitude": "-118.65231000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118377,
                "name": "Hidden Meadows",
                "latitude": "33.22531000",
                "longitude": "-117.11253000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118380,
                "name": "Hidden Valley Lake",
                "latitude": "38.80796000",
                "longitude": "-122.55832000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118391,
                "name": "Highgrove",
                "latitude": "34.01585000",
                "longitude": "-117.33338000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118398,
                "name": "Highland",
                "latitude": "34.12834000",
                "longitude": "-117.20865000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118421,
                "name": "Highlands-Baywood Park",
                "latitude": "37.52272000",
                "longitude": "-122.34506000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118455,
                "name": "Hillsborough",
                "latitude": "37.57410000",
                "longitude": "-122.37942000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118471,
                "name": "Hilmar-Irwin",
                "latitude": "37.40454000",
                "longitude": "-120.85042000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118552,
                "name": "Hollister",
                "latitude": "36.85245000",
                "longitude": "-121.40160000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118567,
                "name": "Hollywood",
                "latitude": "34.09834000",
                "longitude": "-118.32674000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118582,
                "name": "Holtville",
                "latitude": "32.81116000",
                "longitude": "-115.38026000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118586,
                "name": "Home Garden",
                "latitude": "36.30328000",
                "longitude": "-119.63624000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118587,
                "name": "Home Gardens",
                "latitude": "33.87807000",
                "longitude": "-117.52088000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118590,
                "name": "Homeland",
                "latitude": "33.74308000",
                "longitude": "-117.10920000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118764,
                "name": "Hughson",
                "latitude": "37.59688000",
                "longitude": "-120.86604000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118779,
                "name": "Humboldt County",
                "latitude": "40.70501000",
                "longitude": "-123.91582000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118781,
                "name": "Humboldt Hill",
                "latitude": "40.72596000",
                "longitude": "-124.18978000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118805,
                "name": "Huntington Beach",
                "latitude": "33.66030000",
                "longitude": "-117.99923000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118807,
                "name": "Huntington Park",
                "latitude": "33.98168000",
                "longitude": "-118.22507000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118825,
                "name": "Huron",
                "latitude": "36.20273000",
                "longitude": "-120.10292000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118855,
                "name": "Hydesville",
                "latitude": "40.54763000",
                "longitude": "-124.09727000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118874,
                "name": "Idyllwild",
                "latitude": "33.74002000",
                "longitude": "-116.71891000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118875,
                "name": "Idyllwild-Pine Cove",
                "latitude": "33.74429000",
                "longitude": "-116.72587000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118883,
                "name": "Imperial",
                "latitude": "32.84755000",
                "longitude": "-115.56944000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118885,
                "name": "Imperial Beach",
                "latitude": "32.58394000",
                "longitude": "-117.11308000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118886,
                "name": "Imperial County",
                "latitude": "33.03951000",
                "longitude": "-115.36532000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118921,
                "name": "Indian Wells",
                "latitude": "33.71791000",
                "longitude": "-116.34311000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118929,
                "name": "Indio",
                "latitude": "33.72070000",
                "longitude": "-116.21677000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118937,
                "name": "Inglewood",
                "latitude": "33.96168000",
                "longitude": "-118.35313000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118951,
                "name": "Interlaken",
                "latitude": "36.95134000",
                "longitude": "-121.73384000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118957,
                "name": "Inverness",
                "latitude": "38.10103000",
                "longitude": "-122.85694000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118964,
                "name": "Inyo County",
                "latitude": "36.51113000",
                "longitude": "-117.41079000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118965,
                "name": "Inyokern",
                "latitude": "35.64690000",
                "longitude": "-117.81257000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 118970,
                "name": "Ione",
                "latitude": "38.35269000",
                "longitude": "-120.93272000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119004,
                "name": "Irvine",
                "latitude": "33.66946000",
                "longitude": "-117.82311000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119014,
                "name": "Irwindale",
                "latitude": "34.10695000",
                "longitude": "-117.93534000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119021,
                "name": "Isla Vista",
                "latitude": "34.41333000",
                "longitude": "-119.86097000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119049,
                "name": "Ivanhoe",
                "latitude": "36.38717000",
                "longitude": "-119.21789000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119073,
                "name": "Jackson",
                "latitude": "38.34880000",
                "longitude": "-120.77410000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119126,
                "name": "Jamestown",
                "latitude": "37.95326000",
                "longitude": "-120.42270000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119128,
                "name": "Jamul",
                "latitude": "32.71700000",
                "longitude": "-116.87613000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119132,
                "name": "Janesville",
                "latitude": "40.29656000",
                "longitude": "-120.52411000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119283,
                "name": "Johnstonville",
                "latitude": "40.38434000",
                "longitude": "-120.58745000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119323,
                "name": "Joshua Tree",
                "latitude": "34.13473000",
                "longitude": "-116.31307000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119330,
                "name": "Julian",
                "latitude": "33.07866000",
                "longitude": "-116.60196000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119343,
                "name": "Jurupa Valley",
                "latitude": "33.99251000",
                "longitude": "-117.51644000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119431,
                "name": "Kelseyville",
                "latitude": "38.97795000",
                "longitude": "-122.83944000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119469,
                "name": "Kennedy",
                "latitude": "37.92992000",
                "longitude": "-121.25272000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119484,
                "name": "Kensington",
                "latitude": "37.91048000",
                "longitude": "-122.28025000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119495,
                "name": "Kentfield",
                "latitude": "37.95215000",
                "longitude": "-122.55720000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119505,
                "name": "Kenwood",
                "latitude": "38.41380000",
                "longitude": "-122.54609000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119512,
                "name": "Kerman",
                "latitude": "36.72356000",
                "longitude": "-120.05988000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119514,
                "name": "Kern County",
                "latitude": "35.34285000",
                "longitude": "-118.72990000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119516,
                "name": "Kernville",
                "latitude": "35.75467000",
                "longitude": "-118.42536000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119528,
                "name": "Kettleman City",
                "latitude": "36.00829000",
                "longitude": "-119.96180000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119543,
                "name": "Keyes",
                "latitude": "37.55660000",
                "longitude": "-120.91549000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119579,
                "name": "King City",
                "latitude": "36.21274000",
                "longitude": "-121.12603000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119598,
                "name": "Kings Beach",
                "latitude": "39.23768000",
                "longitude": "-120.02658000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119600,
                "name": "Kings County",
                "latitude": "36.07536000",
                "longitude": "-119.81550000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119609,
                "name": "Kingsburg",
                "latitude": "36.51384000",
                "longitude": "-119.55402000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119675,
                "name": "Knightsen",
                "latitude": "37.96881000",
                "longitude": "-121.66801000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119708,
                "name": "Koreatown",
                "latitude": "34.05779000",
                "longitude": "-118.30091000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119736,
                "name": "La Cañada Flintridge",
                "latitude": "34.19917000",
                "longitude": "-118.18785000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119742,
                "name": "La Crescenta-Montrose",
                "latitude": "34.23216000",
                "longitude": "-118.23529000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119755,
                "name": "La Habra",
                "latitude": "33.93196000",
                "longitude": "-117.94617000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119756,
                "name": "La Habra Heights",
                "latitude": "33.96085000",
                "longitude": "-117.95062000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119760,
                "name": "La Jolla",
                "latitude": "32.84727000",
                "longitude": "-117.27420000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119765,
                "name": "La Mesa",
                "latitude": "32.76783000",
                "longitude": "-117.02308000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119767,
                "name": "La Mirada",
                "latitude": "33.91724000",
                "longitude": "-118.01201000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119769,
                "name": "La Palma",
                "latitude": "33.84640000",
                "longitude": "-118.04673000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119779,
                "name": "La Presa",
                "latitude": "32.70811000",
                "longitude": "-116.99725000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119782,
                "name": "La Puente",
                "latitude": "34.02001000",
                "longitude": "-117.94951000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119783,
                "name": "La Quinta",
                "latitude": "33.66336000",
                "longitude": "-116.31001000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119784,
                "name": "La Riviera",
                "latitude": "38.56685000",
                "longitude": "-121.35690000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119789,
                "name": "La Selva Beach",
                "latitude": "36.93662000",
                "longitude": "-121.86468000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119793,
                "name": "La Verne",
                "latitude": "34.10084000",
                "longitude": "-117.76784000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119823,
                "name": "Ladera",
                "latitude": "37.39994000",
                "longitude": "-122.19830000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119824,
                "name": "Ladera Heights",
                "latitude": "33.99418000",
                "longitude": "-118.37535000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119825,
                "name": "Ladera Ranch",
                "latitude": "33.57086000",
                "longitude": "-117.63561000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119835,
                "name": "Lafayette",
                "latitude": "37.88576000",
                "longitude": "-122.11802000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119849,
                "name": "Laguna",
                "latitude": "38.42102000",
                "longitude": "-121.42384000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119852,
                "name": "Laguna Beach",
                "latitude": "33.54225000",
                "longitude": "-117.78311000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119854,
                "name": "Laguna Hills",
                "latitude": "33.61252000",
                "longitude": "-117.71283000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119855,
                "name": "Laguna Niguel",
                "latitude": "33.52253000",
                "longitude": "-117.70755000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119858,
                "name": "Laguna Woods",
                "latitude": "33.61030000",
                "longitude": "-117.72533000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119859,
                "name": "Lagunitas-Forest Knolls",
                "latitude": "38.01793000",
                "longitude": "-122.69124000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119866,
                "name": "Lake Arrowhead",
                "latitude": "34.24834000",
                "longitude": "-117.18921000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119896,
                "name": "Lake County",
                "latitude": "39.09965000",
                "longitude": "-122.75318000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119906,
                "name": "Lake Elsinore",
                "latitude": "33.66808000",
                "longitude": "-117.32726000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119911,
                "name": "Lake Forest",
                "latitude": "33.64697000",
                "longitude": "-117.68922000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119923,
                "name": "Lake Isabella",
                "latitude": "35.61801000",
                "longitude": "-118.47314000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119931,
                "name": "Lake Los Angeles",
                "latitude": "34.61249000",
                "longitude": "-117.82812000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119950,
                "name": "Lake Nacimiento",
                "latitude": "35.72830000",
                "longitude": "-120.87963000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120005,
                "name": "Lake of the Pines",
                "latitude": "39.03962000",
                "longitude": "-121.05661000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119973,
                "name": "Lake San Marcos",
                "latitude": "33.12615000",
                "longitude": "-117.20837000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 119993,
                "name": "Lake Wildwood",
                "latitude": "39.23295000",
                "longitude": "-121.20051000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120020,
                "name": "Lakeland Village",
                "latitude": "33.63863000",
                "longitude": "-117.34393000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120023,
                "name": "Lakeport",
                "latitude": "39.04295000",
                "longitude": "-122.91583000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120032,
                "name": "Lakeside",
                "latitude": "32.85727000",
                "longitude": "-116.92225000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120040,
                "name": "Lakeview",
                "latitude": "33.83863000",
                "longitude": "-117.11809000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120051,
                "name": "Lakewood",
                "latitude": "33.85363000",
                "longitude": "-118.13396000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120074,
                "name": "Lamont",
                "latitude": "35.25968000",
                "longitude": "-118.91427000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120089,
                "name": "Lancaster",
                "latitude": "34.69804000",
                "longitude": "-118.13674000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120147,
                "name": "Larkfield-Wikiup",
                "latitude": "38.51342000",
                "longitude": "-122.75094000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120148,
                "name": "Larkspur",
                "latitude": "37.93409000",
                "longitude": "-122.53525000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120156,
                "name": "Las Flores",
                "latitude": "33.58808000",
                "longitude": "-117.62672000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120158,
                "name": "Las Lomas",
                "latitude": "36.86523000",
                "longitude": "-121.73495000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120166,
                "name": "Lassen County",
                "latitude": "40.67359000",
                "longitude": "-120.59433000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120170,
                "name": "Lathrop",
                "latitude": "37.82270000",
                "longitude": "-121.27661000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120174,
                "name": "Laton",
                "latitude": "36.43328000",
                "longitude": "-119.68680000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120222,
                "name": "Lawndale",
                "latitude": "33.88724000",
                "longitude": "-118.35257000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120255,
                "name": "Laytonville",
                "latitude": "39.68821000",
                "longitude": "-123.48279000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120260,
                "name": "Le Grand",
                "latitude": "37.22855000",
                "longitude": "-120.24823000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120298,
                "name": "Lebec",
                "latitude": "34.84164000",
                "longitude": "-118.86482000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120359,
                "name": "Lemon Grove",
                "latitude": "32.74255000",
                "longitude": "-117.03142000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120362,
                "name": "Lemoore",
                "latitude": "36.30078000",
                "longitude": "-119.78291000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120363,
                "name": "Lemoore Station",
                "latitude": "36.26326000",
                "longitude": "-119.90476000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120371,
                "name": "Lennox",
                "latitude": "33.93807000",
                "longitude": "-118.35258000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120378,
                "name": "Lenwood",
                "latitude": "34.87665000",
                "longitude": "-117.10393000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120387,
                "name": "Leona Valley",
                "latitude": "34.61832000",
                "longitude": "-118.28813000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120427,
                "name": "Lewiston",
                "latitude": "40.70737000",
                "longitude": "-122.80752000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120454,
                "name": "Lexington Hills",
                "latitude": "37.16467000",
                "longitude": "-121.97301000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120509,
                "name": "Lincoln",
                "latitude": "38.89156000",
                "longitude": "-121.29301000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120557,
                "name": "Linda",
                "latitude": "39.12767000",
                "longitude": "-121.55080000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120566,
                "name": "Linden",
                "latitude": "38.02131000",
                "longitude": "-121.08383000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120574,
                "name": "Lindsay",
                "latitude": "36.20301000",
                "longitude": "-119.08816000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120633,
                "name": "Littlerock",
                "latitude": "34.52110000",
                "longitude": "-117.98368000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120640,
                "name": "Live Oak",
                "latitude": "36.98356000",
                "longitude": "-121.98052000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120644,
                "name": "Livermore",
                "latitude": "37.68187000",
                "longitude": "-121.76801000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120652,
                "name": "Livingston",
                "latitude": "37.38688000",
                "longitude": "-120.72353000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120675,
                "name": "Lockeford",
                "latitude": "38.16353000",
                "longitude": "-121.14994000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120691,
                "name": "Lodi",
                "latitude": "38.13020000",
                "longitude": "-121.27245000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120712,
                "name": "Loma Linda",
                "latitude": "34.04835000",
                "longitude": "-117.26115000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120713,
                "name": "Loma Rica",
                "latitude": "39.31183000",
                "longitude": "-121.41774000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120716,
                "name": "Lomita",
                "latitude": "33.79224000",
                "longitude": "-118.31507000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120717,
                "name": "Lompico",
                "latitude": "37.10550000",
                "longitude": "-122.05274000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120718,
                "name": "Lompoc",
                "latitude": "34.63915000",
                "longitude": "-120.45794000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120722,
                "name": "London",
                "latitude": "36.47606000",
                "longitude": "-119.44318000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120729,
                "name": "Lone Pine",
                "latitude": "36.60626000",
                "longitude": "-118.06462000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120738,
                "name": "Long Beach",
                "latitude": "33.76696000",
                "longitude": "-118.18923000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120767,
                "name": "Loomis",
                "latitude": "38.82129000",
                "longitude": "-121.19300000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120778,
                "name": "Los Alamitos",
                "latitude": "33.80307000",
                "longitude": "-118.07256000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120779,
                "name": "Los Alamos",
                "latitude": "34.74443000",
                "longitude": "-120.27821000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120782,
                "name": "Los Altos",
                "latitude": "37.38522000",
                "longitude": "-122.11413000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120783,
                "name": "Los Altos Hills",
                "latitude": "37.37966000",
                "longitude": "-122.13746000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120784,
                "name": "Los Angeles",
                "latitude": "34.05223000",
                "longitude": "-118.24368000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120785,
                "name": "Los Angeles County",
                "latitude": "34.19801000",
                "longitude": "-118.26102000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120786,
                "name": "Los Banos",
                "latitude": "37.05828000",
                "longitude": "-120.84992000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120789,
                "name": "Los Gatos",
                "latitude": "37.22661000",
                "longitude": "-121.97468000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120792,
                "name": "Los Molinos",
                "latitude": "40.02127000",
                "longitude": "-122.10027000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120793,
                "name": "Los Olivos",
                "latitude": "34.66776000",
                "longitude": "-120.11487000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120794,
                "name": "Los Osos",
                "latitude": "35.31109000",
                "longitude": "-120.83240000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120796,
                "name": "Los Serranos",
                "latitude": "33.97279000",
                "longitude": "-117.70811000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120798,
                "name": "Lost Hills",
                "latitude": "35.61635000",
                "longitude": "-119.69429000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120842,
                "name": "Lower Lake",
                "latitude": "38.91045000",
                "longitude": "-122.61026000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120855,
                "name": "Loyola",
                "latitude": "37.35133000",
                "longitude": "-122.10052000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120862,
                "name": "Lucas Valley-Marinwood",
                "latitude": "38.04011000",
                "longitude": "-122.57550000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120865,
                "name": "Lucerne",
                "latitude": "36.38078000",
                "longitude": "-119.66430000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120866,
                "name": "Lucerne Valley",
                "latitude": "34.44389000",
                "longitude": "-116.96781000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120934,
                "name": "Lynwood",
                "latitude": "33.93029000",
                "longitude": "-118.21146000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120980,
                "name": "Madera",
                "latitude": "36.96134000",
                "longitude": "-120.06072000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120981,
                "name": "Madera Acres",
                "latitude": "37.01911000",
                "longitude": "-120.06683000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 120982,
                "name": "Madera County",
                "latitude": "37.21804000",
                "longitude": "-119.76265000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121031,
                "name": "Magalia",
                "latitude": "39.81211000",
                "longitude": "-121.57831000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121062,
                "name": "Malibu",
                "latitude": "34.02577000",
                "longitude": "-118.78040000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121077,
                "name": "Mammoth Lakes",
                "latitude": "37.64855000",
                "longitude": "-118.97208000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121117,
                "name": "Manhattan Beach",
                "latitude": "33.88474000",
                "longitude": "-118.41091000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121154,
                "name": "Manteca",
                "latitude": "37.79743000",
                "longitude": "-121.21605000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121196,
                "name": "March Air Force Base",
                "latitude": "33.89209000",
                "longitude": "-117.26310000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121212,
                "name": "Maricopa",
                "latitude": "35.05886000",
                "longitude": "-119.40095000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121221,
                "name": "Marin City",
                "latitude": "37.86854000",
                "longitude": "-122.50914000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121222,
                "name": "Marin County",
                "latitude": "38.05518000",
                "longitude": "-122.74886000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121223,
                "name": "Marina",
                "latitude": "36.68440000",
                "longitude": "-121.80217000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121224,
                "name": "Marina del Rey",
                "latitude": "33.98029000",
                "longitude": "-118.45174000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121264,
                "name": "Mariposa",
                "latitude": "37.48494000",
                "longitude": "-119.96628000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121265,
                "name": "Mariposa County",
                "latitude": "37.58152000",
                "longitude": "-119.90552000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121345,
                "name": "Martinez",
                "latitude": "38.01937000",
                "longitude": "-122.13413000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121360,
                "name": "Marysville",
                "latitude": "39.14573000",
                "longitude": "-121.59135000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121401,
                "name": "Matheny",
                "latitude": "36.17066000",
                "longitude": "-119.35158000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121430,
                "name": "Maxwell",
                "latitude": "39.27628000",
                "longitude": "-122.19137000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121439,
                "name": "Mayflower Village",
                "latitude": "34.11501000",
                "longitude": "-118.00979000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121459,
                "name": "Maywood",
                "latitude": "33.98668000",
                "longitude": "-118.18535000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121471,
                "name": "McCloud",
                "latitude": "41.25571000",
                "longitude": "-122.13945000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121500,
                "name": "McFarland",
                "latitude": "35.67801000",
                "longitude": "-119.22927000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121524,
                "name": "McKinleyville",
                "latitude": "40.94652000",
                "longitude": "-124.10062000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121554,
                "name": "Mead Valley",
                "latitude": "33.83335000",
                "longitude": "-117.29615000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121563,
                "name": "Meadow Vista",
                "latitude": "39.00101000",
                "longitude": "-121.02189000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121567,
                "name": "Meadowbrook",
                "latitude": "33.72578000",
                "longitude": "-117.28509000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121578,
                "name": "Mecca",
                "latitude": "33.57219000",
                "longitude": "-116.07820000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121619,
                "name": "Meiners Oaks",
                "latitude": "34.44694000",
                "longitude": "-119.27928000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121652,
                "name": "Mendocino County",
                "latitude": "39.43362000",
                "longitude": "-123.43155000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121657,
                "name": "Mendota",
                "latitude": "36.75356000",
                "longitude": "-120.38156000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121659,
                "name": "Menifee",
                "latitude": "33.72835000",
                "longitude": "-117.14642000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121661,
                "name": "Menlo Park",
                "latitude": "37.45383000",
                "longitude": "-122.18219000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121667,
                "name": "Mentone",
                "latitude": "34.07001000",
                "longitude": "-117.13448000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121671,
                "name": "Merced",
                "latitude": "37.30216000",
                "longitude": "-120.48297000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121672,
                "name": "Merced County",
                "latitude": "37.19186000",
                "longitude": "-120.71767000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121722,
                "name": "Mesa Verde",
                "latitude": "33.60586000",
                "longitude": "-114.73107000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121794,
                "name": "Middletown",
                "latitude": "38.75240000",
                "longitude": "-122.61499000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121809,
                "name": "Midpines",
                "latitude": "37.54438000",
                "longitude": "-119.92045000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121821,
                "name": "Midway City",
                "latitude": "33.74474000",
                "longitude": "-117.98923000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121868,
                "name": "Mill Valley",
                "latitude": "37.90604000",
                "longitude": "-122.54498000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121871,
                "name": "Millbrae",
                "latitude": "37.59855000",
                "longitude": "-122.38719000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121909,
                "name": "Milpitas",
                "latitude": "37.42827000",
                "longitude": "-121.90662000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121949,
                "name": "Minkler",
                "latitude": "36.72384000",
                "longitude": "-119.45818000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121971,
                "name": "Mira Mesa",
                "latitude": "32.91560000",
                "longitude": "-117.14392000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121972,
                "name": "Mira Monte",
                "latitude": "34.43361000",
                "longitude": "-119.28511000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121984,
                "name": "Mission Canyon",
                "latitude": "34.45083000",
                "longitude": "-119.71291000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121985,
                "name": "Mission District",
                "latitude": "37.75993000",
                "longitude": "-122.41914000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121987,
                "name": "Mission Hills",
                "latitude": "34.68609000",
                "longitude": "-120.43683000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 121988,
                "name": "Mission Viejo",
                "latitude": "33.60002000",
                "longitude": "-117.67200000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122014,
                "name": "Modesto",
                "latitude": "37.63910000",
                "longitude": "-120.99688000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122015,
                "name": "Modoc County",
                "latitude": "41.58985000",
                "longitude": "-120.72497000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122023,
                "name": "Mojave",
                "latitude": "35.05247000",
                "longitude": "-118.17396000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122048,
                "name": "Mono County",
                "latitude": "37.93899000",
                "longitude": "-118.88671000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122049,
                "name": "Mono Vista",
                "latitude": "37.99770000",
                "longitude": "-120.26991000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122088,
                "name": "Monrovia",
                "latitude": "34.14806000",
                "longitude": "-117.99895000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122098,
                "name": "Montague",
                "latitude": "41.72820000",
                "longitude": "-122.52780000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122100,
                "name": "Montalvin",
                "latitude": "37.99548000",
                "longitude": "-122.33275000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122102,
                "name": "Montara",
                "latitude": "37.54216000",
                "longitude": "-122.51609000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122107,
                "name": "Montclair",
                "latitude": "34.07751000",
                "longitude": "-117.68978000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122109,
                "name": "Monte Rio",
                "latitude": "38.46547000",
                "longitude": "-123.00889000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122110,
                "name": "Monte Sereno",
                "latitude": "37.23633000",
                "longitude": "-121.99246000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122114,
                "name": "Montebello",
                "latitude": "34.00946000",
                "longitude": "-118.10535000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122115,
                "name": "Montecito",
                "latitude": "34.43666000",
                "longitude": "-119.63208000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122120,
                "name": "Monterey",
                "latitude": "36.60024000",
                "longitude": "-121.89468000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122121,
                "name": "Monterey County",
                "latitude": "36.23977000",
                "longitude": "-121.30890000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122122,
                "name": "Monterey Park",
                "latitude": "34.06251000",
                "longitude": "-118.12285000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122193,
                "name": "Monument Hills",
                "latitude": "38.66429000",
                "longitude": "-121.87566000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122213,
                "name": "Moorpark",
                "latitude": "34.28556000",
                "longitude": "-118.88204000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122221,
                "name": "Morada",
                "latitude": "38.03853000",
                "longitude": "-121.24578000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122222,
                "name": "Moraga",
                "latitude": "37.83493000",
                "longitude": "-122.12969000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122231,
                "name": "Moreno Valley",
                "latitude": "33.93752000",
                "longitude": "-117.23059000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122246,
                "name": "Morgan Hill",
                "latitude": "37.13050000",
                "longitude": "-121.65439000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122261,
                "name": "Morongo Valley",
                "latitude": "34.04695000",
                "longitude": "-116.58085000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122288,
                "name": "Morro Bay",
                "latitude": "35.36581000",
                "longitude": "-120.84990000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122307,
                "name": "Moss Beach",
                "latitude": "37.52744000",
                "longitude": "-122.51331000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122347,
                "name": "Mount Hermon",
                "latitude": "37.05106000",
                "longitude": "-122.05857000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122388,
                "name": "Mount Shasta",
                "latitude": "41.31024000",
                "longitude": "-122.31225000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122418,
                "name": "Mountain House",
                "latitude": "37.78326000",
                "longitude": "-121.54273000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122425,
                "name": "Mountain Ranch",
                "latitude": "38.22825000",
                "longitude": "-120.54076000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122431,
                "name": "Mountain View",
                "latitude": "37.38605000",
                "longitude": "-122.08385000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122434,
                "name": "Mountain View Acres",
                "latitude": "34.49666000",
                "longitude": "-117.34894000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122488,
                "name": "Murphys",
                "latitude": "38.13762000",
                "longitude": "-120.46105000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122498,
                "name": "Murrieta",
                "latitude": "33.55391000",
                "longitude": "-117.21392000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122499,
                "name": "Murrieta Hot Springs",
                "latitude": "33.56058000",
                "longitude": "-117.15809000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122506,
                "name": "Muscoy",
                "latitude": "34.15418000",
                "longitude": "-117.34421000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122525,
                "name": "Myrtletown",
                "latitude": "40.78874000",
                "longitude": "-124.13034000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122546,
                "name": "Napa",
                "latitude": "38.29714000",
                "longitude": "-122.28553000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122547,
                "name": "Napa County",
                "latitude": "38.50647000",
                "longitude": "-122.33053000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122591,
                "name": "National City",
                "latitude": "32.67811000",
                "longitude": "-117.09920000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122614,
                "name": "Needles",
                "latitude": "34.84806000",
                "longitude": "-114.61413000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122651,
                "name": "Nevada City",
                "latitude": "39.26173000",
                "longitude": "-121.01779000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122653,
                "name": "Nevada County",
                "latitude": "39.30137000",
                "longitude": "-120.76875000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122805,
                "name": "Newark",
                "latitude": "37.52966000",
                "longitude": "-122.04024000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122821,
                "name": "Newcastle",
                "latitude": "38.87407000",
                "longitude": "-121.13328000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122834,
                "name": "Newman",
                "latitude": "37.31383000",
                "longitude": "-121.02076000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122853,
                "name": "Newport Beach",
                "latitude": "33.61891000",
                "longitude": "-117.92895000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122885,
                "name": "Nice",
                "latitude": "39.12323000",
                "longitude": "-122.84833000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122899,
                "name": "Niland",
                "latitude": "33.24004000",
                "longitude": "-115.51888000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122905,
                "name": "Nipomo",
                "latitude": "35.04275000",
                "longitude": "-120.47600000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122925,
                "name": "Noe Valley",
                "latitude": "37.75018000",
                "longitude": "-122.43369000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122939,
                "name": "Norco",
                "latitude": "33.93113000",
                "longitude": "-117.54866000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 122968,
                "name": "North Auburn",
                "latitude": "38.93129000",
                "longitude": "-121.08189000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123020,
                "name": "North Edwards",
                "latitude": "35.01664000",
                "longitude": "-117.83284000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123021,
                "name": "North El Monte",
                "latitude": "34.10279000",
                "longitude": "-118.02423000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123024,
                "name": "North Fair Oaks",
                "latitude": "37.47438000",
                "longitude": "-122.19663000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123039,
                "name": "North Highlands",
                "latitude": "38.68574000",
                "longitude": "-121.37217000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123041,
                "name": "North Hills",
                "latitude": "34.23639000",
                "longitude": "-118.48472000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123042,
                "name": "North Hollywood",
                "latitude": "34.17223000",
                "longitude": "-118.37897000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123050,
                "name": "North Lakeport",
                "latitude": "39.08831000",
                "longitude": "-122.90538000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123094,
                "name": "North Richmond",
                "latitude": "37.95881000",
                "longitude": "-122.36747000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123117,
                "name": "North Tustin",
                "latitude": "33.76446000",
                "longitude": "-117.79394000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123163,
                "name": "Northridge",
                "latitude": "34.22834000",
                "longitude": "-118.53675000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123191,
                "name": "Norwalk",
                "latitude": "33.90224000",
                "longitude": "-118.08173000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123207,
                "name": "Novato",
                "latitude": "38.10742000",
                "longitude": "-122.56970000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123216,
                "name": "Nuevo",
                "latitude": "33.80141000",
                "longitude": "-117.14587000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123248,
                "name": "Oak Hills",
                "latitude": "34.38313000",
                "longitude": "-117.38135000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123257,
                "name": "Oak Park",
                "latitude": "34.17917000",
                "longitude": "-118.76287000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123266,
                "name": "Oak View",
                "latitude": "34.40000000",
                "longitude": "-119.30011000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123274,
                "name": "Oakdale",
                "latitude": "37.76659000",
                "longitude": "-120.84715000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123281,
                "name": "Oakhurst",
                "latitude": "37.32800000",
                "longitude": "-119.64932000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123293,
                "name": "Oakland",
                "latitude": "37.80437000",
                "longitude": "-122.27080000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123298,
                "name": "Oakley",
                "latitude": "37.99742000",
                "longitude": "-121.71245000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123313,
                "name": "Oasis",
                "latitude": "33.46586000",
                "longitude": "-116.09889000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123321,
                "name": "Occidental",
                "latitude": "38.40741000",
                "longitude": "-122.94833000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123341,
                "name": "Oceano",
                "latitude": "35.09886000",
                "longitude": "-120.61239000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123344,
                "name": "Oceanside",
                "latitude": "33.19587000",
                "longitude": "-117.37948000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123388,
                "name": "Oildale",
                "latitude": "35.41968000",
                "longitude": "-119.01955000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123390,
                "name": "Ojai",
                "latitude": "34.44805000",
                "longitude": "-119.24289000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123418,
                "name": "Old Fig Garden",
                "latitude": "36.79885000",
                "longitude": "-119.80515000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123441,
                "name": "Olivehurst",
                "latitude": "39.09545000",
                "longitude": "-121.55219000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123486,
                "name": "Ontario",
                "latitude": "34.06334000",
                "longitude": "-117.65089000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123495,
                "name": "Opal Cliffs",
                "latitude": "36.96078000",
                "longitude": "-121.96413000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123510,
                "name": "Orange",
                "latitude": "33.78779000",
                "longitude": "-117.85311000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123521,
                "name": "Orange County",
                "latitude": "33.67691000",
                "longitude": "-117.77617000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123522,
                "name": "Orange Cove",
                "latitude": "36.62439000",
                "longitude": "-119.31373000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123530,
                "name": "Orangevale",
                "latitude": "38.67851000",
                "longitude": "-121.22578000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123541,
                "name": "Orcutt",
                "latitude": "34.86526000",
                "longitude": "-120.43600000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123554,
                "name": "Orinda",
                "latitude": "37.87715000",
                "longitude": "-122.17969000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123559,
                "name": "Orland",
                "latitude": "39.74738000",
                "longitude": "-122.19637000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123577,
                "name": "Orosi",
                "latitude": "36.54495000",
                "longitude": "-119.28734000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123578,
                "name": "Oroville",
                "latitude": "39.51394000",
                "longitude": "-121.55776000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123580,
                "name": "Oroville East",
                "latitude": "39.51126000",
                "longitude": "-121.47519000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123689,
                "name": "Oxnard",
                "latitude": "34.19750000",
                "longitude": "-119.17705000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123705,
                "name": "Pacheco",
                "latitude": "37.98353000",
                "longitude": "-122.07524000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123710,
                "name": "Pacific Grove",
                "latitude": "36.61774000",
                "longitude": "-121.91662000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123711,
                "name": "Pacifica",
                "latitude": "37.61383000",
                "longitude": "-122.48692000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123729,
                "name": "Pajaro",
                "latitude": "36.90412000",
                "longitude": "-121.74856000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123735,
                "name": "Palermo",
                "latitude": "39.43544000",
                "longitude": "-121.53802000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123748,
                "name": "Palm Desert",
                "latitude": "33.72255000",
                "longitude": "-116.37697000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123752,
                "name": "Palm Springs",
                "latitude": "33.83030000",
                "longitude": "-116.54529000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123757,
                "name": "Palmdale",
                "latitude": "34.57943000",
                "longitude": "-118.11646000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123781,
                "name": "Palo Alto",
                "latitude": "37.44188000",
                "longitude": "-122.14302000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123783,
                "name": "Palo Cedro",
                "latitude": "40.56376000",
                "longitude": "-122.23889000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123791,
                "name": "Palos Verdes Estates",
                "latitude": "33.80105000",
                "longitude": "-118.39245000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123818,
                "name": "Paradise",
                "latitude": "39.75961000",
                "longitude": "-121.62192000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123824,
                "name": "Paramount",
                "latitude": "33.88946000",
                "longitude": "-118.15979000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123874,
                "name": "Parksdale",
                "latitude": "36.94717000",
                "longitude": "-120.02294000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123881,
                "name": "Parkway",
                "latitude": "38.49602000",
                "longitude": "-121.45884000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123882,
                "name": "Parkwood",
                "latitude": "36.92689000",
                "longitude": "-120.04461000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123884,
                "name": "Parlier",
                "latitude": "36.61162000",
                "longitude": "-119.52707000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123897,
                "name": "Pasadena",
                "latitude": "34.14778000",
                "longitude": "-118.14452000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123899,
                "name": "Pasatiempo",
                "latitude": "37.00439000",
                "longitude": "-122.02580000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123904,
                "name": "Paso Robles",
                "latitude": "35.62664000",
                "longitude": "-120.69100000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123916,
                "name": "Patterson",
                "latitude": "37.47160000",
                "longitude": "-121.12966000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123917,
                "name": "Patterson Tract",
                "latitude": "36.37952000",
                "longitude": "-119.29560000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 123983,
                "name": "Pedley",
                "latitude": "33.97529000",
                "longitude": "-117.47588000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124024,
                "name": "Penn Valley",
                "latitude": "39.19600000",
                "longitude": "-121.19107000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124028,
                "name": "Penngrove",
                "latitude": "38.29964000",
                "longitude": "-122.66665000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124066,
                "name": "Perris",
                "latitude": "33.78252000",
                "longitude": "-117.22865000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124101,
                "name": "Petaluma",
                "latitude": "38.23242000",
                "longitude": "-122.63665000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124119,
                "name": "Phelan",
                "latitude": "34.42611000",
                "longitude": "-117.57228000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124150,
                "name": "Phoenix Lake",
                "latitude": "38.00594000",
                "longitude": "-120.30702000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124162,
                "name": "Pico Rivera",
                "latitude": "33.98307000",
                "longitude": "-118.09673000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124168,
                "name": "Piedmont",
                "latitude": "37.82437000",
                "longitude": "-122.23163000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124222,
                "name": "Pine Grove",
                "latitude": "38.41297000",
                "longitude": "-120.65882000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124226,
                "name": "Pine Hills",
                "latitude": "40.73318000",
                "longitude": "-124.15228000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124239,
                "name": "Pine Mountain Club",
                "latitude": "34.84637000",
                "longitude": "-119.14955000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124246,
                "name": "Pine Valley",
                "latitude": "32.82144000",
                "longitude": "-116.52918000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124271,
                "name": "Pinole",
                "latitude": "38.00437000",
                "longitude": "-122.29886000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124309,
                "name": "Piñon Hills",
                "latitude": "34.43333000",
                "longitude": "-117.64672000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124274,
                "name": "Pioneer",
                "latitude": "38.43186000",
                "longitude": "-120.57187000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124280,
                "name": "Piru",
                "latitude": "34.41527000",
                "longitude": "-118.79398000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124283,
                "name": "Pismo Beach",
                "latitude": "35.14275000",
                "longitude": "-120.64128000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124294,
                "name": "Pittsburg",
                "latitude": "38.02798000",
                "longitude": "-121.88468000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124308,
                "name": "Pixley",
                "latitude": "35.96856000",
                "longitude": "-119.29178000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124310,
                "name": "Placentia",
                "latitude": "33.87224000",
                "longitude": "-117.87034000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124311,
                "name": "Placer County",
                "latitude": "39.06343000",
                "longitude": "-120.71766000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124312,
                "name": "Placerville",
                "latitude": "38.72963000",
                "longitude": "-120.79855000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124338,
                "name": "Planada",
                "latitude": "37.29077000",
                "longitude": "-120.31852000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124372,
                "name": "Pleasant Hill",
                "latitude": "37.94798000",
                "longitude": "-122.06080000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124384,
                "name": "Pleasanton",
                "latitude": "37.66243000",
                "longitude": "-121.87468000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124395,
                "name": "Plumas County",
                "latitude": "40.00468000",
                "longitude": "-120.83860000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124396,
                "name": "Plumas Lake",
                "latitude": "39.02073000",
                "longitude": "-121.55802000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124453,
                "name": "Pollock Pines",
                "latitude": "38.76158000",
                "longitude": "-120.58611000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124459,
                "name": "Pomona",
                "latitude": "34.05529000",
                "longitude": "-117.75228000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124486,
                "name": "Poplar-Cotton Center",
                "latitude": "36.05635000",
                "longitude": "-119.14919000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124510,
                "name": "Port Hueneme",
                "latitude": "34.14778000",
                "longitude": "-119.19511000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124556,
                "name": "Porterville",
                "latitude": "36.06523000",
                "longitude": "-119.01677000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124566,
                "name": "Portola",
                "latitude": "39.81046000",
                "longitude": "-120.46910000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124567,
                "name": "Portola Hills",
                "latitude": "33.67919000",
                "longitude": "-117.63116000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124568,
                "name": "Portola Valley",
                "latitude": "37.38411000",
                "longitude": "-122.23524000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124606,
                "name": "Poway",
                "latitude": "32.96282000",
                "longitude": "-117.03586000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124725,
                "name": "Prunedale",
                "latitude": "36.77579000",
                "longitude": "-121.66967000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124777,
                "name": "Quail Valley",
                "latitude": "33.70697000",
                "longitude": "-117.24504000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124782,
                "name": "Quartz Hill",
                "latitude": "34.64526000",
                "longitude": "-118.21813000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124799,
                "name": "Quincy",
                "latitude": "39.93682000",
                "longitude": "-120.94647000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124823,
                "name": "Rainbow",
                "latitude": "33.41031000",
                "longitude": "-117.14781000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124838,
                "name": "Ramona",
                "latitude": "33.04171000",
                "longitude": "-116.86808000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124848,
                "name": "Rancho Calaveras",
                "latitude": "38.12742000",
                "longitude": "-120.85827000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124849,
                "name": "Rancho Cordova",
                "latitude": "38.58907000",
                "longitude": "-121.30273000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124850,
                "name": "Rancho Cucamonga",
                "latitude": "34.10640000",
                "longitude": "-117.59311000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124851,
                "name": "Rancho Mirage",
                "latitude": "33.73974000",
                "longitude": "-116.41279000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124852,
                "name": "Rancho Murieta",
                "latitude": "38.50185000",
                "longitude": "-121.09467000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124853,
                "name": "Rancho Palos Verdes",
                "latitude": "33.74446000",
                "longitude": "-118.38702000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124854,
                "name": "Rancho Penasquitos",
                "latitude": "32.95949000",
                "longitude": "-117.11531000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124855,
                "name": "Rancho San Diego",
                "latitude": "32.74727000",
                "longitude": "-116.93530000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124856,
                "name": "Rancho Santa Fe",
                "latitude": "33.02032000",
                "longitude": "-117.20281000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124857,
                "name": "Rancho Santa Margarita",
                "latitude": "33.64086000",
                "longitude": "-117.60310000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124858,
                "name": "Rancho Tehama Reserve",
                "latitude": "40.01569000",
                "longitude": "-122.40072000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124940,
                "name": "Red Bluff",
                "latitude": "40.17849000",
                "longitude": "-122.23583000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124945,
                "name": "Red Corral",
                "latitude": "38.41165000",
                "longitude": "-120.60552000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124966,
                "name": "Redding",
                "latitude": "40.58654000",
                "longitude": "-122.39168000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124976,
                "name": "Redlands",
                "latitude": "34.05557000",
                "longitude": "-117.18254000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124980,
                "name": "Redondo Beach",
                "latitude": "33.84918000",
                "longitude": "-118.38841000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124983,
                "name": "Redway",
                "latitude": "40.12014000",
                "longitude": "-123.82336000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124986,
                "name": "Redwood City",
                "latitude": "37.48522000",
                "longitude": "-122.23635000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124989,
                "name": "Redwood Shores",
                "latitude": "37.53188000",
                "longitude": "-122.24802000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124990,
                "name": "Redwood Valley",
                "latitude": "39.26544000",
                "longitude": "-123.20445000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 124993,
                "name": "Reedley",
                "latitude": "36.59634000",
                "longitude": "-119.45040000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125049,
                "name": "Rialto",
                "latitude": "34.10640000",
                "longitude": "-117.37032000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125066,
                "name": "Richgrove",
                "latitude": "35.79662000",
                "longitude": "-119.10788000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125096,
                "name": "Richmond",
                "latitude": "37.93576000",
                "longitude": "-122.34775000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125118,
                "name": "Ridgecrest",
                "latitude": "35.62246000",
                "longitude": "-117.67090000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125127,
                "name": "Ridgemark",
                "latitude": "36.81246000",
                "longitude": "-121.36577000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125151,
                "name": "Rio Del Mar",
                "latitude": "36.96828000",
                "longitude": "-121.90023000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125152,
                "name": "Rio Dell",
                "latitude": "40.49930000",
                "longitude": "-124.10644000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125157,
                "name": "Rio Linda",
                "latitude": "38.69101000",
                "longitude": "-121.44857000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125161,
                "name": "Rio Vista",
                "latitude": "38.16389000",
                "longitude": "-121.69583000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125168,
                "name": "Ripon",
                "latitude": "37.74159000",
                "longitude": "-121.12438000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125190,
                "name": "Riverbank",
                "latitude": "37.73604000",
                "longitude": "-120.93549000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125196,
                "name": "Riverdale",
                "latitude": "36.43106000",
                "longitude": "-119.85958000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125199,
                "name": "Riverdale Park",
                "latitude": "37.60938000",
                "longitude": "-121.05188000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125209,
                "name": "Riverside",
                "latitude": "33.95335000",
                "longitude": "-117.39616000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125210,
                "name": "Riverside County",
                "latitude": "33.74368000",
                "longitude": "-115.99386000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125313,
                "name": "Rocklin",
                "latitude": "38.79073000",
                "longitude": "-121.23578000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125341,
                "name": "Rodeo",
                "latitude": "38.03298000",
                "longitude": "-122.26691000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125358,
                "name": "Rohnert Park",
                "latitude": "38.33964000",
                "longitude": "-122.70110000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125366,
                "name": "Rolling Hills",
                "latitude": "33.75739000",
                "longitude": "-118.35752000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125367,
                "name": "Rolling Hills Estates",
                "latitude": "33.78779000",
                "longitude": "-118.35813000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125370,
                "name": "Rollingwood",
                "latitude": "37.96520000",
                "longitude": "-122.32997000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125384,
                "name": "Romoland",
                "latitude": "33.74585000",
                "longitude": "-117.17503000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125397,
                "name": "Rosamond",
                "latitude": "34.86414000",
                "longitude": "-118.16341000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125419,
                "name": "Rosedale",
                "latitude": "35.38357000",
                "longitude": "-119.14538000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125424,
                "name": "Roseland",
                "latitude": "38.42213000",
                "longitude": "-122.72804000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125429,
                "name": "Rosemead",
                "latitude": "34.08057000",
                "longitude": "-118.07285000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125431,
                "name": "Rosemont",
                "latitude": "38.55185000",
                "longitude": "-121.36467000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125441,
                "name": "Roseville",
                "latitude": "38.75212000",
                "longitude": "-121.28801000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125451,
                "name": "Ross",
                "latitude": "37.96242000",
                "longitude": "-122.55498000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125455,
                "name": "Rossmoor",
                "latitude": "33.78557000",
                "longitude": "-118.08506000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125480,
                "name": "Rowland Heights",
                "latitude": "33.97612000",
                "longitude": "-117.90534000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125501,
                "name": "Rubidoux",
                "latitude": "33.99613000",
                "longitude": "-117.40560000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125514,
                "name": "Running Springs",
                "latitude": "34.20779000",
                "longitude": "-117.10920000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125577,
                "name": "Sacramento",
                "latitude": "38.58157000",
                "longitude": "-121.49440000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125578,
                "name": "Sacramento County",
                "latitude": "38.44932000",
                "longitude": "-121.34424000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125647,
                "name": "Saint Helena",
                "latitude": "38.50519000",
                "longitude": "-122.47026000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125742,
                "name": "Salida",
                "latitude": "37.70576000",
                "longitude": "-121.08494000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125747,
                "name": "Salinas",
                "latitude": "36.67774000",
                "longitude": "-121.65550000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125770,
                "name": "Salton City",
                "latitude": "33.29865000",
                "longitude": "-115.95611000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125783,
                "name": "San Andreas",
                "latitude": "38.19603000",
                "longitude": "-120.68049000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125785,
                "name": "San Anselmo",
                "latitude": "37.97465000",
                "longitude": "-122.56164000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125788,
                "name": "San Antonio Heights",
                "latitude": "34.15556000",
                "longitude": "-117.65644000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125792,
                "name": "San Benito County",
                "latitude": "36.60571000",
                "longitude": "-121.07500000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125793,
                "name": "San Bernardino",
                "latitude": "34.10834000",
                "longitude": "-117.28977000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125794,
                "name": "San Bernardino County",
                "latitude": "34.84143000",
                "longitude": "-116.17846000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125795,
                "name": "San Bruno",
                "latitude": "37.63049000",
                "longitude": "-122.41108000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125798,
                "name": "San Carlos",
                "latitude": "37.50716000",
                "longitude": "-122.26052000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125800,
                "name": "San Clemente",
                "latitude": "33.42697000",
                "longitude": "-117.61199000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125802,
                "name": "San Diego",
                "latitude": "32.71571000",
                "longitude": "-117.16472000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125803,
                "name": "San Diego Country Estates",
                "latitude": "33.00671000",
                "longitude": "-116.78364000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125804,
                "name": "San Diego County",
                "latitude": "33.02820000",
                "longitude": "-116.77021000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125805,
                "name": "San Dimas",
                "latitude": "34.10668000",
                "longitude": "-117.80673000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125808,
                "name": "San Fernando",
                "latitude": "34.28195000",
                "longitude": "-118.43897000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125809,
                "name": "San Francisco",
                "latitude": "37.77493000",
                "longitude": "-122.41942000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125810,
                "name": "San Gabriel",
                "latitude": "34.09611000",
                "longitude": "-118.10583000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125811,
                "name": "San Jacinto",
                "latitude": "33.78391000",
                "longitude": "-116.95864000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125813,
                "name": "San Joaquin",
                "latitude": "36.60662000",
                "longitude": "-120.18904000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125814,
                "name": "San Joaquin County",
                "latitude": "37.93478000",
                "longitude": "-121.27145000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125815,
                "name": "San Joaquin Hills",
                "latitude": "33.61169000",
                "longitude": "-117.83672000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125816,
                "name": "San Jose",
                "latitude": "37.33939000",
                "longitude": "-121.89496000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125818,
                "name": "San Juan Bautista",
                "latitude": "36.84551000",
                "longitude": "-121.53800000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125819,
                "name": "San Juan Capistrano",
                "latitude": "33.50169000",
                "longitude": "-117.66255000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125824,
                "name": "San Leandro",
                "latitude": "37.72493000",
                "longitude": "-122.15608000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125826,
                "name": "San Lorenzo",
                "latitude": "37.68104000",
                "longitude": "-122.12441000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125829,
                "name": "San Luis Obispo",
                "latitude": "35.28275000",
                "longitude": "-120.65962000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125830,
                "name": "San Luis Obispo County",
                "latitude": "35.38742000",
                "longitude": "-120.45220000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125833,
                "name": "San Marcos",
                "latitude": "33.14337000",
                "longitude": "-117.16614000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125834,
                "name": "San Marino",
                "latitude": "34.12140000",
                "longitude": "-118.10646000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125835,
                "name": "San Martin",
                "latitude": "37.08495000",
                "longitude": "-121.61022000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125836,
                "name": "San Mateo",
                "latitude": "37.56299000",
                "longitude": "-122.32553000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125837,
                "name": "San Mateo County",
                "latitude": "37.43621000",
                "longitude": "-122.35566000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125838,
                "name": "San Miguel",
                "latitude": "35.75247000",
                "longitude": "-120.69628000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125842,
                "name": "San Pablo",
                "latitude": "37.96215000",
                "longitude": "-122.34553000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125843,
                "name": "San Pasqual",
                "latitude": "33.09171000",
                "longitude": "-116.95392000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125845,
                "name": "San Pedro",
                "latitude": "33.73585000",
                "longitude": "-118.29229000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125846,
                "name": "San Rafael",
                "latitude": "37.97353000",
                "longitude": "-122.53109000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125847,
                "name": "San Ramon",
                "latitude": "37.77993000",
                "longitude": "-121.97802000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125892,
                "name": "Sanger",
                "latitude": "36.70801000",
                "longitude": "-119.55597000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125899,
                "name": "Santa Ana",
                "latitude": "33.74557000",
                "longitude": "-117.86783000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125901,
                "name": "Santa Barbara",
                "latitude": "34.42083000",
                "longitude": "-119.69819000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125902,
                "name": "Santa Barbara County",
                "latitude": "34.53834000",
                "longitude": "-120.03078000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125903,
                "name": "Santa Clara",
                "latitude": "37.35411000",
                "longitude": "-121.95524000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125906,
                "name": "Santa Clara County",
                "latitude": "37.23249000",
                "longitude": "-121.69627000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125908,
                "name": "Santa Clarita",
                "latitude": "34.39166000",
                "longitude": "-118.54259000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125910,
                "name": "Santa Cruz",
                "latitude": "36.97412000",
                "longitude": "-122.03080000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125912,
                "name": "Santa Cruz County",
                "latitude": "37.02161000",
                "longitude": "-122.00979000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125916,
                "name": "Santa Fe Springs",
                "latitude": "33.94724000",
                "longitude": "-118.08535000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125917,
                "name": "Santa Margarita",
                "latitude": "35.38997000",
                "longitude": "-120.60906000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125918,
                "name": "Santa Maria",
                "latitude": "34.95303000",
                "longitude": "-120.43572000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125919,
                "name": "Santa Monica",
                "latitude": "34.01945000",
                "longitude": "-118.49119000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125920,
                "name": "Santa Paula",
                "latitude": "34.35417000",
                "longitude": "-119.05927000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125922,
                "name": "Santa Rosa",
                "latitude": "38.44047000",
                "longitude": "-122.71443000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125925,
                "name": "Santa Susana",
                "latitude": "34.27167000",
                "longitude": "-118.70898000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125927,
                "name": "Santa Venetia",
                "latitude": "37.99853000",
                "longitude": "-122.52525000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125928,
                "name": "Santa Ynez",
                "latitude": "34.61443000",
                "longitude": "-120.07987000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125930,
                "name": "Santee",
                "latitude": "32.83838000",
                "longitude": "-116.97392000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125937,
                "name": "Saranap",
                "latitude": "37.88492000",
                "longitude": "-122.07607000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125941,
                "name": "Saratoga",
                "latitude": "37.26383000",
                "longitude": "-122.02301000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125956,
                "name": "Saticoy",
                "latitude": "34.28306000",
                "longitude": "-119.14983000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 125970,
                "name": "Sausalito",
                "latitude": "37.85909000",
                "longitude": "-122.48525000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126059,
                "name": "Scotts Valley",
                "latitude": "37.05106000",
                "longitude": "-122.01468000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126075,
                "name": "Sea Ranch",
                "latitude": "38.71519000",
                "longitude": "-123.45445000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126083,
                "name": "Seacliff",
                "latitude": "36.97412000",
                "longitude": "-121.91579000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126090,
                "name": "Seal Beach",
                "latitude": "33.74141000",
                "longitude": "-118.10479000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126095,
                "name": "Searles Valley",
                "latitude": "35.76745000",
                "longitude": "-117.40395000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126099,
                "name": "Seaside",
                "latitude": "36.61107000",
                "longitude": "-121.85162000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126108,
                "name": "Sebastopol",
                "latitude": "38.40214000",
                "longitude": "-122.82388000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126116,
                "name": "Sedco Hills",
                "latitude": "33.64169000",
                "longitude": "-117.29087000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126124,
                "name": "Seeley",
                "latitude": "32.79311000",
                "longitude": "-115.69111000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126141,
                "name": "Selma",
                "latitude": "36.57078000",
                "longitude": "-119.61208000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126176,
                "name": "Seven Trees",
                "latitude": "37.28605000",
                "longitude": "-121.83856000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126198,
                "name": "Shackelford",
                "latitude": "37.61382000",
                "longitude": "-120.99271000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126202,
                "name": "Shadow Hills",
                "latitude": "34.26195000",
                "longitude": "-118.35175000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126210,
                "name": "Shafter",
                "latitude": "35.50051000",
                "longitude": "-119.27178000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126217,
                "name": "Shandon",
                "latitude": "35.65525000",
                "longitude": "-120.37543000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126238,
                "name": "Shasta",
                "latitude": "40.59932000",
                "longitude": "-122.49196000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126239,
                "name": "Shasta County",
                "latitude": "40.76377000",
                "longitude": "-122.04052000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126240,
                "name": "Shasta Lake",
                "latitude": "40.68043000",
                "longitude": "-122.37084000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126321,
                "name": "Sheridan",
                "latitude": "38.97962000",
                "longitude": "-121.37551000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126336,
                "name": "Sherman Oaks",
                "latitude": "34.15112000",
                "longitude": "-118.44925000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126351,
                "name": "Shingle Springs",
                "latitude": "38.66574000",
                "longitude": "-120.92605000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126353,
                "name": "Shingletown",
                "latitude": "40.49238000",
                "longitude": "-121.88916000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126402,
                "name": "Sierra County",
                "latitude": "39.58040000",
                "longitude": "-120.51600000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126404,
                "name": "Sierra Madre",
                "latitude": "34.16167000",
                "longitude": "-118.05285000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126411,
                "name": "Signal Hill",
                "latitude": "33.80446000",
                "longitude": "-118.16785000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126431,
                "name": "Silver Lake",
                "latitude": "34.08668000",
                "longitude": "-118.27023000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126432,
                "name": "Silver Lakes",
                "latitude": "34.74558000",
                "longitude": "-117.34098000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126445,
                "name": "Simi Valley",
                "latitude": "34.26945000",
                "longitude": "-118.78148000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126465,
                "name": "Siskiyou County",
                "latitude": "41.59265000",
                "longitude": "-122.54037000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126486,
                "name": "Sky Valley",
                "latitude": "33.89001000",
                "longitude": "-116.35251000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126499,
                "name": "Sleepy Hollow",
                "latitude": "38.01048000",
                "longitude": "-122.58442000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126561,
                "name": "Soda Bay",
                "latitude": "39.00101000",
                "longitude": "-122.78916000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126565,
                "name": "Solana Beach",
                "latitude": "32.99115000",
                "longitude": "-117.27115000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126566,
                "name": "Solano County",
                "latitude": "38.26692000",
                "longitude": "-121.94001000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126568,
                "name": "Soledad",
                "latitude": "36.42469000",
                "longitude": "-121.32632000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126572,
                "name": "Solvang",
                "latitude": "34.59582000",
                "longitude": "-120.13765000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126598,
                "name": "Sonoma",
                "latitude": "38.29186000",
                "longitude": "-122.45804000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126599,
                "name": "Sonoma County",
                "latitude": "38.52529000",
                "longitude": "-122.92254000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126600,
                "name": "Sonora",
                "latitude": "37.98409000",
                "longitude": "-120.38214000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126604,
                "name": "Soquel",
                "latitude": "36.98801000",
                "longitude": "-121.95663000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126606,
                "name": "Sorrento Valley",
                "latitude": "32.89991000",
                "longitude": "-117.19451000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126608,
                "name": "Soulsbyville",
                "latitude": "37.98465000",
                "longitude": "-120.26380000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126648,
                "name": "South Dos Palos",
                "latitude": "36.96439000",
                "longitude": "-120.65324000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126650,
                "name": "South El Monte",
                "latitude": "34.05195000",
                "longitude": "-118.04673000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126659,
                "name": "South Gate",
                "latitude": "33.95474000",
                "longitude": "-118.21202000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126684,
                "name": "South Lake Tahoe",
                "latitude": "38.93324000",
                "longitude": "-119.98435000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126699,
                "name": "South Oroville",
                "latitude": "39.49655000",
                "longitude": "-121.55219000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126706,
                "name": "South Pasadena",
                "latitude": "34.11612000",
                "longitude": "-118.15035000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126723,
                "name": "South San Francisco",
                "latitude": "37.65466000",
                "longitude": "-122.40775000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126724,
                "name": "South San Gabriel",
                "latitude": "34.04915000",
                "longitude": "-118.09462000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126725,
                "name": "South San Jose Hills",
                "latitude": "34.01279000",
                "longitude": "-117.90478000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126733,
                "name": "South Taft",
                "latitude": "35.13469000",
                "longitude": "-119.45623000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126748,
                "name": "South Whittier",
                "latitude": "33.95015000",
                "longitude": "-118.03917000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126756,
                "name": "South Yuba City",
                "latitude": "39.11656000",
                "longitude": "-121.63913000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126880,
                "name": "Spring Valley",
                "latitude": "32.74477000",
                "longitude": "-116.99892000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126882,
                "name": "Spring Valley Lake",
                "latitude": "34.49364000",
                "longitude": "-117.26832000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126924,
                "name": "Squaw Valley",
                "latitude": "36.74023000",
                "longitude": "-119.24679000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126941,
                "name": "Stallion Springs",
                "latitude": "35.08886000",
                "longitude": "-118.64259000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126954,
                "name": "Stanford",
                "latitude": "37.42411000",
                "longitude": "-122.16608000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126957,
                "name": "Stanislaus County",
                "latitude": "37.55914000",
                "longitude": "-120.99769000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 126969,
                "name": "Stanton",
                "latitude": "33.80252000",
                "longitude": "-117.99312000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127046,
                "name": "Stevenson Ranch",
                "latitude": "34.39048000",
                "longitude": "-118.57372000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127074,
                "name": "Stockton",
                "latitude": "37.95770000",
                "longitude": "-121.29078000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127127,
                "name": "Stratford",
                "latitude": "36.18940000",
                "longitude": "-119.82319000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127131,
                "name": "Strathmore",
                "latitude": "36.14551000",
                "longitude": "-119.06066000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127133,
                "name": "Strawberry",
                "latitude": "37.89687000",
                "longitude": "-122.50886000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127146,
                "name": "Studio City",
                "latitude": "34.14862000",
                "longitude": "-118.39647000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127177,
                "name": "Suisun",
                "latitude": "38.23825000",
                "longitude": "-122.04024000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127204,
                "name": "Summerland",
                "latitude": "34.42138000",
                "longitude": "-119.59652000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127233,
                "name": "Sun City",
                "latitude": "33.70919000",
                "longitude": "-117.19726000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127243,
                "name": "Sun Village",
                "latitude": "34.55952000",
                "longitude": "-117.95676000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127253,
                "name": "Sunland",
                "latitude": "34.26695000",
                "longitude": "-118.30230000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127259,
                "name": "Sunnyside",
                "latitude": "36.74912000",
                "longitude": "-119.69931000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127261,
                "name": "Sunnyside-Tahoe City",
                "latitude": "39.15023000",
                "longitude": "-120.16120000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127262,
                "name": "Sunnyslope",
                "latitude": "34.01196000",
                "longitude": "-117.43338000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127265,
                "name": "Sunnyvale",
                "latitude": "37.36883000",
                "longitude": "-122.03635000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127296,
                "name": "Susanville",
                "latitude": "40.41628000",
                "longitude": "-120.65301000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127308,
                "name": "Sutter",
                "latitude": "39.15989000",
                "longitude": "-121.75275000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127309,
                "name": "Sutter County",
                "latitude": "39.03452000",
                "longitude": "-121.69484000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127310,
                "name": "Sutter Creek",
                "latitude": "38.39297000",
                "longitude": "-120.80244000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127373,
                "name": "Taft",
                "latitude": "35.14247000",
                "longitude": "-119.45651000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127374,
                "name": "Taft Heights",
                "latitude": "35.13469000",
                "longitude": "-119.47262000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127375,
                "name": "Taft Mosswood",
                "latitude": "37.91385000",
                "longitude": "-121.28316000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127378,
                "name": "Tahoe Vista",
                "latitude": "39.23991000",
                "longitude": "-120.05102000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127380,
                "name": "Tahoma",
                "latitude": "39.06741000",
                "longitude": "-120.12824000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127397,
                "name": "Talmage",
                "latitude": "39.13323000",
                "longitude": "-123.16778000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127402,
                "name": "Tamalpais Valley",
                "latitude": "37.87965000",
                "longitude": "-122.54581000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127403,
                "name": "Tamalpais-Homestead Valley",
                "latitude": "37.87834000",
                "longitude": "-122.53625000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127427,
                "name": "Tara Hills",
                "latitude": "37.99353000",
                "longitude": "-122.31636000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127432,
                "name": "Tarpey Village",
                "latitude": "36.79301000",
                "longitude": "-119.70097000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127483,
                "name": "Tehachapi",
                "latitude": "35.13219000",
                "longitude": "-118.44897000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127484,
                "name": "Tehama County",
                "latitude": "40.12574000",
                "longitude": "-122.23388000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127492,
                "name": "Temecula",
                "latitude": "33.49364000",
                "longitude": "-117.14836000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127493,
                "name": "Temelec",
                "latitude": "38.26658000",
                "longitude": "-122.49276000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127501,
                "name": "Temple City",
                "latitude": "34.10723000",
                "longitude": "-118.05785000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127505,
                "name": "Templeton",
                "latitude": "35.54969000",
                "longitude": "-120.70600000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127515,
                "name": "Terra Bella",
                "latitude": "35.96245000",
                "longitude": "-119.04427000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127541,
                "name": "Teviston",
                "latitude": "35.92894000",
                "longitude": "-119.27831000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127570,
                "name": "Thermal",
                "latitude": "33.64030000",
                "longitude": "-116.13945000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127571,
                "name": "Thermalito",
                "latitude": "39.51128000",
                "longitude": "-121.58692000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127604,
                "name": "Thornton",
                "latitude": "38.22603000",
                "longitude": "-121.42467000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127609,
                "name": "Thousand Oaks",
                "latitude": "34.17056000",
                "longitude": "-118.83759000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127610,
                "name": "Thousand Palms",
                "latitude": "33.82002000",
                "longitude": "-116.39029000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127620,
                "name": "Three Rivers",
                "latitude": "36.43884000",
                "longitude": "-118.90454000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127632,
                "name": "Tiburon",
                "latitude": "37.87354000",
                "longitude": "-122.45664000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127637,
                "name": "Tierra Buena",
                "latitude": "39.14878000",
                "longitude": "-121.66691000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127678,
                "name": "Tipton",
                "latitude": "36.05940000",
                "longitude": "-119.31206000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127730,
                "name": "Topanga",
                "latitude": "34.09362000",
                "longitude": "-118.60147000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127741,
                "name": "Toro Canyon",
                "latitude": "34.42000000",
                "longitude": "-119.56707000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127742,
                "name": "Torrance",
                "latitude": "33.83585000",
                "longitude": "-118.34063000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127769,
                "name": "Trabuco Canyon",
                "latitude": "33.66252000",
                "longitude": "-117.59033000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127771,
                "name": "Tracy",
                "latitude": "37.73987000",
                "longitude": "-121.42618000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127829,
                "name": "Trinity County",
                "latitude": "40.65069000",
                "longitude": "-123.11263000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127853,
                "name": "Truckee",
                "latitude": "39.32796000",
                "longitude": "-120.18325000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127878,
                "name": "Tujunga",
                "latitude": "34.25223000",
                "longitude": "-118.28841000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127882,
                "name": "Tulare",
                "latitude": "36.20773000",
                "longitude": "-119.34734000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127883,
                "name": "Tulare County",
                "latitude": "36.22016000",
                "longitude": "-118.80047000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127895,
                "name": "Tuolumne City",
                "latitude": "37.96270000",
                "longitude": "-120.24130000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127896,
                "name": "Tuolumne County",
                "latitude": "38.02760000",
                "longitude": "-119.95475000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127900,
                "name": "Turlock",
                "latitude": "37.49466000",
                "longitude": "-120.84659000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127917,
                "name": "Tustin",
                "latitude": "33.74585000",
                "longitude": "-117.82617000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127920,
                "name": "Twain Harte",
                "latitude": "38.03965000",
                "longitude": "-120.23269000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127921,
                "name": "Twentynine Palms",
                "latitude": "34.13556000",
                "longitude": "-116.05417000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127930,
                "name": "Twin Lakes",
                "latitude": "36.96745000",
                "longitude": "-121.99802000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127958,
                "name": "Ukiah",
                "latitude": "39.15017000",
                "longitude": "-123.20778000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 127987,
                "name": "Union City",
                "latitude": "37.59577000",
                "longitude": "-122.01913000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128023,
                "name": "Universal City",
                "latitude": "34.13890000",
                "longitude": "-118.35341000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128039,
                "name": "Upland",
                "latitude": "34.09751000",
                "longitude": "-117.64839000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128045,
                "name": "Upper Lake",
                "latitude": "39.16461000",
                "longitude": "-122.91055000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128072,
                "name": "Vacaville",
                "latitude": "38.35658000",
                "longitude": "-121.98774000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128078,
                "name": "Val Verde",
                "latitude": "34.44500000",
                "longitude": "-118.65759000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128087,
                "name": "Valencia",
                "latitude": "34.44361000",
                "longitude": "-118.60953000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128093,
                "name": "Valinda",
                "latitude": "34.04529000",
                "longitude": "-117.94367000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128094,
                "name": "Valle Vista",
                "latitude": "33.74780000",
                "longitude": "-116.89336000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128096,
                "name": "Vallejo",
                "latitude": "38.10409000",
                "longitude": "-122.25664000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128100,
                "name": "Valley Center",
                "latitude": "33.21837000",
                "longitude": "-117.03420000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128109,
                "name": "Valley Glen",
                "latitude": "34.18991000",
                "longitude": "-118.44953000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128115,
                "name": "Valley Springs",
                "latitude": "38.19159000",
                "longitude": "-120.82910000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128137,
                "name": "Van Nuys",
                "latitude": "34.18667000",
                "longitude": "-118.44897000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128147,
                "name": "Vandenberg Air Force Base",
                "latitude": "34.74830000",
                "longitude": "-120.51817000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128148,
                "name": "Vandenberg Village",
                "latitude": "34.70832000",
                "longitude": "-120.46766000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128172,
                "name": "Venice",
                "latitude": "33.99084000",
                "longitude": "-118.46008000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128175,
                "name": "Ventura",
                "latitude": "34.27834000",
                "longitude": "-119.29317000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128176,
                "name": "Ventura County",
                "latitude": "34.35753000",
                "longitude": "-119.12603000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128224,
                "name": "Victorville",
                "latitude": "34.53611000",
                "longitude": "-117.29116000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128238,
                "name": "View Park-Windsor Hills",
                "latitude": "33.99551000",
                "longitude": "-118.34835000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128244,
                "name": "Villa Park",
                "latitude": "33.81446000",
                "longitude": "-117.81311000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128265,
                "name": "Vincent",
                "latitude": "34.50055000",
                "longitude": "-118.11646000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128269,
                "name": "Vine Hill",
                "latitude": "38.00853000",
                "longitude": "-122.09608000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128273,
                "name": "Vineyard",
                "latitude": "38.46449000",
                "longitude": "-121.34692000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128293,
                "name": "Visalia",
                "latitude": "36.33023000",
                "longitude": "-119.29206000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128294,
                "name": "Visitacion Valley",
                "latitude": "37.71715000",
                "longitude": "-122.40433000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128295,
                "name": "Vista",
                "latitude": "33.20004000",
                "longitude": "-117.24254000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128297,
                "name": "Vista Santa Rosa",
                "latitude": "33.62780000",
                "longitude": "-116.21806000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128374,
                "name": "Waldon",
                "latitude": "37.92631000",
                "longitude": "-122.05552000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128414,
                "name": "Walnut",
                "latitude": "34.02029000",
                "longitude": "-117.86534000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128416,
                "name": "Walnut Creek",
                "latitude": "37.90631000",
                "longitude": "-122.06496000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128419,
                "name": "Walnut Grove",
                "latitude": "38.24214000",
                "longitude": "-121.51162000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128422,
                "name": "Walnut Park",
                "latitude": "33.96807000",
                "longitude": "-118.22507000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128528,
                "name": "Wasco",
                "latitude": "35.59412000",
                "longitude": "-119.34095000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128609,
                "name": "Waterford",
                "latitude": "37.64132000",
                "longitude": "-120.76048000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128641,
                "name": "Watsonville",
                "latitude": "36.91023000",
                "longitude": "-121.75689000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128723,
                "name": "Weaverville",
                "latitude": "40.73098000",
                "longitude": "-122.94197000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128751,
                "name": "Weed",
                "latitude": "41.42265000",
                "longitude": "-122.38613000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128752,
                "name": "Weedpatch",
                "latitude": "35.23802000",
                "longitude": "-118.91510000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128770,
                "name": "Weldon",
                "latitude": "35.66579000",
                "longitude": "-118.29036000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128818,
                "name": "West Athens",
                "latitude": "33.92335000",
                "longitude": "-118.30341000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128826,
                "name": "West Bishop",
                "latitude": "37.36104000",
                "longitude": "-118.45511000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128842,
                "name": "West Carson",
                "latitude": "33.82168000",
                "longitude": "-118.29257000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128853,
                "name": "West Covina",
                "latitude": "34.06862000",
                "longitude": "-117.93895000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128897,
                "name": "West Hills",
                "latitude": "34.19731000",
                "longitude": "-118.64398000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128899,
                "name": "West Hollywood",
                "latitude": "34.09001000",
                "longitude": "-118.36174000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128929,
                "name": "West Menlo Park",
                "latitude": "37.43355000",
                "longitude": "-122.20302000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128934,
                "name": "West Modesto",
                "latitude": "37.61754000",
                "longitude": "-121.03914000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128950,
                "name": "West Park",
                "latitude": "36.71023000",
                "longitude": "-119.85126000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128964,
                "name": "West Puente Valley",
                "latitude": "34.05168000",
                "longitude": "-117.96840000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128966,
                "name": "West Rancho Dominguez",
                "latitude": "33.89390000",
                "longitude": "-118.27063000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 128971,
                "name": "West Sacramento",
                "latitude": "38.58046000",
                "longitude": "-121.53023000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129005,
                "name": "West Whittier-Los Nietos",
                "latitude": "33.97600000",
                "longitude": "-118.06909000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129037,
                "name": "Westhaven-Moonstone",
                "latitude": "41.04489000",
                "longitude": "-124.10239000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129040,
                "name": "Westlake Village",
                "latitude": "34.14584000",
                "longitude": "-118.80565000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129048,
                "name": "Westminster",
                "latitude": "33.75918000",
                "longitude": "-118.00673000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129051,
                "name": "Westmont",
                "latitude": "33.94140000",
                "longitude": "-118.30230000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129057,
                "name": "Westmorland",
                "latitude": "33.03727000",
                "longitude": "-115.62138000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129087,
                "name": "Westwood",
                "latitude": "34.05612000",
                "longitude": "-118.43063000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129108,
                "name": "Wheatland",
                "latitude": "39.00989000",
                "longitude": "-121.42301000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129210,
                "name": "Whittier",
                "latitude": "33.97918000",
                "longitude": "-118.03284000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129235,
                "name": "Wildomar",
                "latitude": "33.59891000",
                "longitude": "-117.28004000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129261,
                "name": "Williams",
                "latitude": "39.15461000",
                "longitude": "-122.14942000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129302,
                "name": "Willits",
                "latitude": "39.40961000",
                "longitude": "-123.35557000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129305,
                "name": "Willow Creek",
                "latitude": "40.93958000",
                "longitude": "-123.63144000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129315,
                "name": "Willowbrook",
                "latitude": "33.91696000",
                "longitude": "-118.25507000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129316,
                "name": "Willows",
                "latitude": "39.52433000",
                "longitude": "-122.19359000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 157017,
                "name": "Wilmington",
                "latitude": "33.78953550",
                "longitude": "-118.25909280",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129346,
                "name": "Wilton",
                "latitude": "38.41186000",
                "longitude": "-121.27217000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129360,
                "name": "Winchester",
                "latitude": "33.70697000",
                "longitude": "-117.08447000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129386,
                "name": "Windsor",
                "latitude": "38.54713000",
                "longitude": "-122.81638000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129439,
                "name": "Winter Gardens",
                "latitude": "32.83116000",
                "longitude": "-116.93336000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129445,
                "name": "Winters",
                "latitude": "38.52491000",
                "longitude": "-121.97080000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129454,
                "name": "Winton",
                "latitude": "37.38938000",
                "longitude": "-120.61325000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129467,
                "name": "Wofford Heights",
                "latitude": "35.70690000",
                "longitude": "-118.45620000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129493,
                "name": "Woodacre",
                "latitude": "38.01270000",
                "longitude": "-122.64526000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129502,
                "name": "Woodbridge",
                "latitude": "38.15408000",
                "longitude": "-121.30134000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129516,
                "name": "Woodcrest",
                "latitude": "33.88224000",
                "longitude": "-117.35727000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129524,
                "name": "Woodlake",
                "latitude": "36.41356000",
                "longitude": "-119.09872000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129526,
                "name": "Woodland",
                "latitude": "38.67852000",
                "longitude": "-121.77330000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129530,
                "name": "Woodland Hills",
                "latitude": "34.16834000",
                "longitude": "-118.60592000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129556,
                "name": "Woodside",
                "latitude": "37.42994000",
                "longitude": "-122.25386000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129574,
                "name": "Woodville",
                "latitude": "36.09356000",
                "longitude": "-119.19900000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129617,
                "name": "Wrightwood",
                "latitude": "34.36083000",
                "longitude": "-117.63339000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129686,
                "name": "Yolo County",
                "latitude": "38.68665000",
                "longitude": "-121.90162000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129689,
                "name": "Yorba Linda",
                "latitude": "33.88863000",
                "longitude": "-117.81311000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129711,
                "name": "Yosemite Lakes",
                "latitude": "37.19106000",
                "longitude": "-119.77265000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129712,
                "name": "Yosemite Valley",
                "latitude": "37.74075000",
                "longitude": "-119.57788000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129723,
                "name": "Yountville",
                "latitude": "38.40158000",
                "longitude": "-122.36081000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129725,
                "name": "Yreka",
                "latitude": "41.73542000",
                "longitude": "-122.63447000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129726,
                "name": "Yuba City",
                "latitude": "39.14045000",
                "longitude": "-121.61691000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129727,
                "name": "Yuba County",
                "latitude": "39.26902000",
                "longitude": "-121.35126000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129728,
                "name": "Yucaipa",
                "latitude": "34.03363000",
                "longitude": "-117.04309000",
                "timezone": "America\/Los_Angeles"
            },
            {
                "id": 129729,
                "name": "Yucca Valley",
                "latitude": "34.11417000",
                "longitude": "-116.43224000",
                "timezone": "America\/Los_Angeles"
            }
        ],
    },
    {
        "id": 1417,
        "name": "New Jersey",
        "stateCode": "NJ",
        "iso3166_2": "US-NJ",
        "native": "New Jersey",
        "latitude": "40.07573840",
        "longitude": "-74.40416220",
        "type": "state",
        "timezone": "America\/New_York",
        "cities": [
            {
                "id": 110990,
                "name": "Absecon",
                "latitude": "39.42845000",
                "longitude": "-74.49571000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111195,
                "name": "Allendale",
                "latitude": "41.04149000",
                "longitude": "-74.12903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111198,
                "name": "Allentown",
                "latitude": "40.17789000",
                "longitude": "-74.58349000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111204,
                "name": "Alloway",
                "latitude": "39.56095000",
                "longitude": "-75.36242000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111220,
                "name": "Alpha",
                "latitude": "40.66704000",
                "longitude": "-75.15740000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111222,
                "name": "Alpine",
                "latitude": "40.95593000",
                "longitude": "-73.93125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111351,
                "name": "Annandale",
                "latitude": "40.64093000",
                "longitude": "-74.88128000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111508,
                "name": "Asbury Park",
                "latitude": "40.22039000",
                "longitude": "-74.01208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111531,
                "name": "Ashland",
                "latitude": "39.86317000",
                "longitude": "-75.00600000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111570,
                "name": "Atco",
                "latitude": "39.76984000",
                "longitude": "-74.88739000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111598,
                "name": "Atlantic City",
                "latitude": "39.36415000",
                "longitude": "-74.42306000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111599,
                "name": "Atlantic County",
                "latitude": "39.46883000",
                "longitude": "-74.63373000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111600,
                "name": "Atlantic Highlands",
                "latitude": "40.40789000",
                "longitude": "-74.03431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111638,
                "name": "Audubon",
                "latitude": "39.89095000",
                "longitude": "-75.07295000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111643,
                "name": "Audubon Park",
                "latitude": "39.89650000",
                "longitude": "-75.08767000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111673,
                "name": "Avalon",
                "latitude": "39.10122000",
                "longitude": "-74.71766000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111677,
                "name": "Avenel",
                "latitude": "40.58038000",
                "longitude": "-74.28515000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111697,
                "name": "Avon-by-the-Sea",
                "latitude": "40.19234000",
                "longitude": "-74.01597000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111825,
                "name": "Barnegat",
                "latitude": "39.75318000",
                "longitude": "-74.22292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111845,
                "name": "Barrington",
                "latitude": "39.86484000",
                "longitude": "-75.05517000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111945,
                "name": "Bayonne",
                "latitude": "40.66871000",
                "longitude": "-74.11431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111960,
                "name": "Bayville",
                "latitude": "39.90929000",
                "longitude": "-74.15486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111964,
                "name": "Beach Haven",
                "latitude": "39.55928000",
                "longitude": "-74.24320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111965,
                "name": "Beach Haven West",
                "latitude": "39.66984000",
                "longitude": "-74.23181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111967,
                "name": "Beachwood",
                "latitude": "39.93901000",
                "longitude": "-74.19292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 111983,
                "name": "Beattystown",
                "latitude": "40.81315000",
                "longitude": "-74.84294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112015,
                "name": "Beckett",
                "latitude": "39.75400000",
                "longitude": "-75.35741000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112031,
                "name": "Bedminster",
                "latitude": "40.68066000",
                "longitude": "-74.64544000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112059,
                "name": "Belford",
                "latitude": "40.42594000",
                "longitude": "-74.08681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112106,
                "name": "Belleville",
                "latitude": "40.79371000",
                "longitude": "-74.15014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112121,
                "name": "Bellmawr",
                "latitude": "39.86761000",
                "longitude": "-75.09462000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112133,
                "name": "Belmar",
                "latitude": "40.17845000",
                "longitude": "-74.02180000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112156,
                "name": "Belvidere",
                "latitude": "40.82982000",
                "longitude": "-75.07767000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112218,
                "name": "Bergen County",
                "latitude": "40.95977000",
                "longitude": "-74.07441000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112219,
                "name": "Bergenfield",
                "latitude": "40.92760000",
                "longitude": "-73.99736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112226,
                "name": "Berkeley Heights",
                "latitude": "40.68343000",
                "longitude": "-74.44265000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112235,
                "name": "Berlin",
                "latitude": "39.79123000",
                "longitude": "-74.92905000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112245,
                "name": "Bernardsville",
                "latitude": "40.71871000",
                "longitude": "-74.56932000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112301,
                "name": "Beverly",
                "latitude": "40.06539000",
                "longitude": "-74.91906000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112397,
                "name": "Blackwood",
                "latitude": "39.80234000",
                "longitude": "-75.06406000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112437,
                "name": "Bloomfield",
                "latitude": "40.80677000",
                "longitude": "-74.18542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112448,
                "name": "Bloomingdale",
                "latitude": "41.00204000",
                "longitude": "-74.32654000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112501,
                "name": "Bogota",
                "latitude": "40.87621000",
                "longitude": "-74.02986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112566,
                "name": "Boonton",
                "latitude": "40.90260000",
                "longitude": "-74.40710000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112576,
                "name": "Bordentown",
                "latitude": "40.14622000",
                "longitude": "-74.71183000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112608,
                "name": "Bound Brook",
                "latitude": "40.56844000",
                "longitude": "-74.53849000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112674,
                "name": "Bradley Beach",
                "latitude": "40.20234000",
                "longitude": "-74.01208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112677,
                "name": "Bradley Gardens",
                "latitude": "40.56288000",
                "longitude": "-74.65460000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112698,
                "name": "Brass Castle",
                "latitude": "40.76482000",
                "longitude": "-75.01101000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112770,
                "name": "Bridgeton",
                "latitude": "39.42734000",
                "longitude": "-75.23408000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112777,
                "name": "Bridgewater",
                "latitude": "40.60079000",
                "longitude": "-74.64815000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112781,
                "name": "Brielle",
                "latitude": "40.10789000",
                "longitude": "-74.05653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112783,
                "name": "Brigantine",
                "latitude": "39.41012000",
                "longitude": "-74.36459000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112850,
                "name": "Brookdale",
                "latitude": "40.83371000",
                "longitude": "-74.18292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112865,
                "name": "Brooklawn",
                "latitude": "39.87817000",
                "longitude": "-75.12073000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112921,
                "name": "Browns Mills",
                "latitude": "39.97261000",
                "longitude": "-74.58293000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112939,
                "name": "Brownville",
                "latitude": "40.40066000",
                "longitude": "-74.29515000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112994,
                "name": "Budd Lake",
                "latitude": "40.87121000",
                "longitude": "-74.73405000",
                "timezone": "America\/New_York"
            },
            {
                "id": 112998,
                "name": "Buena",
                "latitude": "39.51373000",
                "longitude": "-74.92462000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113071,
                "name": "Burlington",
                "latitude": "40.07122000",
                "longitude": "-74.86489000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113077,
                "name": "Burlington County",
                "latitude": "39.87769000",
                "longitude": "-74.66820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113110,
                "name": "Butler",
                "latitude": "41.00371000",
                "longitude": "-74.34154000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113181,
                "name": "Caldwell",
                "latitude": "40.83982000",
                "longitude": "-74.27654000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113214,
                "name": "Califon",
                "latitude": "40.71954000",
                "longitude": "-74.83572000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113263,
                "name": "Camden",
                "latitude": "39.92595000",
                "longitude": "-75.11962000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113271,
                "name": "Camden County",
                "latitude": "39.80353000",
                "longitude": "-74.95976000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113369,
                "name": "Cape May",
                "latitude": "38.93511000",
                "longitude": "-74.90601000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113370,
                "name": "Cape May County",
                "latitude": "39.08513000",
                "longitude": "-74.84998000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113371,
                "name": "Cape May Court House",
                "latitude": "39.08261000",
                "longitude": "-74.82378000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113410,
                "name": "Carlstadt",
                "latitude": "40.84038000",
                "longitude": "-74.09070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113429,
                "name": "Carneys Point",
                "latitude": "39.71122000",
                "longitude": "-75.47020000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113486,
                "name": "Carteret",
                "latitude": "40.57733000",
                "longitude": "-74.22820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113608,
                "name": "Cedar Glen Lakes",
                "latitude": "39.95234000",
                "longitude": "-74.39987000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113609,
                "name": "Cedar Glen West",
                "latitude": "40.04206000",
                "longitude": "-74.29265000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113611,
                "name": "Cedar Grove",
                "latitude": "40.85177000",
                "longitude": "-74.22903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113800,
                "name": "Chatham",
                "latitude": "40.74093000",
                "longitude": "-74.38376000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113860,
                "name": "Cherry Hill",
                "latitude": "39.93484000",
                "longitude": "-75.03073000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113862,
                "name": "Cherry Hill Mall",
                "latitude": "39.93595000",
                "longitude": "-75.00906000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113880,
                "name": "Chesilhurst",
                "latitude": "39.73234000",
                "longitude": "-74.88100000",
                "timezone": "America\/New_York"
            },
            {
                "id": 113889,
                "name": "Chester",
                "latitude": "40.78427000",
                "longitude": "-74.69683000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114027,
                "name": "Cinnaminson",
                "latitude": "39.99678000",
                "longitude": "-74.99267000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114119,
                "name": "Clark",
                "latitude": "40.64094000",
                "longitude": "-74.31070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114201,
                "name": "Clayton",
                "latitude": "39.66011000",
                "longitude": "-75.09212000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114215,
                "name": "Clearbrook Park",
                "latitude": "40.30983000",
                "longitude": "-74.46460000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114232,
                "name": "Clementon",
                "latitude": "39.81150000",
                "longitude": "-74.98294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114253,
                "name": "Cliffside Park",
                "latitude": "40.82149000",
                "longitude": "-73.98764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114254,
                "name": "Cliffwood Beach",
                "latitude": "40.44205000",
                "longitude": "-74.21681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114259,
                "name": "Clifton",
                "latitude": "40.85843000",
                "longitude": "-74.16376000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114284,
                "name": "Clinton",
                "latitude": "40.63677000",
                "longitude": "-74.90989000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114305,
                "name": "Closter",
                "latitude": "40.97315000",
                "longitude": "-73.96153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114428,
                "name": "Collings Lakes",
                "latitude": "39.59567000",
                "longitude": "-74.88156000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114429,
                "name": "Collingswood",
                "latitude": "39.91817000",
                "longitude": "-75.07128000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114446,
                "name": "Colonia",
                "latitude": "40.57455000",
                "longitude": "-74.30209000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114546,
                "name": "Concordia",
                "latitude": "40.31094000",
                "longitude": "-74.44821000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114722,
                "name": "Country Lake Estates",
                "latitude": "39.94262000",
                "longitude": "-74.54404000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114764,
                "name": "Cranbury",
                "latitude": "40.31622000",
                "longitude": "-74.51376000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114767,
                "name": "Crandon Lakes",
                "latitude": "41.12426000",
                "longitude": "-74.83989000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114771,
                "name": "Cranford",
                "latitude": "40.65844000",
                "longitude": "-74.29959000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114799,
                "name": "Cresskill",
                "latitude": "40.94149000",
                "longitude": "-73.95930000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114812,
                "name": "Crestwood Village",
                "latitude": "39.94817000",
                "longitude": "-74.36070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 114915,
                "name": "Cumberland County",
                "latitude": "39.32807000",
                "longitude": "-75.12934000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115097,
                "name": "Dayton",
                "latitude": "40.37261000",
                "longitude": "-74.51015000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115197,
                "name": "Delanco",
                "latitude": "40.05067000",
                "longitude": "-74.95350000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115230,
                "name": "Demarest",
                "latitude": "40.95732000",
                "longitude": "-73.96347000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115449,
                "name": "Dover",
                "latitude": "40.88399000",
                "longitude": "-74.56210000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115454,
                "name": "Dover Beaches North",
                "latitude": "39.99123000",
                "longitude": "-74.06375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115455,
                "name": "Dover Beaches South",
                "latitude": "39.95567000",
                "longitude": "-74.07430000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115518,
                "name": "Dumont",
                "latitude": "40.94065000",
                "longitude": "-73.99681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115535,
                "name": "Dunellen",
                "latitude": "40.58927000",
                "longitude": "-74.47182000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115641,
                "name": "East Brunswick",
                "latitude": "40.42788000",
                "longitude": "-74.41598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115664,
                "name": "East Franklin",
                "latitude": "40.49330000",
                "longitude": "-74.47110000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115665,
                "name": "East Freehold",
                "latitude": "40.28094000",
                "longitude": "-74.25126000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115682,
                "name": "East Hanover",
                "latitude": "40.82010000",
                "longitude": "-74.36487000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115720,
                "name": "East Newark",
                "latitude": "40.74843000",
                "longitude": "-74.16181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115726,
                "name": "East Orange",
                "latitude": "40.76732000",
                "longitude": "-74.20487000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115752,
                "name": "East Rutherford",
                "latitude": "40.83399000",
                "longitude": "-74.09709000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115807,
                "name": "Eatontown",
                "latitude": "40.29622000",
                "longitude": "-74.05097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115813,
                "name": "Echelon",
                "latitude": "39.84845000",
                "longitude": "-74.99572000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115854,
                "name": "Edgewater",
                "latitude": "40.82704000",
                "longitude": "-73.97569000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115856,
                "name": "Edgewater Park",
                "latitude": "40.06817000",
                "longitude": "-74.90072000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115875,
                "name": "Edison",
                "latitude": "40.51872000",
                "longitude": "-74.41210000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115901,
                "name": "Egg Harbor City",
                "latitude": "39.52873000",
                "longitude": "-74.64794000",
                "timezone": "America\/New_York"
            },
            {
                "id": 115972,
                "name": "Elizabeth",
                "latitude": "40.66399000",
                "longitude": "-74.21070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116033,
                "name": "Ellisburg",
                "latitude": "39.91372000",
                "longitude": "-75.01045000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116050,
                "name": "Elmer",
                "latitude": "39.59511000",
                "longitude": "-75.17018000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116063,
                "name": "Elmwood Park",
                "latitude": "40.90399000",
                "longitude": "-74.11848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116078,
                "name": "Elwood",
                "latitude": "39.57651000",
                "longitude": "-74.71683000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116094,
                "name": "Emerson",
                "latitude": "40.97621000",
                "longitude": "-74.02625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116132,
                "name": "Englewood",
                "latitude": "40.89288000",
                "longitude": "-73.97264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116134,
                "name": "Englewood Cliffs",
                "latitude": "40.88538000",
                "longitude": "-73.95236000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116136,
                "name": "Englishtown",
                "latitude": "40.29733000",
                "longitude": "-74.35820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116173,
                "name": "Erma",
                "latitude": "38.98776000",
                "longitude": "-74.90170000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116195,
                "name": "Essex County",
                "latitude": "40.78707000",
                "longitude": "-74.24687000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116198,
                "name": "Essex Fells",
                "latitude": "40.82454000",
                "longitude": "-74.28459000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116204,
                "name": "Estell Manor",
                "latitude": "39.41206000",
                "longitude": "-74.74239000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116268,
                "name": "Ewing",
                "latitude": "40.26983000",
                "longitude": "-74.79988000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116282,
                "name": "Fair Haven",
                "latitude": "40.36067000",
                "longitude": "-74.03819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116284,
                "name": "Fair Lawn",
                "latitude": "40.94038000",
                "longitude": "-74.13181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116315,
                "name": "Fairfield",
                "latitude": "40.88371000",
                "longitude": "-74.30598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116346,
                "name": "Fairton",
                "latitude": "39.38178000",
                "longitude": "-75.21991000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116352,
                "name": "Fairview",
                "latitude": "40.81260000",
                "longitude": "-73.99903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116394,
                "name": "Fanwood",
                "latitude": "40.64094000",
                "longitude": "-74.38348000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116410,
                "name": "Farmingdale",
                "latitude": "40.19650000",
                "longitude": "-74.16848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116515,
                "name": "Finderne",
                "latitude": "40.56316000",
                "longitude": "-74.57766000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116562,
                "name": "Flemington",
                "latitude": "40.51233000",
                "longitude": "-74.85933000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116582,
                "name": "Florence",
                "latitude": "39.73428000",
                "longitude": "-74.91822000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116591,
                "name": "Florham Park",
                "latitude": "40.78788000",
                "longitude": "-74.38821000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116624,
                "name": "Folsom",
                "latitude": "39.60206000",
                "longitude": "-74.84267000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116640,
                "name": "Fords",
                "latitude": "40.52927000",
                "longitude": "-74.31598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116674,
                "name": "Forked River",
                "latitude": "39.83984000",
                "longitude": "-74.19014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116706,
                "name": "Fort Dix",
                "latitude": "40.02984000",
                "longitude": "-74.61849000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116723,
                "name": "Fort Lee",
                "latitude": "40.85093000",
                "longitude": "-73.97014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116838,
                "name": "Franklin",
                "latitude": "41.12204000",
                "longitude": "-74.58044000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116842,
                "name": "Franklin Center",
                "latitude": "40.53153000",
                "longitude": "-74.54141000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116866,
                "name": "Franklin Lakes",
                "latitude": "41.01676000",
                "longitude": "-74.20570000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116869,
                "name": "Franklin Park",
                "latitude": "40.43899000",
                "longitude": "-74.53515000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116904,
                "name": "Freehold",
                "latitude": "40.26011000",
                "longitude": "-74.27376000",
                "timezone": "America\/New_York"
            },
            {
                "id": 116934,
                "name": "Frenchtown",
                "latitude": "40.52621000",
                "longitude": "-75.06156000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117081,
                "name": "Garfield",
                "latitude": "40.88149000",
                "longitude": "-74.11320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117105,
                "name": "Garwood",
                "latitude": "40.65177000",
                "longitude": "-74.32293000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117183,
                "name": "Gibbsboro",
                "latitude": "39.83817000",
                "longitude": "-74.96489000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117184,
                "name": "Gibbstown",
                "latitude": "39.82511000",
                "longitude": "-75.28352000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117238,
                "name": "Gladstone",
                "latitude": "40.72260000",
                "longitude": "-74.66544000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117251,
                "name": "Glassboro",
                "latitude": "39.70289000",
                "longitude": "-75.11184000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117266,
                "name": "Glen Gardner",
                "latitude": "40.69677000",
                "longitude": "-74.94072000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117271,
                "name": "Glen Ridge",
                "latitude": "40.80538000",
                "longitude": "-74.20376000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117273,
                "name": "Glen Rock",
                "latitude": "40.96288000",
                "longitude": "-74.13292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117290,
                "name": "Glendora",
                "latitude": "39.83956000",
                "longitude": "-75.07351000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117323,
                "name": "Gloucester City",
                "latitude": "39.89178000",
                "longitude": "-75.11629000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117324,
                "name": "Gloucester County",
                "latitude": "39.71731000",
                "longitude": "-75.14167000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117354,
                "name": "Golden Triangle",
                "latitude": "39.92789000",
                "longitude": "-75.03878000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117600,
                "name": "Green Knoll",
                "latitude": "40.60010000",
                "longitude": "-74.61210000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117675,
                "name": "Greentree",
                "latitude": "39.89706000",
                "longitude": "-74.95572000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117766,
                "name": "Groveville",
                "latitude": "40.16983000",
                "longitude": "-74.67155000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117817,
                "name": "Guttenberg",
                "latitude": "40.79205000",
                "longitude": "-74.00375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117828,
                "name": "Hackensack",
                "latitude": "40.88593000",
                "longitude": "-74.04347000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117829,
                "name": "Hackettstown",
                "latitude": "40.85399000",
                "longitude": "-74.82906000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117831,
                "name": "Haddon Heights",
                "latitude": "39.87734000",
                "longitude": "-75.06462000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117832,
                "name": "Haddonfield",
                "latitude": "39.89150000",
                "longitude": "-75.03767000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117850,
                "name": "Haledon",
                "latitude": "40.93565000",
                "longitude": "-74.18626000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117883,
                "name": "Hamburg",
                "latitude": "41.15343000",
                "longitude": "-74.57627000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117905,
                "name": "Hamilton Square",
                "latitude": "40.22733000",
                "longitude": "-74.65321000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117915,
                "name": "Hammonton",
                "latitude": "39.63651000",
                "longitude": "-74.80239000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117933,
                "name": "Hampton",
                "latitude": "40.70704000",
                "longitude": "-74.95600000",
                "timezone": "America\/New_York"
            },
            {
                "id": 117973,
                "name": "Hanover",
                "latitude": "40.80454000",
                "longitude": "-74.36682000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118009,
                "name": "Hardwick",
                "latitude": "41.05454000",
                "longitude": "-74.93212000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118042,
                "name": "Harrington Park",
                "latitude": "40.98371000",
                "longitude": "-73.97986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118058,
                "name": "Harrison",
                "latitude": "40.74649000",
                "longitude": "-74.15626000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118121,
                "name": "Hasbrouck Heights",
                "latitude": "40.85816000",
                "longitude": "-74.08070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118170,
                "name": "Haworth",
                "latitude": "40.96093000",
                "longitude": "-73.99014000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118173,
                "name": "Hawthorne",
                "latitude": "40.94926000",
                "longitude": "-74.15375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 149546,
                "name": "Hazlet Township",
                "latitude": "40.42685010",
                "longitude": "-74.20682440",
                "timezone": "America\/New_York"
            },
            {
                "id": 118223,
                "name": "Heathcote",
                "latitude": "40.38872000",
                "longitude": "-74.57571000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118260,
                "name": "Helmetta",
                "latitude": "40.37677000",
                "longitude": "-74.42460000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118385,
                "name": "High Bridge",
                "latitude": "40.66705000",
                "longitude": "-74.89572000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118407,
                "name": "Highland Lake",
                "latitude": "41.17676000",
                "longitude": "-74.45655000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118413,
                "name": "Highland Park",
                "latitude": "40.49594000",
                "longitude": "-74.42432000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118418,
                "name": "Highlands",
                "latitude": "40.40372000",
                "longitude": "-73.99153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118424,
                "name": "Hightstown",
                "latitude": "40.26955000",
                "longitude": "-74.52321000",
                "timezone": "America\/New_York"
            },
            {
                "id": 153288,
                "name": "Hillsborough",
                "latitude": "40.49807090",
                "longitude": "-74.68498850",
                "timezone": "America\/New_York"
            },
            {
                "id": 118461,
                "name": "Hillsdale",
                "latitude": "41.00260000",
                "longitude": "-74.04042000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118464,
                "name": "Hillside",
                "latitude": "40.70121000",
                "longitude": "-74.23015000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118494,
                "name": "Ho-Ho-Kus",
                "latitude": "40.99649000",
                "longitude": "-74.10125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118502,
                "name": "Hoboken",
                "latitude": "40.74399000",
                "longitude": "-74.03236000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118530,
                "name": "Holiday City South",
                "latitude": "39.95324000",
                "longitude": "-74.23778000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118531,
                "name": "Holiday City-Berkeley",
                "latitude": "39.96380000",
                "longitude": "-74.27803000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118532,
                "name": "Holiday Heights",
                "latitude": "39.94595000",
                "longitude": "-74.25403000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118640,
                "name": "Hopatcong",
                "latitude": "40.93288000",
                "longitude": "-74.65933000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118641,
                "name": "Hopatcong Hills",
                "latitude": "40.94399000",
                "longitude": "-74.67072000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118650,
                "name": "Hopewell",
                "latitude": "40.38927000",
                "longitude": "-74.76183000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118749,
                "name": "Hudson County",
                "latitude": "40.73094000",
                "longitude": "-74.07594000",
                "timezone": "America\/New_York"
            },
            {
                "id": 118789,
                "name": "Hunterdon County",
                "latitude": "40.56729000",
                "longitude": "-74.91222000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119009,
                "name": "Irvington",
                "latitude": "40.73232000",
                "longitude": "-74.23487000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119019,
                "name": "Iselin",
                "latitude": "40.57538000",
                "longitude": "-74.32237000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119025,
                "name": "Island Heights",
                "latitude": "39.94206000",
                "longitude": "-74.14986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119066,
                "name": "Jackson",
                "latitude": "39.77650000",
                "longitude": "-74.86238000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119118,
                "name": "Jamesburg",
                "latitude": "40.35261000",
                "longitude": "-74.44015000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119231,
                "name": "Jersey City",
                "latitude": "40.72816000",
                "longitude": "-74.07764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119406,
                "name": "Keansburg",
                "latitude": "40.44177000",
                "longitude": "-74.12986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119412,
                "name": "Kearny",
                "latitude": "40.76843000",
                "longitude": "-74.14542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119449,
                "name": "Kendall Park",
                "latitude": "40.42094000",
                "longitude": "-74.56071000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119457,
                "name": "Kenilworth",
                "latitude": "40.67649000",
                "longitude": "-74.29070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119502,
                "name": "Kenvil",
                "latitude": "40.87982000",
                "longitude": "-74.61849000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119544,
                "name": "Keyport",
                "latitude": "40.43316000",
                "longitude": "-74.19959000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119626,
                "name": "Kingston",
                "latitude": "40.37538000",
                "longitude": "-74.61349000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119631,
                "name": "Kingston Estates",
                "latitude": "39.92372000",
                "longitude": "-74.98795000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119639,
                "name": "Kinnelon",
                "latitude": "41.00176000",
                "longitude": "-74.36710000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119888,
                "name": "Lake Como",
                "latitude": "40.15984000",
                "longitude": "-74.02819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119944,
                "name": "Lake Mohawk",
                "latitude": "41.01843000",
                "longitude": "-74.66016000",
                "timezone": "America\/New_York"
            },
            {
                "id": 119985,
                "name": "Lake Telemark",
                "latitude": "40.95677000",
                "longitude": "-74.49793000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120011,
                "name": "Lakehurst",
                "latitude": "40.01456000",
                "longitude": "-74.31126000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120048,
                "name": "Lakewood",
                "latitude": "40.09789000",
                "longitude": "-74.21764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120069,
                "name": "Lambertville",
                "latitude": "40.36594000",
                "longitude": "-74.94294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120098,
                "name": "Landing",
                "latitude": "40.90510000",
                "longitude": "-74.66516000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120199,
                "name": "Laurel Lake",
                "latitude": "39.33956000",
                "longitude": "-75.02990000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120201,
                "name": "Laurel Springs",
                "latitude": "39.82011000",
                "longitude": "-75.00628000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120205,
                "name": "Laurence Harbor",
                "latitude": "40.45677000",
                "longitude": "-74.24653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120216,
                "name": "Lavallette",
                "latitude": "39.97040000",
                "longitude": "-74.06875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120223,
                "name": "Lawnside",
                "latitude": "39.86650000",
                "longitude": "-75.02823000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120246,
                "name": "Lawrenceville",
                "latitude": "40.29733000",
                "longitude": "-74.72960000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120292,
                "name": "Lebanon",
                "latitude": "40.64177000",
                "longitude": "-74.83600000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120341,
                "name": "Leisure Knoll",
                "latitude": "40.01901000",
                "longitude": "-74.29209000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120342,
                "name": "Leisure Village",
                "latitude": "40.04262000",
                "longitude": "-74.18486000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120343,
                "name": "Leisure Village East",
                "latitude": "40.03012000",
                "longitude": "-74.16431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120344,
                "name": "Leisure Village West-Pine Lake Park",
                "latitude": "40.00416000",
                "longitude": "-74.26629000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120346,
                "name": "Leisuretowne",
                "latitude": "39.89234000",
                "longitude": "-74.70210000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120389,
                "name": "Leonardo",
                "latitude": "40.41733000",
                "longitude": "-74.06208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120391,
                "name": "Leonia",
                "latitude": "40.86149000",
                "longitude": "-73.98819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120542,
                "name": "Lincoln Park",
                "latitude": "40.92427000",
                "longitude": "-74.30209000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120556,
                "name": "Lincroft",
                "latitude": "40.33067000",
                "longitude": "-74.12097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120564,
                "name": "Linden",
                "latitude": "40.62205000",
                "longitude": "-74.24459000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120569,
                "name": "Lindenwold",
                "latitude": "39.82428000",
                "longitude": "-74.99767000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120592,
                "name": "Linwood",
                "latitude": "39.33984000",
                "longitude": "-74.57516000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120618,
                "name": "Little Falls",
                "latitude": "40.86899000",
                "longitude": "-74.20820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120620,
                "name": "Little Ferry",
                "latitude": "40.85288000",
                "longitude": "-74.04208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120630,
                "name": "Little Silver",
                "latitude": "40.33678000",
                "longitude": "-74.04708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120651,
                "name": "Livingston",
                "latitude": "40.79593000",
                "longitude": "-74.31487000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120689,
                "name": "Lodi",
                "latitude": "40.88232000",
                "longitude": "-74.08320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120740,
                "name": "Long Branch",
                "latitude": "40.30428000",
                "longitude": "-73.99236000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120750,
                "name": "Long Valley",
                "latitude": "40.78593000",
                "longitude": "-74.78016000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120921,
                "name": "Lyndhurst",
                "latitude": "40.81204000",
                "longitude": "-74.12431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 120998,
                "name": "Madison",
                "latitude": "40.75982000",
                "longitude": "-74.41710000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121024,
                "name": "Madison Park",
                "latitude": "40.45150000",
                "longitude": "-74.30792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121037,
                "name": "Magnolia",
                "latitude": "39.85456000",
                "longitude": "-75.03906000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121048,
                "name": "Mahwah",
                "latitude": "41.08871000",
                "longitude": "-74.14376000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121079,
                "name": "Manahawkin",
                "latitude": "39.69540000",
                "longitude": "-74.25875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121081,
                "name": "Manasquan",
                "latitude": "40.12623000",
                "longitude": "-74.04930000",
                "timezone": "America\/New_York"
            },
            {
                "id": 149067,
                "name": "Mantua Township",
                "latitude": "39.75687570",
                "longitude": "-75.20697550",
                "timezone": "America\/New_York"
            },
            {
                "id": 121162,
                "name": "Manville",
                "latitude": "40.54094000",
                "longitude": "-74.58766000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121172,
                "name": "Maple Shade",
                "latitude": "39.95261000",
                "longitude": "-74.99239000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121179,
                "name": "Maplewood",
                "latitude": "40.73121000",
                "longitude": "-74.27348000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121207,
                "name": "Margate City",
                "latitude": "39.32789000",
                "longitude": "-74.50349000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121274,
                "name": "Marlboro",
                "latitude": "40.31539000",
                "longitude": "-74.24626000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121288,
                "name": "Marlton",
                "latitude": "39.89122000",
                "longitude": "-74.92183000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121351,
                "name": "Martinsville",
                "latitude": "40.60121000",
                "longitude": "-74.55905000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121400,
                "name": "Matawan",
                "latitude": "40.41483000",
                "longitude": "-74.22959000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121447,
                "name": "Mays Landing",
                "latitude": "39.45234000",
                "longitude": "-74.72766000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121458,
                "name": "Maywood",
                "latitude": "40.90260000",
                "longitude": "-74.06181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121507,
                "name": "McGuire AFB",
                "latitude": "40.03977000",
                "longitude": "-74.58174000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121597,
                "name": "Medford Lakes",
                "latitude": "39.85845000",
                "longitude": "-74.80294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121651,
                "name": "Mendham",
                "latitude": "40.77593000",
                "longitude": "-74.60071000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121679,
                "name": "Mercer County",
                "latitude": "40.28340000",
                "longitude": "-74.70169000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121684,
                "name": "Mercerville",
                "latitude": "40.23705000",
                "longitude": "-74.68655000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121685,
                "name": "Mercerville-Hamilton Square",
                "latitude": "40.23126000",
                "longitude": "-74.67223000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121686,
                "name": "Merchantville",
                "latitude": "39.94734000",
                "longitude": "-75.06656000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121738,
                "name": "Metuchen",
                "latitude": "40.54316000",
                "longitude": "-74.36320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121774,
                "name": "Middlebush",
                "latitude": "40.49760000",
                "longitude": "-74.52932000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121777,
                "name": "Middlesex",
                "latitude": "40.57260000",
                "longitude": "-74.49265000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121781,
                "name": "Middlesex County",
                "latitude": "40.44004000",
                "longitude": "-74.40889000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121806,
                "name": "Midland Park",
                "latitude": "40.98926000",
                "longitude": "-74.14070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121854,
                "name": "Milford",
                "latitude": "40.56871000",
                "longitude": "-75.09462000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121902,
                "name": "Milltown",
                "latitude": "40.45622000",
                "longitude": "-74.44321000",
                "timezone": "America\/New_York"
            },
            {
                "id": 121904,
                "name": "Millville",
                "latitude": "39.40206000",
                "longitude": "-75.03934000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122045,
                "name": "Monmouth Beach",
                "latitude": "40.33039000",
                "longitude": "-73.98153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122046,
                "name": "Monmouth County",
                "latitude": "40.28755000",
                "longitude": "-74.15815000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122047,
                "name": "Monmouth Junction",
                "latitude": "40.37900000",
                "longitude": "-74.54654000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122106,
                "name": "Montclair",
                "latitude": "40.82593000",
                "longitude": "-74.20903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 153289,
                "name": "Montgomery",
                "latitude": "40.42350110",
                "longitude": "-74.74351950",
                "timezone": "America\/New_York"
            },
            {
                "id": 122187,
                "name": "Montvale",
                "latitude": "41.04676000",
                "longitude": "-74.02292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122198,
                "name": "Moonachie",
                "latitude": "40.84121000",
                "longitude": "-74.04514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122208,
                "name": "Moorestown-Lenola",
                "latitude": "39.96591000",
                "longitude": "-74.96441000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122254,
                "name": "Morganville",
                "latitude": "40.37650000",
                "longitude": "-74.24431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122271,
                "name": "Morris County",
                "latitude": "40.86203000",
                "longitude": "-74.54444000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122274,
                "name": "Morris Plains",
                "latitude": "40.82177000",
                "longitude": "-74.48099000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122282,
                "name": "Morristown",
                "latitude": "40.79677000",
                "longitude": "-74.48154000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122333,
                "name": "Mount Arlington",
                "latitude": "40.92593000",
                "longitude": "-74.63488000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122342,
                "name": "Mount Ephraim",
                "latitude": "39.87845000",
                "longitude": "-75.09267000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122348,
                "name": "Mount Holly",
                "latitude": "39.99289000",
                "longitude": "-74.78766000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122361,
                "name": "Mount Laurel",
                "latitude": "39.93400000",
                "longitude": "-74.89100000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122422,
                "name": "Mountain Lakes",
                "latitude": "40.89482000",
                "longitude": "-74.43293000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122438,
                "name": "Mountainside",
                "latitude": "40.67232000",
                "longitude": "-74.35737000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122461,
                "name": "Mullica Hill",
                "latitude": "39.73928000",
                "longitude": "-75.22407000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122527,
                "name": "Mystic Island",
                "latitude": "39.54428000",
                "longitude": "-74.38237000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122593,
                "name": "National Park",
                "latitude": "39.86595000",
                "longitude": "-75.17879000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122604,
                "name": "Navesink",
                "latitude": "40.39955000",
                "longitude": "-74.03542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122638,
                "name": "Neptune City",
                "latitude": "40.20011000",
                "longitude": "-74.02792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122645,
                "name": "Netcong",
                "latitude": "40.89899000",
                "longitude": "-74.70655000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122677,
                "name": "New Brunswick",
                "latitude": "40.48622000",
                "longitude": "-74.45182000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122703,
                "name": "New Egypt",
                "latitude": "40.06761000",
                "longitude": "-74.53071000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122755,
                "name": "New Milford",
                "latitude": "40.93510000",
                "longitude": "-74.01903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122768,
                "name": "New Providence",
                "latitude": "40.69843000",
                "longitude": "-74.40154000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122803,
                "name": "Newark",
                "latitude": "40.73566000",
                "longitude": "-74.17237000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122828,
                "name": "Newfield",
                "latitude": "39.54688000",
                "longitude": "-75.02636000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122867,
                "name": "Newton",
                "latitude": "41.05815000",
                "longitude": "-74.75267000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122965,
                "name": "North Arlington",
                "latitude": "40.78843000",
                "longitude": "-74.13320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122978,
                "name": "North Beach Haven",
                "latitude": "39.57317000",
                "longitude": "-74.23153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122987,
                "name": "North Bergen",
                "latitude": "40.80427000",
                "longitude": "-74.01208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 122999,
                "name": "North Caldwell",
                "latitude": "40.86482000",
                "longitude": "-74.25820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123000,
                "name": "North Cape May",
                "latitude": "38.98206000",
                "longitude": "-74.95795000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123034,
                "name": "North Haledon",
                "latitude": "40.95510000",
                "longitude": "-74.18598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123068,
                "name": "North Middletown",
                "latitude": "40.43955000",
                "longitude": "-74.11903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123080,
                "name": "North Plainfield",
                "latitude": "40.63010000",
                "longitude": "-74.42737000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123129,
                "name": "North Wildwood",
                "latitude": "39.00067000",
                "longitude": "-74.79933000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123149,
                "name": "Northfield",
                "latitude": "39.37039000",
                "longitude": "-74.55015000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123169,
                "name": "Northvale",
                "latitude": "41.00649000",
                "longitude": "-73.94903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123200,
                "name": "Norwood",
                "latitude": "40.99815000",
                "longitude": "-73.96180000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123219,
                "name": "Nutley",
                "latitude": "40.82232000",
                "longitude": "-74.15987000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123265,
                "name": "Oak Valley",
                "latitude": "39.80122000",
                "longitude": "-75.16240000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123280,
                "name": "Oakhurst",
                "latitude": "40.27094000",
                "longitude": "-74.01625000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123290,
                "name": "Oakland",
                "latitude": "41.01315000",
                "longitude": "-74.26431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123301,
                "name": "Oaklyn",
                "latitude": "39.90095000",
                "longitude": "-75.08462000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123323,
                "name": "Ocean Acres",
                "latitude": "39.74345000",
                "longitude": "-74.28098000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123327,
                "name": "Ocean City",
                "latitude": "39.27762000",
                "longitude": "-74.57460000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123328,
                "name": "Ocean County",
                "latitude": "39.86600000",
                "longitude": "-74.25003000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123329,
                "name": "Ocean Gate",
                "latitude": "39.92679000",
                "longitude": "-74.13375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123331,
                "name": "Ocean Grove",
                "latitude": "40.21206000",
                "longitude": "-74.00653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123342,
                "name": "Oceanport",
                "latitude": "40.31817000",
                "longitude": "-74.01514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123371,
                "name": "Ogdensburg",
                "latitude": "41.08176000",
                "longitude": "-74.59238000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123416,
                "name": "Old Bridge",
                "latitude": "40.41483000",
                "longitude": "-74.36543000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123429,
                "name": "Old Tappan",
                "latitude": "41.01065000",
                "longitude": "-73.99125000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123445,
                "name": "Olivet",
                "latitude": "39.54817000",
                "longitude": "-75.15463000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123503,
                "name": "Oradell",
                "latitude": "40.95871000",
                "longitude": "-74.03681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123509,
                "name": "Orange",
                "latitude": "40.77066000",
                "longitude": "-74.23265000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123686,
                "name": "Oxford",
                "latitude": "40.80315000",
                "longitude": "-74.98962000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123739,
                "name": "Palisades Park",
                "latitude": "40.84816000",
                "longitude": "-73.99764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123775,
                "name": "Palmyra",
                "latitude": "40.00706000",
                "longitude": "-75.02823000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123826,
                "name": "Paramus",
                "latitude": "40.94454000",
                "longitude": "-74.07542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123852,
                "name": "Park Ridge",
                "latitude": "41.03760000",
                "longitude": "-74.04070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123890,
                "name": "Parsippany",
                "latitude": "40.85788000",
                "longitude": "-74.42599000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123907,
                "name": "Passaic",
                "latitude": "40.85677000",
                "longitude": "-74.12848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123908,
                "name": "Passaic County",
                "latitude": "41.03370000",
                "longitude": "-74.30032000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123911,
                "name": "Paterson",
                "latitude": "40.91677000",
                "longitude": "-74.17181000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123926,
                "name": "Paulsboro",
                "latitude": "39.83039000",
                "longitude": "-75.24046000",
                "timezone": "America\/New_York"
            },
            {
                "id": 123961,
                "name": "Peapack",
                "latitude": "40.71677000",
                "longitude": "-74.65655000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124000,
                "name": "Pemberton",
                "latitude": "39.97206000",
                "longitude": "-74.68294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124001,
                "name": "Pemberton Heights",
                "latitude": "39.96261000",
                "longitude": "-74.67877000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124029,
                "name": "Pennington",
                "latitude": "40.32844000",
                "longitude": "-74.79072000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124033,
                "name": "Penns Grove",
                "latitude": "39.72956000",
                "longitude": "-75.46797000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124034,
                "name": "Pennsauken",
                "latitude": "39.95622000",
                "longitude": "-75.05795000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124039,
                "name": "Pennsville",
                "latitude": "39.65345000",
                "longitude": "-75.51659000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124094,
                "name": "Perth Amboy",
                "latitude": "40.50677000",
                "longitude": "-74.26542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124140,
                "name": "Phillipsburg",
                "latitude": "40.69371000",
                "longitude": "-75.19018000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124213,
                "name": "Pine Beach",
                "latitude": "39.93595000",
                "longitude": "-74.17097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124224,
                "name": "Pine Hill",
                "latitude": "39.78428000",
                "longitude": "-74.99211000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124233,
                "name": "Pine Lake Park",
                "latitude": "40.00317000",
                "longitude": "-74.25653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124245,
                "name": "Pine Ridge at Crestwood",
                "latitude": "39.95456000",
                "longitude": "-74.31515000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124282,
                "name": "Piscataway",
                "latitude": "40.49927000",
                "longitude": "-74.39904000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124287,
                "name": "Pitman",
                "latitude": "39.73289000",
                "longitude": "-75.13157000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124321,
                "name": "Plainfield",
                "latitude": "40.63371000",
                "longitude": "-74.40737000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124327,
                "name": "Plainsboro Center",
                "latitude": "40.33177000",
                "longitude": "-74.59460000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124386,
                "name": "Pleasantville",
                "latitude": "39.38984000",
                "longitude": "-74.52404000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124431,
                "name": "Point Pleasant",
                "latitude": "40.08317000",
                "longitude": "-74.06819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124432,
                "name": "Point Pleasant Beach",
                "latitude": "40.09123000",
                "longitude": "-74.04791000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124457,
                "name": "Pomona",
                "latitude": "39.47845000",
                "longitude": "-74.57516000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124462,
                "name": "Pompton Lakes",
                "latitude": "41.00538000",
                "longitude": "-74.29070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124519,
                "name": "Port Monmouth",
                "latitude": "40.43011000",
                "longitude": "-74.09847000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124522,
                "name": "Port Norris",
                "latitude": "39.24595000",
                "longitude": "-75.03518000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124527,
                "name": "Port Reading",
                "latitude": "40.56538000",
                "longitude": "-74.26042000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124528,
                "name": "Port Republic",
                "latitude": "39.52067000",
                "longitude": "-74.48571000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124646,
                "name": "Presidential Lakes Estates",
                "latitude": "39.91373000",
                "longitude": "-74.56460000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124689,
                "name": "Princeton",
                "latitude": "40.34872000",
                "longitude": "-74.65905000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124692,
                "name": "Princeton Junction",
                "latitude": "40.31733000",
                "longitude": "-74.61988000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124693,
                "name": "Princeton Meadows",
                "latitude": "40.33177000",
                "longitude": "-74.56377000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124710,
                "name": "Prospect Park",
                "latitude": "40.93704000",
                "longitude": "-74.17431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124822,
                "name": "Rahway",
                "latitude": "40.60816000",
                "longitude": "-74.27765000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124837,
                "name": "Ramblewood",
                "latitude": "39.92872000",
                "longitude": "-74.94378000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124842,
                "name": "Ramsey",
                "latitude": "41.05732000",
                "longitude": "-74.14098000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124845,
                "name": "Ramtown",
                "latitude": "40.12095000",
                "longitude": "-74.14375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124871,
                "name": "Randolph",
                "latitude": "40.84829000",
                "longitude": "-74.58148000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124899,
                "name": "Raritan",
                "latitude": "40.56955000",
                "longitude": "-74.63294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 124938,
                "name": "Red Bank",
                "latitude": "40.34705000",
                "longitude": "-74.06431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125110,
                "name": "Richwood",
                "latitude": "39.72261000",
                "longitude": "-75.16546000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125120,
                "name": "Ridgefield",
                "latitude": "40.83427000",
                "longitude": "-74.00875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125122,
                "name": "Ridgefield Park",
                "latitude": "40.85704000",
                "longitude": "-74.02153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125131,
                "name": "Ridgewood",
                "latitude": "40.97926000",
                "longitude": "-74.11653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125145,
                "name": "Ringwood",
                "latitude": "41.11343000",
                "longitude": "-74.24543000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125153,
                "name": "Rio Grande",
                "latitude": "39.01456000",
                "longitude": "-74.88156000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125177,
                "name": "River Edge",
                "latitude": "40.92871000",
                "longitude": "-74.03986000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125188,
                "name": "River Vale",
                "latitude": "40.99538000",
                "longitude": "-74.01208000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125194,
                "name": "Riverdale",
                "latitude": "40.99399000",
                "longitude": "-74.30348000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125212,
                "name": "Riverton",
                "latitude": "40.01150000",
                "longitude": "-75.01489000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125238,
                "name": "Robbinsville",
                "latitude": "40.21455000",
                "longitude": "-74.61932000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125248,
                "name": "Robertsville",
                "latitude": "40.34622000",
                "longitude": "-74.28792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125260,
                "name": "Rochelle Park",
                "latitude": "40.90732000",
                "longitude": "-74.07514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125289,
                "name": "Rockaway",
                "latitude": "40.90121000",
                "longitude": "-74.51432000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125343,
                "name": "Roebling",
                "latitude": "40.11594000",
                "longitude": "-74.78627000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125423,
                "name": "Roseland",
                "latitude": "40.82066000",
                "longitude": "-74.29376000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125427,
                "name": "Roselle",
                "latitude": "40.65223000",
                "longitude": "-74.25882000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125428,
                "name": "Roselle Park",
                "latitude": "40.66455000",
                "longitude": "-74.26431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125436,
                "name": "Rosenhayn",
                "latitude": "39.47817000",
                "longitude": "-75.13129000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125454,
                "name": "Rossmoor",
                "latitude": "40.33650000",
                "longitude": "-74.47349000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125509,
                "name": "Rumson",
                "latitude": "40.37205000",
                "longitude": "-73.99903000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125513,
                "name": "Runnemede",
                "latitude": "39.85234000",
                "longitude": "-75.06795000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125549,
                "name": "Rutherford",
                "latitude": "40.82649000",
                "longitude": "-74.10681000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125579,
                "name": "Saddle Brook",
                "latitude": "40.89899000",
                "longitude": "-74.09264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125581,
                "name": "Saddle River",
                "latitude": "41.03176000",
                "longitude": "-74.10209000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125729,
                "name": "Salem",
                "latitude": "39.57178000",
                "longitude": "-75.46714000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125741,
                "name": "Salem County",
                "latitude": "39.57658000",
                "longitude": "-75.35791000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125991,
                "name": "Sayreville",
                "latitude": "40.45927000",
                "longitude": "-74.36098000",
                "timezone": "America\/New_York"
            },
            {
                "id": 125992,
                "name": "Sayreville Junction",
                "latitude": "40.46538000",
                "longitude": "-74.33043000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126032,
                "name": "Scotch Plains",
                "latitude": "40.65538000",
                "longitude": "-74.38987000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126071,
                "name": "Sea Bright",
                "latitude": "40.36150000",
                "longitude": "-73.97403000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126073,
                "name": "Sea Girt",
                "latitude": "40.13206000",
                "longitude": "-74.03458000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126074,
                "name": "Sea Isle City",
                "latitude": "39.15345000",
                "longitude": "-74.69294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126081,
                "name": "Seabrook Farms",
                "latitude": "39.50095000",
                "longitude": "-75.21796000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126101,
                "name": "Seaside Heights",
                "latitude": "39.94429000",
                "longitude": "-74.07291000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126102,
                "name": "Seaside Park",
                "latitude": "39.92679000",
                "longitude": "-74.07708000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126112,
                "name": "Secaucus",
                "latitude": "40.78955000",
                "longitude": "-74.05653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126190,
                "name": "Sewaren",
                "latitude": "40.55205000",
                "longitude": "-74.25876000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126225,
                "name": "Shark River Hills",
                "latitude": "40.19400000",
                "longitude": "-74.04875000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126356,
                "name": "Ship Bottom",
                "latitude": "39.64290000",
                "longitude": "-74.18042000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126376,
                "name": "Short Hills",
                "latitude": "40.74788000",
                "longitude": "-74.32543000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126386,
                "name": "Shrewsbury",
                "latitude": "40.32955000",
                "longitude": "-74.06153000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126393,
                "name": "Sicklerville",
                "latitude": "39.71734000",
                "longitude": "-74.96933000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126433,
                "name": "Silver Ridge",
                "latitude": "39.95928000",
                "longitude": "-74.21848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126454,
                "name": "Singac",
                "latitude": "40.88677000",
                "longitude": "-74.24098000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126473,
                "name": "Sixmile Run",
                "latitude": "40.45761000",
                "longitude": "-74.51154000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126527,
                "name": "Smithville",
                "latitude": "39.49401000",
                "longitude": "-74.45709000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126556,
                "name": "Society Hill",
                "latitude": "40.53399000",
                "longitude": "-74.45793000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126574,
                "name": "Somerdale",
                "latitude": "39.84400000",
                "longitude": "-75.02267000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126578,
                "name": "Somers Point",
                "latitude": "39.31762000",
                "longitude": "-74.59460000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126583,
                "name": "Somerset",
                "latitude": "40.49760000",
                "longitude": "-74.48849000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126588,
                "name": "Somerset County",
                "latitude": "40.56351000",
                "longitude": "-74.61631000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126596,
                "name": "Somerville",
                "latitude": "40.57427000",
                "longitude": "-74.60988000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126612,
                "name": "South Amboy",
                "latitude": "40.47788000",
                "longitude": "-74.29070000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126622,
                "name": "South Belmar",
                "latitude": "40.17095000",
                "longitude": "-74.02736000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126630,
                "name": "South Bound Brook",
                "latitude": "40.55344000",
                "longitude": "-74.53154000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126697,
                "name": "South Old Bridge",
                "latitude": "40.40816000",
                "longitude": "-74.35432000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126698,
                "name": "South Orange",
                "latitude": "40.74899000",
                "longitude": "-74.26126000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126711,
                "name": "South Plainfield",
                "latitude": "40.57927000",
                "longitude": "-74.41154000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126717,
                "name": "South River",
                "latitude": "40.44649000",
                "longitude": "-74.38598000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126736,
                "name": "South Toms River",
                "latitude": "39.94206000",
                "longitude": "-74.20431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126743,
                "name": "South Vineland",
                "latitude": "39.44595000",
                "longitude": "-75.02879000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126812,
                "name": "Sparta",
                "latitude": "41.03343000",
                "longitude": "-74.63849000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126846,
                "name": "Spotswood",
                "latitude": "40.39177000",
                "longitude": "-74.39848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126867,
                "name": "Spring Lake",
                "latitude": "40.15345000",
                "longitude": "-74.02819000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126868,
                "name": "Spring Lake Heights",
                "latitude": "40.15039000",
                "longitude": "-74.03097000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126885,
                "name": "Springdale",
                "latitude": "39.90261000",
                "longitude": "-74.96628000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126900,
                "name": "Springfield",
                "latitude": "40.70491000",
                "longitude": "-74.31723000",
                "timezone": "America\/New_York"
            },
            {
                "id": 126956,
                "name": "Stanhope",
                "latitude": "40.90288000",
                "longitude": "-74.70905000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127122,
                "name": "Stratford",
                "latitude": "39.82678000",
                "longitude": "-75.01545000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127130,
                "name": "Strathmore",
                "latitude": "40.39594000",
                "longitude": "-74.21348000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127160,
                "name": "Succasunna",
                "latitude": "40.86843000",
                "longitude": "-74.64044000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127213,
                "name": "Summit",
                "latitude": "40.71562000",
                "longitude": "-74.36468000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127286,
                "name": "Surf City",
                "latitude": "39.66206000",
                "longitude": "-74.16514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127301,
                "name": "Sussex",
                "latitude": "41.20982000",
                "longitude": "-74.60766000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127305,
                "name": "Sussex County",
                "latitude": "41.13946000",
                "longitude": "-74.69023000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127334,
                "name": "Swedesboro",
                "latitude": "39.74761000",
                "longitude": "-75.31047000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127475,
                "name": "Teaneck",
                "latitude": "40.89760000",
                "longitude": "-74.01597000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127506,
                "name": "Ten Mile Run",
                "latitude": "40.41301000",
                "longitude": "-74.60223000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127507,
                "name": "Tenafly",
                "latitude": "40.92538000",
                "longitude": "-73.96292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127667,
                "name": "Tinton Falls",
                "latitude": "40.30428000",
                "longitude": "-74.10042000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127716,
                "name": "Toms River",
                "latitude": "39.95373000",
                "longitude": "-74.19792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127747,
                "name": "Totowa",
                "latitude": "40.90510000",
                "longitude": "-74.20987000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127808,
                "name": "Trenton",
                "latitude": "40.21705000",
                "longitude": "-74.74294000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127873,
                "name": "Tuckerton",
                "latitude": "39.60317000",
                "longitude": "-74.34015000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127906,
                "name": "Turnersville",
                "latitude": "39.77317000",
                "longitude": "-75.05128000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127934,
                "name": "Twin Rivers",
                "latitude": "40.26400000",
                "longitude": "-74.49126000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127977,
                "name": "Union",
                "latitude": "40.69760000",
                "longitude": "-74.26320000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127979,
                "name": "Union Beach",
                "latitude": "40.44650000",
                "longitude": "-74.17820000",
                "timezone": "America\/New_York"
            },
            {
                "id": 127999,
                "name": "Union County",
                "latitude": "40.65980000",
                "longitude": "-74.30859000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128047,
                "name": "Upper Montclair",
                "latitude": "40.84621000",
                "longitude": "-74.20126000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128049,
                "name": "Upper Pohatcong",
                "latitude": "40.67747000",
                "longitude": "-75.15580000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128050,
                "name": "Upper Saddle River",
                "latitude": "41.05843000",
                "longitude": "-74.09848000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128174,
                "name": "Ventnor City",
                "latitude": "39.34039000",
                "longitude": "-74.47737000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128191,
                "name": "Vernon Center",
                "latitude": "41.18879000",
                "longitude": "-74.50405000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128196,
                "name": "Vernon Valley",
                "latitude": "41.23676000",
                "longitude": "-74.48710000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128203,
                "name": "Verona",
                "latitude": "40.82982000",
                "longitude": "-74.24015000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128225,
                "name": "Victory Gardens",
                "latitude": "40.87593000",
                "longitude": "-74.54238000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128226,
                "name": "Victory Lakes",
                "latitude": "39.63317000",
                "longitude": "-74.96600000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128258,
                "name": "Villas",
                "latitude": "39.02872000",
                "longitude": "-74.93851000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128266,
                "name": "Vincentown",
                "latitude": "39.93400000",
                "longitude": "-74.74849000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128270,
                "name": "Vineland",
                "latitude": "39.48623000",
                "longitude": "-75.02573000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128296,
                "name": "Vista Center",
                "latitude": "40.15928000",
                "longitude": "-74.31792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128306,
                "name": "Voorhees",
                "latitude": "40.48122000",
                "longitude": "-74.48321000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128378,
                "name": "Waldwick",
                "latitude": "41.01065000",
                "longitude": "-74.11792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128408,
                "name": "Wallington",
                "latitude": "40.85316000",
                "longitude": "-74.11375000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128447,
                "name": "Wanamassa",
                "latitude": "40.23178000",
                "longitude": "-74.02542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128449,
                "name": "Wanaque",
                "latitude": "41.03815000",
                "longitude": "-74.29404000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128466,
                "name": "Waretown",
                "latitude": "39.79151000",
                "longitude": "-74.19514000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128496,
                "name": "Warren County",
                "latitude": "40.85725000",
                "longitude": "-74.99702000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128500,
                "name": "Warren Township",
                "latitude": "40.60822000",
                "longitude": "-74.51803000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128548,
                "name": "Washington",
                "latitude": "40.75843000",
                "longitude": "-74.97934000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128598,
                "name": "Watchung",
                "latitude": "40.63788000",
                "longitude": "-74.45099000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128685,
                "name": "Wayne",
                "latitude": "40.92538000",
                "longitude": "-74.27654000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128754,
                "name": "Weehawken",
                "latitude": "40.76955000",
                "longitude": "-74.02042000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128803,
                "name": "Wenonah",
                "latitude": "39.79456000",
                "longitude": "-75.14879000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128824,
                "name": "West Belmar",
                "latitude": "40.16928000",
                "longitude": "-74.03542000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128840,
                "name": "West Cape May",
                "latitude": "38.93872000",
                "longitude": "-74.94184000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128874,
                "name": "West Freehold",
                "latitude": "40.24206000",
                "longitude": "-74.30126000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128922,
                "name": "West Long Branch",
                "latitude": "40.29039000",
                "longitude": "-74.01764000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128932,
                "name": "West Milford",
                "latitude": "41.13121000",
                "longitude": "-74.36737000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128938,
                "name": "West New York",
                "latitude": "40.78788000",
                "longitude": "-74.01431000",
                "timezone": "America\/New_York"
            },
            {
                "id": 128946,
                "name": "West Orange",
                "latitude": "40.79871000",
                "longitude": "-74.23904000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129029,
                "name": "Westfield",
                "latitude": "40.65899000",
                "longitude": "-74.34737000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129062,
                "name": "Weston",
                "latitude": "40.53510000",
                "longitude": "-74.59071000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129076,
                "name": "Westville",
                "latitude": "39.86789000",
                "longitude": "-75.13156000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129086,
                "name": "Westwood",
                "latitude": "40.99121000",
                "longitude": "-74.03264000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129103,
                "name": "Wharton",
                "latitude": "40.89315000",
                "longitude": "-74.58183000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129142,
                "name": "White Horse",
                "latitude": "40.19067000",
                "longitude": "-74.70238000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129146,
                "name": "White Meadow Lake",
                "latitude": "40.92371000",
                "longitude": "-74.51071000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129175,
                "name": "Whitehouse Station",
                "latitude": "40.61538000",
                "longitude": "-74.77044000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129181,
                "name": "Whitesboro",
                "latitude": "39.03900000",
                "longitude": "-74.85684000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129184,
                "name": "Whitesboro-Burleigh",
                "latitude": "39.04305000",
                "longitude": "-74.86538000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129211,
                "name": "Whittingham",
                "latitude": "40.32982000",
                "longitude": "-74.44511000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129238,
                "name": "Wildwood",
                "latitude": "38.99178000",
                "longitude": "-74.81489000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129241,
                "name": "Wildwood Crest",
                "latitude": "38.97484000",
                "longitude": "-74.83350000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129286,
                "name": "Williamstown",
                "latitude": "39.68623000",
                "longitude": "-74.99517000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129294,
                "name": "Willingboro",
                "latitude": "40.02789000",
                "longitude": "-74.86905000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129399,
                "name": "Winfield",
                "latitude": "40.64260000",
                "longitude": "-74.28543000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129491,
                "name": "Wood-Lynne",
                "latitude": "39.91734000",
                "longitude": "-75.09629000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129492,
                "name": "Wood-Ridge",
                "latitude": "40.84566000",
                "longitude": "-74.08792000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129495,
                "name": "Woodbine",
                "latitude": "39.24178000",
                "longitude": "-74.81517000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129501,
                "name": "Woodbridge",
                "latitude": "40.55760000",
                "longitude": "-74.28459000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129506,
                "name": "Woodbury",
                "latitude": "39.83817000",
                "longitude": "-75.15268000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129513,
                "name": "Woodbury Heights",
                "latitude": "39.81706000",
                "longitude": "-75.15518000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129514,
                "name": "Woodcliff Lake",
                "latitude": "41.02343000",
                "longitude": "-74.06653000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129532,
                "name": "Woodland Park",
                "latitude": "40.88982000",
                "longitude": "-74.19487000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129568,
                "name": "Woodstown",
                "latitude": "39.65150000",
                "longitude": "-75.32825000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129623,
                "name": "Wyckoff",
                "latitude": "41.00954000",
                "longitude": "-74.17292000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129665,
                "name": "Yardville",
                "latitude": "40.18122000",
                "longitude": "-74.66432000",
                "timezone": "America\/New_York"
            },
            {
                "id": 129701,
                "name": "Yorketown",
                "latitude": "40.30789000",
                "longitude": "-74.33765000",
                "timezone": "America\/New_York"
            }
        ]
    }
]

export const statesData = [
    { label: "Alaska", value: "alaska" },
    { label: "Alabama", value: "alabama" },
    { label: "Arkansas", value: "arkansas" },
    { label: "Arizona", value: "arizona" },
    { label: "California", value: "california" },
    { label: "Colorado", value: "colorado" },
    { label: "Connecticut", value: "connecticut" },
    { label: "District of Columbia", value: "district of columbia" },
    { label: "Delaware", value: "delaware" },
    { label: "Florida", value: "florida" },
    { label: "Georgia", value: "georgia" },
    { label: "Hawaii", value: "hawaii" },
    { label: "Iowa", value: "iowa" },
    { label: "Idaho", value: "idaho" },
    { label: "Illinois", value: "illinois" },
    { label: "Indiana", value: "indiana" },
    { label: "Kansas", value: "kansas" },
    { label: "Kentucky", value: "kentucky" },
    { label: "Louisiana", value: "louisiana" },
    { label: "Massachusetts", value: "massachusetts" },
    { label: "Maryland", value: "maryland" },
    { label: "Maine", value: "maine" },
    { label: "Michigan", value: "michigan" },
    { label: "Minnesota", value: "minnesota" },
    { label: "Missouri", value: "missouri" },
    { label: "Mississippi", value: "mississippi" },
    { label: "Montana", value: "montana" },
    { label: "North Carolina", value: "north carolina" },
    { label: "North Dakota", value: "north dakota" },
    { label: "Nebraska", value: "nebraska" },
    { label: "New Hampshire", value: "new hampshire" },
    { label: "New Jersey", value: "new jersey" },
    { label: "New Mexico", value: "new mexico" },
    { label: "Nevada", value: "nevada" },
    { label: "New York", value: "new york" },
    { label: "Ohio", value: "ohio" },
    { label: "Oklahoma", value: "oklahoma" },
    { label: "Oregon", value: "oregon" },
    { label: "Pennsylvania", value: "pennsylvania" },
    { label: "Rhode Island", value: "rhode island" },
    { label: "South Carolina", value: "south carolina" },
    { label: "South Dakota", value: "south dakota" },
    { label: "Tennessee", value: "tennessee" },
    { label: "Texas", value: "texas" },
    { label: "Utah", value: "utah" },
    { label: "Virginia", value: "virginia" },
    { label: "Vermont", value: "vermont" },
    { label: "Washington", value: "washington" },
    { label: "Wisconsin", value: "wisconsin" },
    { label: "West Virginia", value: "west virginia" },
    { label: "Wyoming", value: "wyoming" },
]; 